/*eslint-disable block-scoped-var, id-length, no-control-regex, no-magic-numbers, no-prototype-builtins, no-redeclare, no-shadow, no-var, sort-vars*/
"use strict";

var $protobuf = require("protobufjs/minimal");

// Common aliases
var $Reader = $protobuf.Reader, $Writer = $protobuf.Writer, $util = $protobuf.util;

// Exported root namespace
var $root = $protobuf.roots["default"] || ($protobuf.roots["default"] = {});

$root.Q2Game = (function() {

    /**
     * Namespace Q2Game.
     * @exports Q2Game
     * @namespace
     */
    var Q2Game = {};

    Q2Game.CardPattern = (function() {

        /**
         * Properties of a CardPattern.
         * @memberof Q2Game
         * @interface ICardPattern
         * @property {Array.<number>|null} [cards] CardPattern cards
         * @property {number|null} [zone] CardPattern zone
         * @property {number|null} [type] CardPattern type
         * @property {Array.<number>|null} [origCards] CardPattern origCards
         * @property {number|null} [origOp] CardPattern origOp
         */

        /**
         * Constructs a new CardPattern.
         * @memberof Q2Game
         * @classdesc Represents a CardPattern.
         * @implements ICardPattern
         * @constructor
         * @param {Q2Game.ICardPattern=} [properties] Properties to set
         */
        function CardPattern(properties) {
            this.cards = [];
            this.origCards = [];
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * CardPattern cards.
         * @member {Array.<number>} cards
         * @memberof Q2Game.CardPattern
         * @instance
         */
        CardPattern.prototype.cards = $util.emptyArray;

        /**
         * CardPattern zone.
         * @member {number} zone
         * @memberof Q2Game.CardPattern
         * @instance
         */
        CardPattern.prototype.zone = 0;

        /**
         * CardPattern type.
         * @member {number} type
         * @memberof Q2Game.CardPattern
         * @instance
         */
        CardPattern.prototype.type = 0;

        /**
         * CardPattern origCards.
         * @member {Array.<number>} origCards
         * @memberof Q2Game.CardPattern
         * @instance
         */
        CardPattern.prototype.origCards = $util.emptyArray;

        /**
         * CardPattern origOp.
         * @member {number} origOp
         * @memberof Q2Game.CardPattern
         * @instance
         */
        CardPattern.prototype.origOp = 0;

        /**
         * Creates a new CardPattern instance using the specified properties.
         * @function create
         * @memberof Q2Game.CardPattern
         * @static
         * @param {Q2Game.ICardPattern=} [properties] Properties to set
         * @returns {Q2Game.CardPattern} CardPattern instance
         */
        CardPattern.create = function create(properties) {
            return new CardPattern(properties);
        };

        /**
         * Encodes the specified CardPattern message. Does not implicitly {@link Q2Game.CardPattern.verify|verify} messages.
         * @function encode
         * @memberof Q2Game.CardPattern
         * @static
         * @param {Q2Game.ICardPattern} message CardPattern message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        CardPattern.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.cards != null && message.cards.length)
                for (var i = 0; i < message.cards.length; ++i)
                    writer.uint32(/* id 1, wireType 0 =*/8).int32(message.cards[i]);
            if (message.zone != null && message.hasOwnProperty("zone"))
                writer.uint32(/* id 2, wireType 0 =*/16).int32(message.zone);
            if (message.type != null && message.hasOwnProperty("type"))
                writer.uint32(/* id 3, wireType 0 =*/24).int32(message.type);
            if (message.origCards != null && message.origCards.length)
                for (var i = 0; i < message.origCards.length; ++i)
                    writer.uint32(/* id 4, wireType 0 =*/32).int32(message.origCards[i]);
            if (message.origOp != null && message.hasOwnProperty("origOp"))
                writer.uint32(/* id 5, wireType 0 =*/40).int32(message.origOp);
            return writer;
        };

        /**
         * Encodes the specified CardPattern message, length delimited. Does not implicitly {@link Q2Game.CardPattern.verify|verify} messages.
         * @function encodeDelimited
         * @memberof Q2Game.CardPattern
         * @static
         * @param {Q2Game.ICardPattern} message CardPattern message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        CardPattern.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a CardPattern message from the specified reader or buffer.
         * @function decode
         * @memberof Q2Game.CardPattern
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {Q2Game.CardPattern} CardPattern
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        CardPattern.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.Q2Game.CardPattern();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    if (!(message.cards && message.cards.length))
                        message.cards = [];
                    if ((tag & 7) === 2) {
                        var end2 = reader.uint32() + reader.pos;
                        while (reader.pos < end2)
                            message.cards.push(reader.int32());
                    } else
                        message.cards.push(reader.int32());
                    break;
                case 2:
                    message.zone = reader.int32();
                    break;
                case 3:
                    message.type = reader.int32();
                    break;
                case 4:
                    if (!(message.origCards && message.origCards.length))
                        message.origCards = [];
                    if ((tag & 7) === 2) {
                        var end2 = reader.uint32() + reader.pos;
                        while (reader.pos < end2)
                            message.origCards.push(reader.int32());
                    } else
                        message.origCards.push(reader.int32());
                    break;
                case 5:
                    message.origOp = reader.int32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a CardPattern message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof Q2Game.CardPattern
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {Q2Game.CardPattern} CardPattern
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        CardPattern.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a CardPattern message.
         * @function verify
         * @memberof Q2Game.CardPattern
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        CardPattern.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.cards != null && message.hasOwnProperty("cards")) {
                if (!Array.isArray(message.cards))
                    return "cards: array expected";
                for (var i = 0; i < message.cards.length; ++i)
                    if (!$util.isInteger(message.cards[i]))
                        return "cards: integer[] expected";
            }
            if (message.zone != null && message.hasOwnProperty("zone"))
                if (!$util.isInteger(message.zone))
                    return "zone: integer expected";
            if (message.type != null && message.hasOwnProperty("type"))
                if (!$util.isInteger(message.type))
                    return "type: integer expected";
            if (message.origCards != null && message.hasOwnProperty("origCards")) {
                if (!Array.isArray(message.origCards))
                    return "origCards: array expected";
                for (var i = 0; i < message.origCards.length; ++i)
                    if (!$util.isInteger(message.origCards[i]))
                        return "origCards: integer[] expected";
            }
            if (message.origOp != null && message.hasOwnProperty("origOp"))
                if (!$util.isInteger(message.origOp))
                    return "origOp: integer expected";
            return null;
        };

        /**
         * Creates a CardPattern message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof Q2Game.CardPattern
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {Q2Game.CardPattern} CardPattern
         */
        CardPattern.fromObject = function fromObject(object) {
            if (object instanceof $root.Q2Game.CardPattern)
                return object;
            var message = new $root.Q2Game.CardPattern();
            if (object.cards) {
                if (!Array.isArray(object.cards))
                    throw TypeError(".Q2Game.CardPattern.cards: array expected");
                message.cards = [];
                for (var i = 0; i < object.cards.length; ++i)
                    message.cards[i] = object.cards[i] | 0;
            }
            if (object.zone != null)
                message.zone = object.zone | 0;
            if (object.type != null)
                message.type = object.type | 0;
            if (object.origCards) {
                if (!Array.isArray(object.origCards))
                    throw TypeError(".Q2Game.CardPattern.origCards: array expected");
                message.origCards = [];
                for (var i = 0; i < object.origCards.length; ++i)
                    message.origCards[i] = object.origCards[i] | 0;
            }
            if (object.origOp != null)
                message.origOp = object.origOp | 0;
            return message;
        };

        /**
         * Creates a plain object from a CardPattern message. Also converts values to other types if specified.
         * @function toObject
         * @memberof Q2Game.CardPattern
         * @static
         * @param {Q2Game.CardPattern} message CardPattern
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        CardPattern.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.arrays || options.defaults) {
                object.cards = [];
                object.origCards = [];
            }
            if (options.defaults) {
                object.zone = 0;
                object.type = 0;
                object.origOp = 0;
            }
            if (message.cards && message.cards.length) {
                object.cards = [];
                for (var j = 0; j < message.cards.length; ++j)
                    object.cards[j] = message.cards[j];
            }
            if (message.zone != null && message.hasOwnProperty("zone"))
                object.zone = message.zone;
            if (message.type != null && message.hasOwnProperty("type"))
                object.type = message.type;
            if (message.origCards && message.origCards.length) {
                object.origCards = [];
                for (var j = 0; j < message.origCards.length; ++j)
                    object.origCards[j] = message.origCards[j];
            }
            if (message.origOp != null && message.hasOwnProperty("origOp"))
                object.origOp = message.origOp;
            return object;
        };

        /**
         * Converts this CardPattern to JSON.
         * @function toJSON
         * @memberof Q2Game.CardPattern
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        CardPattern.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return CardPattern;
    })();

    Q2Game.CompleteInfo = (function() {

        /**
         * Properties of a CompleteInfo.
         * @memberof Q2Game
         * @interface ICompleteInfo
         * @property {boolean|null} [canComplete] CompleteInfo canComplete
         * @property {Array.<Q2Game.ICardPattern>|null} [opList] CompleteInfo opList
         */

        /**
         * Constructs a new CompleteInfo.
         * @memberof Q2Game
         * @classdesc Represents a CompleteInfo.
         * @implements ICompleteInfo
         * @constructor
         * @param {Q2Game.ICompleteInfo=} [properties] Properties to set
         */
        function CompleteInfo(properties) {
            this.opList = [];
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * CompleteInfo canComplete.
         * @member {boolean} canComplete
         * @memberof Q2Game.CompleteInfo
         * @instance
         */
        CompleteInfo.prototype.canComplete = false;

        /**
         * CompleteInfo opList.
         * @member {Array.<Q2Game.ICardPattern>} opList
         * @memberof Q2Game.CompleteInfo
         * @instance
         */
        CompleteInfo.prototype.opList = $util.emptyArray;

        /**
         * Creates a new CompleteInfo instance using the specified properties.
         * @function create
         * @memberof Q2Game.CompleteInfo
         * @static
         * @param {Q2Game.ICompleteInfo=} [properties] Properties to set
         * @returns {Q2Game.CompleteInfo} CompleteInfo instance
         */
        CompleteInfo.create = function create(properties) {
            return new CompleteInfo(properties);
        };

        /**
         * Encodes the specified CompleteInfo message. Does not implicitly {@link Q2Game.CompleteInfo.verify|verify} messages.
         * @function encode
         * @memberof Q2Game.CompleteInfo
         * @static
         * @param {Q2Game.ICompleteInfo} message CompleteInfo message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        CompleteInfo.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.opList != null && message.opList.length)
                for (var i = 0; i < message.opList.length; ++i)
                    $root.Q2Game.CardPattern.encode(message.opList[i], writer.uint32(/* id 7, wireType 2 =*/58).fork()).ldelim();
            if (message.canComplete != null && message.hasOwnProperty("canComplete"))
                writer.uint32(/* id 9, wireType 0 =*/72).bool(message.canComplete);
            return writer;
        };

        /**
         * Encodes the specified CompleteInfo message, length delimited. Does not implicitly {@link Q2Game.CompleteInfo.verify|verify} messages.
         * @function encodeDelimited
         * @memberof Q2Game.CompleteInfo
         * @static
         * @param {Q2Game.ICompleteInfo} message CompleteInfo message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        CompleteInfo.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a CompleteInfo message from the specified reader or buffer.
         * @function decode
         * @memberof Q2Game.CompleteInfo
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {Q2Game.CompleteInfo} CompleteInfo
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        CompleteInfo.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.Q2Game.CompleteInfo();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 9:
                    message.canComplete = reader.bool();
                    break;
                case 7:
                    if (!(message.opList && message.opList.length))
                        message.opList = [];
                    message.opList.push($root.Q2Game.CardPattern.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a CompleteInfo message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof Q2Game.CompleteInfo
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {Q2Game.CompleteInfo} CompleteInfo
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        CompleteInfo.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a CompleteInfo message.
         * @function verify
         * @memberof Q2Game.CompleteInfo
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        CompleteInfo.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.canComplete != null && message.hasOwnProperty("canComplete"))
                if (typeof message.canComplete !== "boolean")
                    return "canComplete: boolean expected";
            if (message.opList != null && message.hasOwnProperty("opList")) {
                if (!Array.isArray(message.opList))
                    return "opList: array expected";
                for (var i = 0; i < message.opList.length; ++i) {
                    var error = $root.Q2Game.CardPattern.verify(message.opList[i]);
                    if (error)
                        return "opList." + error;
                }
            }
            return null;
        };

        /**
         * Creates a CompleteInfo message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof Q2Game.CompleteInfo
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {Q2Game.CompleteInfo} CompleteInfo
         */
        CompleteInfo.fromObject = function fromObject(object) {
            if (object instanceof $root.Q2Game.CompleteInfo)
                return object;
            var message = new $root.Q2Game.CompleteInfo();
            if (object.canComplete != null)
                message.canComplete = Boolean(object.canComplete);
            if (object.opList) {
                if (!Array.isArray(object.opList))
                    throw TypeError(".Q2Game.CompleteInfo.opList: array expected");
                message.opList = [];
                for (var i = 0; i < object.opList.length; ++i) {
                    if (typeof object.opList[i] !== "object")
                        throw TypeError(".Q2Game.CompleteInfo.opList: object expected");
                    message.opList[i] = $root.Q2Game.CardPattern.fromObject(object.opList[i]);
                }
            }
            return message;
        };

        /**
         * Creates a plain object from a CompleteInfo message. Also converts values to other types if specified.
         * @function toObject
         * @memberof Q2Game.CompleteInfo
         * @static
         * @param {Q2Game.CompleteInfo} message CompleteInfo
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        CompleteInfo.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.arrays || options.defaults)
                object.opList = [];
            if (options.defaults)
                object.canComplete = false;
            if (message.opList && message.opList.length) {
                object.opList = [];
                for (var j = 0; j < message.opList.length; ++j)
                    object.opList[j] = $root.Q2Game.CardPattern.toObject(message.opList[j], options);
            }
            if (message.canComplete != null && message.hasOwnProperty("canComplete"))
                object.canComplete = message.canComplete;
            return object;
        };

        /**
         * Converts this CompleteInfo to JSON.
         * @function toJSON
         * @memberof Q2Game.CompleteInfo
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        CompleteInfo.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return CompleteInfo;
    })();

    Q2Game.SeatInfo = (function() {

        /**
         * Properties of a SeatInfo.
         * @memberof Q2Game
         * @interface ISeatInfo
         * @property {number|null} [seatId] SeatInfo seatId
         * @property {number|null} [playerId] SeatInfo playerId
         * @property {Array.<number>|null} [cards] SeatInfo cards
         * @property {string|null} [userJson] SeatInfo userJson
         * @property {number|null} [scoreBalance] SeatInfo scoreBalance
         * @property {number|null} [coinBalance] SeatInfo coinBalance
         * @property {boolean|null} [canShowQ2] SeatInfo canShowQ2
         * @property {boolean|null} [showQ2] SeatInfo showQ2
         * @property {boolean|null} [isPlaying] SeatInfo isPlaying
         * @property {Q2Game.ICompleteInfo|null} [completeInfo] SeatInfo completeInfo
         * @property {Array.<Q2Game.ICardPattern>|null} [finishedList] SeatInfo finishedList
         * @property {Array.<Q2Game.ICardPattern>|null} [raisableList] SeatInfo raisableList
         * @property {Array.<Q2Game.ICardPattern>|null} [storableList] SeatInfo storableList
         * @property {Array.<Q2Game.ICardPattern>|null} [attachableList] SeatInfo attachableList
         */

        /**
         * Constructs a new SeatInfo.
         * @memberof Q2Game
         * @classdesc Represents a SeatInfo.
         * @implements ISeatInfo
         * @constructor
         * @param {Q2Game.ISeatInfo=} [properties] Properties to set
         */
        function SeatInfo(properties) {
            this.cards = [];
            this.finishedList = [];
            this.raisableList = [];
            this.storableList = [];
            this.attachableList = [];
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * SeatInfo seatId.
         * @member {number} seatId
         * @memberof Q2Game.SeatInfo
         * @instance
         */
        SeatInfo.prototype.seatId = 0;

        /**
         * SeatInfo playerId.
         * @member {number} playerId
         * @memberof Q2Game.SeatInfo
         * @instance
         */
        SeatInfo.prototype.playerId = 0;

        /**
         * SeatInfo cards.
         * @member {Array.<number>} cards
         * @memberof Q2Game.SeatInfo
         * @instance
         */
        SeatInfo.prototype.cards = $util.emptyArray;

        /**
         * SeatInfo userJson.
         * @member {string} userJson
         * @memberof Q2Game.SeatInfo
         * @instance
         */
        SeatInfo.prototype.userJson = "";

        /**
         * SeatInfo scoreBalance.
         * @member {number} scoreBalance
         * @memberof Q2Game.SeatInfo
         * @instance
         */
        SeatInfo.prototype.scoreBalance = 0;

        /**
         * SeatInfo coinBalance.
         * @member {number} coinBalance
         * @memberof Q2Game.SeatInfo
         * @instance
         */
        SeatInfo.prototype.coinBalance = 0;

        /**
         * SeatInfo canShowQ2.
         * @member {boolean} canShowQ2
         * @memberof Q2Game.SeatInfo
         * @instance
         */
        SeatInfo.prototype.canShowQ2 = false;

        /**
         * SeatInfo showQ2.
         * @member {boolean} showQ2
         * @memberof Q2Game.SeatInfo
         * @instance
         */
        SeatInfo.prototype.showQ2 = false;

        /**
         * SeatInfo isPlaying.
         * @member {boolean} isPlaying
         * @memberof Q2Game.SeatInfo
         * @instance
         */
        SeatInfo.prototype.isPlaying = false;

        /**
         * SeatInfo completeInfo.
         * @member {Q2Game.ICompleteInfo|null|undefined} completeInfo
         * @memberof Q2Game.SeatInfo
         * @instance
         */
        SeatInfo.prototype.completeInfo = null;

        /**
         * SeatInfo finishedList.
         * @member {Array.<Q2Game.ICardPattern>} finishedList
         * @memberof Q2Game.SeatInfo
         * @instance
         */
        SeatInfo.prototype.finishedList = $util.emptyArray;

        /**
         * SeatInfo raisableList.
         * @member {Array.<Q2Game.ICardPattern>} raisableList
         * @memberof Q2Game.SeatInfo
         * @instance
         */
        SeatInfo.prototype.raisableList = $util.emptyArray;

        /**
         * SeatInfo storableList.
         * @member {Array.<Q2Game.ICardPattern>} storableList
         * @memberof Q2Game.SeatInfo
         * @instance
         */
        SeatInfo.prototype.storableList = $util.emptyArray;

        /**
         * SeatInfo attachableList.
         * @member {Array.<Q2Game.ICardPattern>} attachableList
         * @memberof Q2Game.SeatInfo
         * @instance
         */
        SeatInfo.prototype.attachableList = $util.emptyArray;

        /**
         * Creates a new SeatInfo instance using the specified properties.
         * @function create
         * @memberof Q2Game.SeatInfo
         * @static
         * @param {Q2Game.ISeatInfo=} [properties] Properties to set
         * @returns {Q2Game.SeatInfo} SeatInfo instance
         */
        SeatInfo.create = function create(properties) {
            return new SeatInfo(properties);
        };

        /**
         * Encodes the specified SeatInfo message. Does not implicitly {@link Q2Game.SeatInfo.verify|verify} messages.
         * @function encode
         * @memberof Q2Game.SeatInfo
         * @static
         * @param {Q2Game.ISeatInfo} message SeatInfo message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        SeatInfo.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.seatId != null && message.hasOwnProperty("seatId"))
                writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.seatId);
            if (message.cards != null && message.cards.length)
                for (var i = 0; i < message.cards.length; ++i)
                    writer.uint32(/* id 2, wireType 0 =*/16).int32(message.cards[i]);
            if (message.playerId != null && message.hasOwnProperty("playerId"))
                writer.uint32(/* id 3, wireType 0 =*/24).int32(message.playerId);
            if (message.raisableList != null && message.raisableList.length)
                for (var i = 0; i < message.raisableList.length; ++i)
                    $root.Q2Game.CardPattern.encode(message.raisableList[i], writer.uint32(/* id 4, wireType 2 =*/34).fork()).ldelim();
            if (message.storableList != null && message.storableList.length)
                for (var i = 0; i < message.storableList.length; ++i)
                    $root.Q2Game.CardPattern.encode(message.storableList[i], writer.uint32(/* id 5, wireType 2 =*/42).fork()).ldelim();
            if (message.attachableList != null && message.attachableList.length)
                for (var i = 0; i < message.attachableList.length; ++i)
                    $root.Q2Game.CardPattern.encode(message.attachableList[i], writer.uint32(/* id 6, wireType 2 =*/50).fork()).ldelim();
            if (message.finishedList != null && message.finishedList.length)
                for (var i = 0; i < message.finishedList.length; ++i)
                    $root.Q2Game.CardPattern.encode(message.finishedList[i], writer.uint32(/* id 7, wireType 2 =*/58).fork()).ldelim();
            if (message.scoreBalance != null && message.hasOwnProperty("scoreBalance"))
                writer.uint32(/* id 8, wireType 0 =*/64).int32(message.scoreBalance);
            if (message.canShowQ2 != null && message.hasOwnProperty("canShowQ2"))
                writer.uint32(/* id 10, wireType 0 =*/80).bool(message.canShowQ2);
            if (message.showQ2 != null && message.hasOwnProperty("showQ2"))
                writer.uint32(/* id 11, wireType 0 =*/88).bool(message.showQ2);
            if (message.completeInfo != null && message.hasOwnProperty("completeInfo"))
                $root.Q2Game.CompleteInfo.encode(message.completeInfo, writer.uint32(/* id 12, wireType 2 =*/98).fork()).ldelim();
            if (message.userJson != null && message.hasOwnProperty("userJson"))
                writer.uint32(/* id 13, wireType 2 =*/106).string(message.userJson);
            if (message.isPlaying != null && message.hasOwnProperty("isPlaying"))
                writer.uint32(/* id 14, wireType 0 =*/112).bool(message.isPlaying);
            if (message.coinBalance != null && message.hasOwnProperty("coinBalance"))
                writer.uint32(/* id 16, wireType 1 =*/129).double(message.coinBalance);
            return writer;
        };

        /**
         * Encodes the specified SeatInfo message, length delimited. Does not implicitly {@link Q2Game.SeatInfo.verify|verify} messages.
         * @function encodeDelimited
         * @memberof Q2Game.SeatInfo
         * @static
         * @param {Q2Game.ISeatInfo} message SeatInfo message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        SeatInfo.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a SeatInfo message from the specified reader or buffer.
         * @function decode
         * @memberof Q2Game.SeatInfo
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {Q2Game.SeatInfo} SeatInfo
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        SeatInfo.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.Q2Game.SeatInfo();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.seatId = reader.uint32();
                    break;
                case 3:
                    message.playerId = reader.int32();
                    break;
                case 2:
                    if (!(message.cards && message.cards.length))
                        message.cards = [];
                    if ((tag & 7) === 2) {
                        var end2 = reader.uint32() + reader.pos;
                        while (reader.pos < end2)
                            message.cards.push(reader.int32());
                    } else
                        message.cards.push(reader.int32());
                    break;
                case 13:
                    message.userJson = reader.string();
                    break;
                case 8:
                    message.scoreBalance = reader.int32();
                    break;
                case 16:
                    message.coinBalance = reader.double();
                    break;
                case 10:
                    message.canShowQ2 = reader.bool();
                    break;
                case 11:
                    message.showQ2 = reader.bool();
                    break;
                case 14:
                    message.isPlaying = reader.bool();
                    break;
                case 12:
                    message.completeInfo = $root.Q2Game.CompleteInfo.decode(reader, reader.uint32());
                    break;
                case 7:
                    if (!(message.finishedList && message.finishedList.length))
                        message.finishedList = [];
                    message.finishedList.push($root.Q2Game.CardPattern.decode(reader, reader.uint32()));
                    break;
                case 4:
                    if (!(message.raisableList && message.raisableList.length))
                        message.raisableList = [];
                    message.raisableList.push($root.Q2Game.CardPattern.decode(reader, reader.uint32()));
                    break;
                case 5:
                    if (!(message.storableList && message.storableList.length))
                        message.storableList = [];
                    message.storableList.push($root.Q2Game.CardPattern.decode(reader, reader.uint32()));
                    break;
                case 6:
                    if (!(message.attachableList && message.attachableList.length))
                        message.attachableList = [];
                    message.attachableList.push($root.Q2Game.CardPattern.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a SeatInfo message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof Q2Game.SeatInfo
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {Q2Game.SeatInfo} SeatInfo
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        SeatInfo.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a SeatInfo message.
         * @function verify
         * @memberof Q2Game.SeatInfo
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        SeatInfo.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.seatId != null && message.hasOwnProperty("seatId"))
                if (!$util.isInteger(message.seatId))
                    return "seatId: integer expected";
            if (message.playerId != null && message.hasOwnProperty("playerId"))
                if (!$util.isInteger(message.playerId))
                    return "playerId: integer expected";
            if (message.cards != null && message.hasOwnProperty("cards")) {
                if (!Array.isArray(message.cards))
                    return "cards: array expected";
                for (var i = 0; i < message.cards.length; ++i)
                    if (!$util.isInteger(message.cards[i]))
                        return "cards: integer[] expected";
            }
            if (message.userJson != null && message.hasOwnProperty("userJson"))
                if (!$util.isString(message.userJson))
                    return "userJson: string expected";
            if (message.scoreBalance != null && message.hasOwnProperty("scoreBalance"))
                if (!$util.isInteger(message.scoreBalance))
                    return "scoreBalance: integer expected";
            if (message.coinBalance != null && message.hasOwnProperty("coinBalance"))
                if (typeof message.coinBalance !== "number")
                    return "coinBalance: number expected";
            if (message.canShowQ2 != null && message.hasOwnProperty("canShowQ2"))
                if (typeof message.canShowQ2 !== "boolean")
                    return "canShowQ2: boolean expected";
            if (message.showQ2 != null && message.hasOwnProperty("showQ2"))
                if (typeof message.showQ2 !== "boolean")
                    return "showQ2: boolean expected";
            if (message.isPlaying != null && message.hasOwnProperty("isPlaying"))
                if (typeof message.isPlaying !== "boolean")
                    return "isPlaying: boolean expected";
            if (message.completeInfo != null && message.hasOwnProperty("completeInfo")) {
                var error = $root.Q2Game.CompleteInfo.verify(message.completeInfo);
                if (error)
                    return "completeInfo." + error;
            }
            if (message.finishedList != null && message.hasOwnProperty("finishedList")) {
                if (!Array.isArray(message.finishedList))
                    return "finishedList: array expected";
                for (var i = 0; i < message.finishedList.length; ++i) {
                    var error = $root.Q2Game.CardPattern.verify(message.finishedList[i]);
                    if (error)
                        return "finishedList." + error;
                }
            }
            if (message.raisableList != null && message.hasOwnProperty("raisableList")) {
                if (!Array.isArray(message.raisableList))
                    return "raisableList: array expected";
                for (var i = 0; i < message.raisableList.length; ++i) {
                    var error = $root.Q2Game.CardPattern.verify(message.raisableList[i]);
                    if (error)
                        return "raisableList." + error;
                }
            }
            if (message.storableList != null && message.hasOwnProperty("storableList")) {
                if (!Array.isArray(message.storableList))
                    return "storableList: array expected";
                for (var i = 0; i < message.storableList.length; ++i) {
                    var error = $root.Q2Game.CardPattern.verify(message.storableList[i]);
                    if (error)
                        return "storableList." + error;
                }
            }
            if (message.attachableList != null && message.hasOwnProperty("attachableList")) {
                if (!Array.isArray(message.attachableList))
                    return "attachableList: array expected";
                for (var i = 0; i < message.attachableList.length; ++i) {
                    var error = $root.Q2Game.CardPattern.verify(message.attachableList[i]);
                    if (error)
                        return "attachableList." + error;
                }
            }
            return null;
        };

        /**
         * Creates a SeatInfo message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof Q2Game.SeatInfo
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {Q2Game.SeatInfo} SeatInfo
         */
        SeatInfo.fromObject = function fromObject(object) {
            if (object instanceof $root.Q2Game.SeatInfo)
                return object;
            var message = new $root.Q2Game.SeatInfo();
            if (object.seatId != null)
                message.seatId = object.seatId >>> 0;
            if (object.playerId != null)
                message.playerId = object.playerId | 0;
            if (object.cards) {
                if (!Array.isArray(object.cards))
                    throw TypeError(".Q2Game.SeatInfo.cards: array expected");
                message.cards = [];
                for (var i = 0; i < object.cards.length; ++i)
                    message.cards[i] = object.cards[i] | 0;
            }
            if (object.userJson != null)
                message.userJson = String(object.userJson);
            if (object.scoreBalance != null)
                message.scoreBalance = object.scoreBalance | 0;
            if (object.coinBalance != null)
                message.coinBalance = Number(object.coinBalance);
            if (object.canShowQ2 != null)
                message.canShowQ2 = Boolean(object.canShowQ2);
            if (object.showQ2 != null)
                message.showQ2 = Boolean(object.showQ2);
            if (object.isPlaying != null)
                message.isPlaying = Boolean(object.isPlaying);
            if (object.completeInfo != null) {
                if (typeof object.completeInfo !== "object")
                    throw TypeError(".Q2Game.SeatInfo.completeInfo: object expected");
                message.completeInfo = $root.Q2Game.CompleteInfo.fromObject(object.completeInfo);
            }
            if (object.finishedList) {
                if (!Array.isArray(object.finishedList))
                    throw TypeError(".Q2Game.SeatInfo.finishedList: array expected");
                message.finishedList = [];
                for (var i = 0; i < object.finishedList.length; ++i) {
                    if (typeof object.finishedList[i] !== "object")
                        throw TypeError(".Q2Game.SeatInfo.finishedList: object expected");
                    message.finishedList[i] = $root.Q2Game.CardPattern.fromObject(object.finishedList[i]);
                }
            }
            if (object.raisableList) {
                if (!Array.isArray(object.raisableList))
                    throw TypeError(".Q2Game.SeatInfo.raisableList: array expected");
                message.raisableList = [];
                for (var i = 0; i < object.raisableList.length; ++i) {
                    if (typeof object.raisableList[i] !== "object")
                        throw TypeError(".Q2Game.SeatInfo.raisableList: object expected");
                    message.raisableList[i] = $root.Q2Game.CardPattern.fromObject(object.raisableList[i]);
                }
            }
            if (object.storableList) {
                if (!Array.isArray(object.storableList))
                    throw TypeError(".Q2Game.SeatInfo.storableList: array expected");
                message.storableList = [];
                for (var i = 0; i < object.storableList.length; ++i) {
                    if (typeof object.storableList[i] !== "object")
                        throw TypeError(".Q2Game.SeatInfo.storableList: object expected");
                    message.storableList[i] = $root.Q2Game.CardPattern.fromObject(object.storableList[i]);
                }
            }
            if (object.attachableList) {
                if (!Array.isArray(object.attachableList))
                    throw TypeError(".Q2Game.SeatInfo.attachableList: array expected");
                message.attachableList = [];
                for (var i = 0; i < object.attachableList.length; ++i) {
                    if (typeof object.attachableList[i] !== "object")
                        throw TypeError(".Q2Game.SeatInfo.attachableList: object expected");
                    message.attachableList[i] = $root.Q2Game.CardPattern.fromObject(object.attachableList[i]);
                }
            }
            return message;
        };

        /**
         * Creates a plain object from a SeatInfo message. Also converts values to other types if specified.
         * @function toObject
         * @memberof Q2Game.SeatInfo
         * @static
         * @param {Q2Game.SeatInfo} message SeatInfo
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        SeatInfo.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.arrays || options.defaults) {
                object.cards = [];
                object.raisableList = [];
                object.storableList = [];
                object.attachableList = [];
                object.finishedList = [];
            }
            if (options.defaults) {
                object.seatId = 0;
                object.playerId = 0;
                object.scoreBalance = 0;
                object.canShowQ2 = false;
                object.showQ2 = false;
                object.completeInfo = null;
                object.userJson = "";
                object.isPlaying = false;
                object.coinBalance = 0;
            }
            if (message.seatId != null && message.hasOwnProperty("seatId"))
                object.seatId = message.seatId;
            if (message.cards && message.cards.length) {
                object.cards = [];
                for (var j = 0; j < message.cards.length; ++j)
                    object.cards[j] = message.cards[j];
            }
            if (message.playerId != null && message.hasOwnProperty("playerId"))
                object.playerId = message.playerId;
            if (message.raisableList && message.raisableList.length) {
                object.raisableList = [];
                for (var j = 0; j < message.raisableList.length; ++j)
                    object.raisableList[j] = $root.Q2Game.CardPattern.toObject(message.raisableList[j], options);
            }
            if (message.storableList && message.storableList.length) {
                object.storableList = [];
                for (var j = 0; j < message.storableList.length; ++j)
                    object.storableList[j] = $root.Q2Game.CardPattern.toObject(message.storableList[j], options);
            }
            if (message.attachableList && message.attachableList.length) {
                object.attachableList = [];
                for (var j = 0; j < message.attachableList.length; ++j)
                    object.attachableList[j] = $root.Q2Game.CardPattern.toObject(message.attachableList[j], options);
            }
            if (message.finishedList && message.finishedList.length) {
                object.finishedList = [];
                for (var j = 0; j < message.finishedList.length; ++j)
                    object.finishedList[j] = $root.Q2Game.CardPattern.toObject(message.finishedList[j], options);
            }
            if (message.scoreBalance != null && message.hasOwnProperty("scoreBalance"))
                object.scoreBalance = message.scoreBalance;
            if (message.canShowQ2 != null && message.hasOwnProperty("canShowQ2"))
                object.canShowQ2 = message.canShowQ2;
            if (message.showQ2 != null && message.hasOwnProperty("showQ2"))
                object.showQ2 = message.showQ2;
            if (message.completeInfo != null && message.hasOwnProperty("completeInfo"))
                object.completeInfo = $root.Q2Game.CompleteInfo.toObject(message.completeInfo, options);
            if (message.userJson != null && message.hasOwnProperty("userJson"))
                object.userJson = message.userJson;
            if (message.isPlaying != null && message.hasOwnProperty("isPlaying"))
                object.isPlaying = message.isPlaying;
            if (message.coinBalance != null && message.hasOwnProperty("coinBalance"))
                object.coinBalance = options.json && !isFinite(message.coinBalance) ? String(message.coinBalance) : message.coinBalance;
            return object;
        };

        /**
         * Converts this SeatInfo to JSON.
         * @function toJSON
         * @memberof Q2Game.SeatInfo
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        SeatInfo.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return SeatInfo;
    })();

    Q2Game.GameInfo = (function() {

        /**
         * Properties of a GameInfo.
         * @memberof Q2Game
         * @interface IGameInfo
         * @property {number|null} [roomId] GameInfo roomId
         * @property {number|null} [time] GameInfo time
         * @property {number|null} [maxPlayerCnt] GameInfo maxPlayerCnt
         * @property {number|null} [state] GameInfo state
         * @property {number|null} [stateExpiredTime] GameInfo stateExpiredTime
         * @property {number|null} [stateDuration] GameInfo stateDuration
         * @property {number|null} [currentSeat] GameInfo currentSeat
         * @property {Array.<Q2Game.ISeatInfo>|null} [seatList] GameInfo seatList
         * @property {number|null} [cardPoolLen] GameInfo cardPoolLen
         * @property {Array.<number>|null} [commonCards] GameInfo commonCards
         * @property {number|null} [firstCommonCard] GameInfo firstCommonCard
         * @property {string|null} [roundSign] GameInfo roundSign
         * @property {number|null} [firstSeatId] GameInfo firstSeatId
         * @property {number|null} [opDir] GameInfo opDir
         */

        /**
         * Constructs a new GameInfo.
         * @memberof Q2Game
         * @classdesc Represents a GameInfo.
         * @implements IGameInfo
         * @constructor
         * @param {Q2Game.IGameInfo=} [properties] Properties to set
         */
        function GameInfo(properties) {
            this.seatList = [];
            this.commonCards = [];
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * GameInfo roomId.
         * @member {number} roomId
         * @memberof Q2Game.GameInfo
         * @instance
         */
        GameInfo.prototype.roomId = 0;

        /**
         * GameInfo time.
         * @member {number} time
         * @memberof Q2Game.GameInfo
         * @instance
         */
        GameInfo.prototype.time = 0;

        /**
         * GameInfo maxPlayerCnt.
         * @member {number} maxPlayerCnt
         * @memberof Q2Game.GameInfo
         * @instance
         */
        GameInfo.prototype.maxPlayerCnt = 0;

        /**
         * GameInfo state.
         * @member {number} state
         * @memberof Q2Game.GameInfo
         * @instance
         */
        GameInfo.prototype.state = 0;

        /**
         * GameInfo stateExpiredTime.
         * @member {number} stateExpiredTime
         * @memberof Q2Game.GameInfo
         * @instance
         */
        GameInfo.prototype.stateExpiredTime = 0;

        /**
         * GameInfo stateDuration.
         * @member {number} stateDuration
         * @memberof Q2Game.GameInfo
         * @instance
         */
        GameInfo.prototype.stateDuration = 0;

        /**
         * GameInfo currentSeat.
         * @member {number} currentSeat
         * @memberof Q2Game.GameInfo
         * @instance
         */
        GameInfo.prototype.currentSeat = 0;

        /**
         * GameInfo seatList.
         * @member {Array.<Q2Game.ISeatInfo>} seatList
         * @memberof Q2Game.GameInfo
         * @instance
         */
        GameInfo.prototype.seatList = $util.emptyArray;

        /**
         * GameInfo cardPoolLen.
         * @member {number} cardPoolLen
         * @memberof Q2Game.GameInfo
         * @instance
         */
        GameInfo.prototype.cardPoolLen = 0;

        /**
         * GameInfo commonCards.
         * @member {Array.<number>} commonCards
         * @memberof Q2Game.GameInfo
         * @instance
         */
        GameInfo.prototype.commonCards = $util.emptyArray;

        /**
         * GameInfo firstCommonCard.
         * @member {number} firstCommonCard
         * @memberof Q2Game.GameInfo
         * @instance
         */
        GameInfo.prototype.firstCommonCard = 0;

        /**
         * GameInfo roundSign.
         * @member {string} roundSign
         * @memberof Q2Game.GameInfo
         * @instance
         */
        GameInfo.prototype.roundSign = "";

        /**
         * GameInfo firstSeatId.
         * @member {number} firstSeatId
         * @memberof Q2Game.GameInfo
         * @instance
         */
        GameInfo.prototype.firstSeatId = 0;

        /**
         * GameInfo opDir.
         * @member {number} opDir
         * @memberof Q2Game.GameInfo
         * @instance
         */
        GameInfo.prototype.opDir = 0;

        /**
         * Creates a new GameInfo instance using the specified properties.
         * @function create
         * @memberof Q2Game.GameInfo
         * @static
         * @param {Q2Game.IGameInfo=} [properties] Properties to set
         * @returns {Q2Game.GameInfo} GameInfo instance
         */
        GameInfo.create = function create(properties) {
            return new GameInfo(properties);
        };

        /**
         * Encodes the specified GameInfo message. Does not implicitly {@link Q2Game.GameInfo.verify|verify} messages.
         * @function encode
         * @memberof Q2Game.GameInfo
         * @static
         * @param {Q2Game.IGameInfo} message GameInfo message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        GameInfo.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.roomId != null && message.hasOwnProperty("roomId"))
                writer.uint32(/* id 1, wireType 0 =*/8).int32(message.roomId);
            if (message.commonCards != null && message.commonCards.length)
                for (var i = 0; i < message.commonCards.length; ++i)
                    writer.uint32(/* id 2, wireType 0 =*/16).int32(message.commonCards[i]);
            if (message.time != null && message.hasOwnProperty("time"))
                writer.uint32(/* id 3, wireType 0 =*/24).int32(message.time);
            if (message.maxPlayerCnt != null && message.hasOwnProperty("maxPlayerCnt"))
                writer.uint32(/* id 4, wireType 0 =*/32).int32(message.maxPlayerCnt);
            if (message.firstCommonCard != null && message.hasOwnProperty("firstCommonCard"))
                writer.uint32(/* id 5, wireType 0 =*/40).int32(message.firstCommonCard);
            if (message.firstSeatId != null && message.hasOwnProperty("firstSeatId"))
                writer.uint32(/* id 6, wireType 0 =*/48).int32(message.firstSeatId);
            if (message.opDir != null && message.hasOwnProperty("opDir"))
                writer.uint32(/* id 7, wireType 0 =*/56).int32(message.opDir);
            if (message.state != null && message.hasOwnProperty("state"))
                writer.uint32(/* id 10, wireType 0 =*/80).int32(message.state);
            if (message.stateExpiredTime != null && message.hasOwnProperty("stateExpiredTime"))
                writer.uint32(/* id 11, wireType 0 =*/88).int32(message.stateExpiredTime);
            if (message.currentSeat != null && message.hasOwnProperty("currentSeat"))
                writer.uint32(/* id 12, wireType 0 =*/96).int32(message.currentSeat);
            if (message.seatList != null && message.seatList.length)
                for (var i = 0; i < message.seatList.length; ++i)
                    $root.Q2Game.SeatInfo.encode(message.seatList[i], writer.uint32(/* id 13, wireType 2 =*/106).fork()).ldelim();
            if (message.stateDuration != null && message.hasOwnProperty("stateDuration"))
                writer.uint32(/* id 14, wireType 0 =*/112).int32(message.stateDuration);
            if (message.cardPoolLen != null && message.hasOwnProperty("cardPoolLen"))
                writer.uint32(/* id 15, wireType 0 =*/120).int32(message.cardPoolLen);
            if (message.roundSign != null && message.hasOwnProperty("roundSign"))
                writer.uint32(/* id 16, wireType 2 =*/130).string(message.roundSign);
            return writer;
        };

        /**
         * Encodes the specified GameInfo message, length delimited. Does not implicitly {@link Q2Game.GameInfo.verify|verify} messages.
         * @function encodeDelimited
         * @memberof Q2Game.GameInfo
         * @static
         * @param {Q2Game.IGameInfo} message GameInfo message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        GameInfo.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a GameInfo message from the specified reader or buffer.
         * @function decode
         * @memberof Q2Game.GameInfo
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {Q2Game.GameInfo} GameInfo
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        GameInfo.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.Q2Game.GameInfo();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.roomId = reader.int32();
                    break;
                case 3:
                    message.time = reader.int32();
                    break;
                case 4:
                    message.maxPlayerCnt = reader.int32();
                    break;
                case 10:
                    message.state = reader.int32();
                    break;
                case 11:
                    message.stateExpiredTime = reader.int32();
                    break;
                case 14:
                    message.stateDuration = reader.int32();
                    break;
                case 12:
                    message.currentSeat = reader.int32();
                    break;
                case 13:
                    if (!(message.seatList && message.seatList.length))
                        message.seatList = [];
                    message.seatList.push($root.Q2Game.SeatInfo.decode(reader, reader.uint32()));
                    break;
                case 15:
                    message.cardPoolLen = reader.int32();
                    break;
                case 2:
                    if (!(message.commonCards && message.commonCards.length))
                        message.commonCards = [];
                    if ((tag & 7) === 2) {
                        var end2 = reader.uint32() + reader.pos;
                        while (reader.pos < end2)
                            message.commonCards.push(reader.int32());
                    } else
                        message.commonCards.push(reader.int32());
                    break;
                case 5:
                    message.firstCommonCard = reader.int32();
                    break;
                case 16:
                    message.roundSign = reader.string();
                    break;
                case 6:
                    message.firstSeatId = reader.int32();
                    break;
                case 7:
                    message.opDir = reader.int32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a GameInfo message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof Q2Game.GameInfo
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {Q2Game.GameInfo} GameInfo
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        GameInfo.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a GameInfo message.
         * @function verify
         * @memberof Q2Game.GameInfo
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        GameInfo.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.roomId != null && message.hasOwnProperty("roomId"))
                if (!$util.isInteger(message.roomId))
                    return "roomId: integer expected";
            if (message.time != null && message.hasOwnProperty("time"))
                if (!$util.isInteger(message.time))
                    return "time: integer expected";
            if (message.maxPlayerCnt != null && message.hasOwnProperty("maxPlayerCnt"))
                if (!$util.isInteger(message.maxPlayerCnt))
                    return "maxPlayerCnt: integer expected";
            if (message.state != null && message.hasOwnProperty("state"))
                if (!$util.isInteger(message.state))
                    return "state: integer expected";
            if (message.stateExpiredTime != null && message.hasOwnProperty("stateExpiredTime"))
                if (!$util.isInteger(message.stateExpiredTime))
                    return "stateExpiredTime: integer expected";
            if (message.stateDuration != null && message.hasOwnProperty("stateDuration"))
                if (!$util.isInteger(message.stateDuration))
                    return "stateDuration: integer expected";
            if (message.currentSeat != null && message.hasOwnProperty("currentSeat"))
                if (!$util.isInteger(message.currentSeat))
                    return "currentSeat: integer expected";
            if (message.seatList != null && message.hasOwnProperty("seatList")) {
                if (!Array.isArray(message.seatList))
                    return "seatList: array expected";
                for (var i = 0; i < message.seatList.length; ++i) {
                    var error = $root.Q2Game.SeatInfo.verify(message.seatList[i]);
                    if (error)
                        return "seatList." + error;
                }
            }
            if (message.cardPoolLen != null && message.hasOwnProperty("cardPoolLen"))
                if (!$util.isInteger(message.cardPoolLen))
                    return "cardPoolLen: integer expected";
            if (message.commonCards != null && message.hasOwnProperty("commonCards")) {
                if (!Array.isArray(message.commonCards))
                    return "commonCards: array expected";
                for (var i = 0; i < message.commonCards.length; ++i)
                    if (!$util.isInteger(message.commonCards[i]))
                        return "commonCards: integer[] expected";
            }
            if (message.firstCommonCard != null && message.hasOwnProperty("firstCommonCard"))
                if (!$util.isInteger(message.firstCommonCard))
                    return "firstCommonCard: integer expected";
            if (message.roundSign != null && message.hasOwnProperty("roundSign"))
                if (!$util.isString(message.roundSign))
                    return "roundSign: string expected";
            if (message.firstSeatId != null && message.hasOwnProperty("firstSeatId"))
                if (!$util.isInteger(message.firstSeatId))
                    return "firstSeatId: integer expected";
            if (message.opDir != null && message.hasOwnProperty("opDir"))
                if (!$util.isInteger(message.opDir))
                    return "opDir: integer expected";
            return null;
        };

        /**
         * Creates a GameInfo message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof Q2Game.GameInfo
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {Q2Game.GameInfo} GameInfo
         */
        GameInfo.fromObject = function fromObject(object) {
            if (object instanceof $root.Q2Game.GameInfo)
                return object;
            var message = new $root.Q2Game.GameInfo();
            if (object.roomId != null)
                message.roomId = object.roomId | 0;
            if (object.time != null)
                message.time = object.time | 0;
            if (object.maxPlayerCnt != null)
                message.maxPlayerCnt = object.maxPlayerCnt | 0;
            if (object.state != null)
                message.state = object.state | 0;
            if (object.stateExpiredTime != null)
                message.stateExpiredTime = object.stateExpiredTime | 0;
            if (object.stateDuration != null)
                message.stateDuration = object.stateDuration | 0;
            if (object.currentSeat != null)
                message.currentSeat = object.currentSeat | 0;
            if (object.seatList) {
                if (!Array.isArray(object.seatList))
                    throw TypeError(".Q2Game.GameInfo.seatList: array expected");
                message.seatList = [];
                for (var i = 0; i < object.seatList.length; ++i) {
                    if (typeof object.seatList[i] !== "object")
                        throw TypeError(".Q2Game.GameInfo.seatList: object expected");
                    message.seatList[i] = $root.Q2Game.SeatInfo.fromObject(object.seatList[i]);
                }
            }
            if (object.cardPoolLen != null)
                message.cardPoolLen = object.cardPoolLen | 0;
            if (object.commonCards) {
                if (!Array.isArray(object.commonCards))
                    throw TypeError(".Q2Game.GameInfo.commonCards: array expected");
                message.commonCards = [];
                for (var i = 0; i < object.commonCards.length; ++i)
                    message.commonCards[i] = object.commonCards[i] | 0;
            }
            if (object.firstCommonCard != null)
                message.firstCommonCard = object.firstCommonCard | 0;
            if (object.roundSign != null)
                message.roundSign = String(object.roundSign);
            if (object.firstSeatId != null)
                message.firstSeatId = object.firstSeatId | 0;
            if (object.opDir != null)
                message.opDir = object.opDir | 0;
            return message;
        };

        /**
         * Creates a plain object from a GameInfo message. Also converts values to other types if specified.
         * @function toObject
         * @memberof Q2Game.GameInfo
         * @static
         * @param {Q2Game.GameInfo} message GameInfo
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        GameInfo.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.arrays || options.defaults) {
                object.commonCards = [];
                object.seatList = [];
            }
            if (options.defaults) {
                object.roomId = 0;
                object.time = 0;
                object.maxPlayerCnt = 0;
                object.firstCommonCard = 0;
                object.firstSeatId = 0;
                object.opDir = 0;
                object.state = 0;
                object.stateExpiredTime = 0;
                object.currentSeat = 0;
                object.stateDuration = 0;
                object.cardPoolLen = 0;
                object.roundSign = "";
            }
            if (message.roomId != null && message.hasOwnProperty("roomId"))
                object.roomId = message.roomId;
            if (message.commonCards && message.commonCards.length) {
                object.commonCards = [];
                for (var j = 0; j < message.commonCards.length; ++j)
                    object.commonCards[j] = message.commonCards[j];
            }
            if (message.time != null && message.hasOwnProperty("time"))
                object.time = message.time;
            if (message.maxPlayerCnt != null && message.hasOwnProperty("maxPlayerCnt"))
                object.maxPlayerCnt = message.maxPlayerCnt;
            if (message.firstCommonCard != null && message.hasOwnProperty("firstCommonCard"))
                object.firstCommonCard = message.firstCommonCard;
            if (message.firstSeatId != null && message.hasOwnProperty("firstSeatId"))
                object.firstSeatId = message.firstSeatId;
            if (message.opDir != null && message.hasOwnProperty("opDir"))
                object.opDir = message.opDir;
            if (message.state != null && message.hasOwnProperty("state"))
                object.state = message.state;
            if (message.stateExpiredTime != null && message.hasOwnProperty("stateExpiredTime"))
                object.stateExpiredTime = message.stateExpiredTime;
            if (message.currentSeat != null && message.hasOwnProperty("currentSeat"))
                object.currentSeat = message.currentSeat;
            if (message.seatList && message.seatList.length) {
                object.seatList = [];
                for (var j = 0; j < message.seatList.length; ++j)
                    object.seatList[j] = $root.Q2Game.SeatInfo.toObject(message.seatList[j], options);
            }
            if (message.stateDuration != null && message.hasOwnProperty("stateDuration"))
                object.stateDuration = message.stateDuration;
            if (message.cardPoolLen != null && message.hasOwnProperty("cardPoolLen"))
                object.cardPoolLen = message.cardPoolLen;
            if (message.roundSign != null && message.hasOwnProperty("roundSign"))
                object.roundSign = message.roundSign;
            return object;
        };

        /**
         * Converts this GameInfo to JSON.
         * @function toJSON
         * @memberof Q2Game.GameInfo
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        GameInfo.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return GameInfo;
    })();

    Q2Game.InitNotify = (function() {

        /**
         * Properties of an InitNotify.
         * @memberof Q2Game
         * @interface IInitNotify
         * @property {string|null} [roundSign] InitNotify roundSign
         * @property {number|null} [firstSeatId] InitNotify firstSeatId
         * @property {number|null} [opDir] InitNotify opDir
         */

        /**
         * Constructs a new InitNotify.
         * @memberof Q2Game
         * @classdesc Represents an InitNotify.
         * @implements IInitNotify
         * @constructor
         * @param {Q2Game.IInitNotify=} [properties] Properties to set
         */
        function InitNotify(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * InitNotify roundSign.
         * @member {string} roundSign
         * @memberof Q2Game.InitNotify
         * @instance
         */
        InitNotify.prototype.roundSign = "";

        /**
         * InitNotify firstSeatId.
         * @member {number} firstSeatId
         * @memberof Q2Game.InitNotify
         * @instance
         */
        InitNotify.prototype.firstSeatId = 0;

        /**
         * InitNotify opDir.
         * @member {number} opDir
         * @memberof Q2Game.InitNotify
         * @instance
         */
        InitNotify.prototype.opDir = 0;

        /**
         * Creates a new InitNotify instance using the specified properties.
         * @function create
         * @memberof Q2Game.InitNotify
         * @static
         * @param {Q2Game.IInitNotify=} [properties] Properties to set
         * @returns {Q2Game.InitNotify} InitNotify instance
         */
        InitNotify.create = function create(properties) {
            return new InitNotify(properties);
        };

        /**
         * Encodes the specified InitNotify message. Does not implicitly {@link Q2Game.InitNotify.verify|verify} messages.
         * @function encode
         * @memberof Q2Game.InitNotify
         * @static
         * @param {Q2Game.IInitNotify} message InitNotify message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        InitNotify.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.roundSign != null && message.hasOwnProperty("roundSign"))
                writer.uint32(/* id 1, wireType 2 =*/10).string(message.roundSign);
            if (message.firstSeatId != null && message.hasOwnProperty("firstSeatId"))
                writer.uint32(/* id 2, wireType 0 =*/16).int32(message.firstSeatId);
            if (message.opDir != null && message.hasOwnProperty("opDir"))
                writer.uint32(/* id 3, wireType 0 =*/24).int32(message.opDir);
            return writer;
        };

        /**
         * Encodes the specified InitNotify message, length delimited. Does not implicitly {@link Q2Game.InitNotify.verify|verify} messages.
         * @function encodeDelimited
         * @memberof Q2Game.InitNotify
         * @static
         * @param {Q2Game.IInitNotify} message InitNotify message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        InitNotify.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes an InitNotify message from the specified reader or buffer.
         * @function decode
         * @memberof Q2Game.InitNotify
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {Q2Game.InitNotify} InitNotify
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        InitNotify.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.Q2Game.InitNotify();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.roundSign = reader.string();
                    break;
                case 2:
                    message.firstSeatId = reader.int32();
                    break;
                case 3:
                    message.opDir = reader.int32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes an InitNotify message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof Q2Game.InitNotify
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {Q2Game.InitNotify} InitNotify
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        InitNotify.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies an InitNotify message.
         * @function verify
         * @memberof Q2Game.InitNotify
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        InitNotify.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.roundSign != null && message.hasOwnProperty("roundSign"))
                if (!$util.isString(message.roundSign))
                    return "roundSign: string expected";
            if (message.firstSeatId != null && message.hasOwnProperty("firstSeatId"))
                if (!$util.isInteger(message.firstSeatId))
                    return "firstSeatId: integer expected";
            if (message.opDir != null && message.hasOwnProperty("opDir"))
                if (!$util.isInteger(message.opDir))
                    return "opDir: integer expected";
            return null;
        };

        /**
         * Creates an InitNotify message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof Q2Game.InitNotify
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {Q2Game.InitNotify} InitNotify
         */
        InitNotify.fromObject = function fromObject(object) {
            if (object instanceof $root.Q2Game.InitNotify)
                return object;
            var message = new $root.Q2Game.InitNotify();
            if (object.roundSign != null)
                message.roundSign = String(object.roundSign);
            if (object.firstSeatId != null)
                message.firstSeatId = object.firstSeatId | 0;
            if (object.opDir != null)
                message.opDir = object.opDir | 0;
            return message;
        };

        /**
         * Creates a plain object from an InitNotify message. Also converts values to other types if specified.
         * @function toObject
         * @memberof Q2Game.InitNotify
         * @static
         * @param {Q2Game.InitNotify} message InitNotify
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        InitNotify.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                object.roundSign = "";
                object.firstSeatId = 0;
                object.opDir = 0;
            }
            if (message.roundSign != null && message.hasOwnProperty("roundSign"))
                object.roundSign = message.roundSign;
            if (message.firstSeatId != null && message.hasOwnProperty("firstSeatId"))
                object.firstSeatId = message.firstSeatId;
            if (message.opDir != null && message.hasOwnProperty("opDir"))
                object.opDir = message.opDir;
            return object;
        };

        /**
         * Converts this InitNotify to JSON.
         * @function toJSON
         * @memberof Q2Game.InitNotify
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        InitNotify.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return InitNotify;
    })();

    Q2Game.Score = (function() {

        /**
         * Properties of a Score.
         * @memberof Q2Game
         * @interface IScore
         * @property {number|null} [seatId] Score seatId
         * @property {number|null} [score] Score score
         * @property {number|null} [scoreBalance] Score scoreBalance
         * @property {number|null} [scoreReason] Score scoreReason
         */

        /**
         * Constructs a new Score.
         * @memberof Q2Game
         * @classdesc Represents a Score.
         * @implements IScore
         * @constructor
         * @param {Q2Game.IScore=} [properties] Properties to set
         */
        function Score(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * Score seatId.
         * @member {number} seatId
         * @memberof Q2Game.Score
         * @instance
         */
        Score.prototype.seatId = 0;

        /**
         * Score score.
         * @member {number} score
         * @memberof Q2Game.Score
         * @instance
         */
        Score.prototype.score = 0;

        /**
         * Score scoreBalance.
         * @member {number} scoreBalance
         * @memberof Q2Game.Score
         * @instance
         */
        Score.prototype.scoreBalance = 0;

        /**
         * Score scoreReason.
         * @member {number} scoreReason
         * @memberof Q2Game.Score
         * @instance
         */
        Score.prototype.scoreReason = 0;

        /**
         * Creates a new Score instance using the specified properties.
         * @function create
         * @memberof Q2Game.Score
         * @static
         * @param {Q2Game.IScore=} [properties] Properties to set
         * @returns {Q2Game.Score} Score instance
         */
        Score.create = function create(properties) {
            return new Score(properties);
        };

        /**
         * Encodes the specified Score message. Does not implicitly {@link Q2Game.Score.verify|verify} messages.
         * @function encode
         * @memberof Q2Game.Score
         * @static
         * @param {Q2Game.IScore} message Score message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        Score.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.seatId != null && message.hasOwnProperty("seatId"))
                writer.uint32(/* id 1, wireType 0 =*/8).int32(message.seatId);
            if (message.score != null && message.hasOwnProperty("score"))
                writer.uint32(/* id 6, wireType 0 =*/48).int32(message.score);
            if (message.scoreBalance != null && message.hasOwnProperty("scoreBalance"))
                writer.uint32(/* id 7, wireType 0 =*/56).int32(message.scoreBalance);
            if (message.scoreReason != null && message.hasOwnProperty("scoreReason"))
                writer.uint32(/* id 9, wireType 0 =*/72).int32(message.scoreReason);
            return writer;
        };

        /**
         * Encodes the specified Score message, length delimited. Does not implicitly {@link Q2Game.Score.verify|verify} messages.
         * @function encodeDelimited
         * @memberof Q2Game.Score
         * @static
         * @param {Q2Game.IScore} message Score message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        Score.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a Score message from the specified reader or buffer.
         * @function decode
         * @memberof Q2Game.Score
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {Q2Game.Score} Score
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        Score.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.Q2Game.Score();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.seatId = reader.int32();
                    break;
                case 6:
                    message.score = reader.int32();
                    break;
                case 7:
                    message.scoreBalance = reader.int32();
                    break;
                case 9:
                    message.scoreReason = reader.int32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a Score message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof Q2Game.Score
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {Q2Game.Score} Score
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        Score.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a Score message.
         * @function verify
         * @memberof Q2Game.Score
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        Score.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.seatId != null && message.hasOwnProperty("seatId"))
                if (!$util.isInteger(message.seatId))
                    return "seatId: integer expected";
            if (message.score != null && message.hasOwnProperty("score"))
                if (!$util.isInteger(message.score))
                    return "score: integer expected";
            if (message.scoreBalance != null && message.hasOwnProperty("scoreBalance"))
                if (!$util.isInteger(message.scoreBalance))
                    return "scoreBalance: integer expected";
            if (message.scoreReason != null && message.hasOwnProperty("scoreReason"))
                if (!$util.isInteger(message.scoreReason))
                    return "scoreReason: integer expected";
            return null;
        };

        /**
         * Creates a Score message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof Q2Game.Score
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {Q2Game.Score} Score
         */
        Score.fromObject = function fromObject(object) {
            if (object instanceof $root.Q2Game.Score)
                return object;
            var message = new $root.Q2Game.Score();
            if (object.seatId != null)
                message.seatId = object.seatId | 0;
            if (object.score != null)
                message.score = object.score | 0;
            if (object.scoreBalance != null)
                message.scoreBalance = object.scoreBalance | 0;
            if (object.scoreReason != null)
                message.scoreReason = object.scoreReason | 0;
            return message;
        };

        /**
         * Creates a plain object from a Score message. Also converts values to other types if specified.
         * @function toObject
         * @memberof Q2Game.Score
         * @static
         * @param {Q2Game.Score} message Score
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        Score.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                object.seatId = 0;
                object.score = 0;
                object.scoreBalance = 0;
                object.scoreReason = 0;
            }
            if (message.seatId != null && message.hasOwnProperty("seatId"))
                object.seatId = message.seatId;
            if (message.score != null && message.hasOwnProperty("score"))
                object.score = message.score;
            if (message.scoreBalance != null && message.hasOwnProperty("scoreBalance"))
                object.scoreBalance = message.scoreBalance;
            if (message.scoreReason != null && message.hasOwnProperty("scoreReason"))
                object.scoreReason = message.scoreReason;
            return object;
        };

        /**
         * Converts this Score to JSON.
         * @function toJSON
         * @memberof Q2Game.Score
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        Score.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return Score;
    })();

    Q2Game.ScoreNotify = (function() {

        /**
         * Properties of a ScoreNotify.
         * @memberof Q2Game
         * @interface IScoreNotify
         * @property {Array.<Q2Game.IScore>|null} [scoreList] ScoreNotify scoreList
         */

        /**
         * Constructs a new ScoreNotify.
         * @memberof Q2Game
         * @classdesc Represents a ScoreNotify.
         * @implements IScoreNotify
         * @constructor
         * @param {Q2Game.IScoreNotify=} [properties] Properties to set
         */
        function ScoreNotify(properties) {
            this.scoreList = [];
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * ScoreNotify scoreList.
         * @member {Array.<Q2Game.IScore>} scoreList
         * @memberof Q2Game.ScoreNotify
         * @instance
         */
        ScoreNotify.prototype.scoreList = $util.emptyArray;

        /**
         * Creates a new ScoreNotify instance using the specified properties.
         * @function create
         * @memberof Q2Game.ScoreNotify
         * @static
         * @param {Q2Game.IScoreNotify=} [properties] Properties to set
         * @returns {Q2Game.ScoreNotify} ScoreNotify instance
         */
        ScoreNotify.create = function create(properties) {
            return new ScoreNotify(properties);
        };

        /**
         * Encodes the specified ScoreNotify message. Does not implicitly {@link Q2Game.ScoreNotify.verify|verify} messages.
         * @function encode
         * @memberof Q2Game.ScoreNotify
         * @static
         * @param {Q2Game.IScoreNotify} message ScoreNotify message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        ScoreNotify.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.scoreList != null && message.scoreList.length)
                for (var i = 0; i < message.scoreList.length; ++i)
                    $root.Q2Game.Score.encode(message.scoreList[i], writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
            return writer;
        };

        /**
         * Encodes the specified ScoreNotify message, length delimited. Does not implicitly {@link Q2Game.ScoreNotify.verify|verify} messages.
         * @function encodeDelimited
         * @memberof Q2Game.ScoreNotify
         * @static
         * @param {Q2Game.IScoreNotify} message ScoreNotify message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        ScoreNotify.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a ScoreNotify message from the specified reader or buffer.
         * @function decode
         * @memberof Q2Game.ScoreNotify
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {Q2Game.ScoreNotify} ScoreNotify
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        ScoreNotify.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.Q2Game.ScoreNotify();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    if (!(message.scoreList && message.scoreList.length))
                        message.scoreList = [];
                    message.scoreList.push($root.Q2Game.Score.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a ScoreNotify message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof Q2Game.ScoreNotify
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {Q2Game.ScoreNotify} ScoreNotify
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        ScoreNotify.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a ScoreNotify message.
         * @function verify
         * @memberof Q2Game.ScoreNotify
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        ScoreNotify.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.scoreList != null && message.hasOwnProperty("scoreList")) {
                if (!Array.isArray(message.scoreList))
                    return "scoreList: array expected";
                for (var i = 0; i < message.scoreList.length; ++i) {
                    var error = $root.Q2Game.Score.verify(message.scoreList[i]);
                    if (error)
                        return "scoreList." + error;
                }
            }
            return null;
        };

        /**
         * Creates a ScoreNotify message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof Q2Game.ScoreNotify
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {Q2Game.ScoreNotify} ScoreNotify
         */
        ScoreNotify.fromObject = function fromObject(object) {
            if (object instanceof $root.Q2Game.ScoreNotify)
                return object;
            var message = new $root.Q2Game.ScoreNotify();
            if (object.scoreList) {
                if (!Array.isArray(object.scoreList))
                    throw TypeError(".Q2Game.ScoreNotify.scoreList: array expected");
                message.scoreList = [];
                for (var i = 0; i < object.scoreList.length; ++i) {
                    if (typeof object.scoreList[i] !== "object")
                        throw TypeError(".Q2Game.ScoreNotify.scoreList: object expected");
                    message.scoreList[i] = $root.Q2Game.Score.fromObject(object.scoreList[i]);
                }
            }
            return message;
        };

        /**
         * Creates a plain object from a ScoreNotify message. Also converts values to other types if specified.
         * @function toObject
         * @memberof Q2Game.ScoreNotify
         * @static
         * @param {Q2Game.ScoreNotify} message ScoreNotify
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        ScoreNotify.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.arrays || options.defaults)
                object.scoreList = [];
            if (message.scoreList && message.scoreList.length) {
                object.scoreList = [];
                for (var j = 0; j < message.scoreList.length; ++j)
                    object.scoreList[j] = $root.Q2Game.Score.toObject(message.scoreList[j], options);
            }
            return object;
        };

        /**
         * Converts this ScoreNotify to JSON.
         * @function toJSON
         * @memberof Q2Game.ScoreNotify
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        ScoreNotify.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return ScoreNotify;
    })();

    Q2Game.DealCardNotify = (function() {

        /**
         * Properties of a DealCardNotify.
         * @memberof Q2Game
         * @interface IDealCardNotify
         * @property {Array.<Q2Game.ISeatInfo>|null} [seatList] DealCardNotify seatList
         * @property {number|null} [cardPoolLen] DealCardNotify cardPoolLen
         * @property {number|null} [firstCommonCard] DealCardNotify firstCommonCard
         */

        /**
         * Constructs a new DealCardNotify.
         * @memberof Q2Game
         * @classdesc Represents a DealCardNotify.
         * @implements IDealCardNotify
         * @constructor
         * @param {Q2Game.IDealCardNotify=} [properties] Properties to set
         */
        function DealCardNotify(properties) {
            this.seatList = [];
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * DealCardNotify seatList.
         * @member {Array.<Q2Game.ISeatInfo>} seatList
         * @memberof Q2Game.DealCardNotify
         * @instance
         */
        DealCardNotify.prototype.seatList = $util.emptyArray;

        /**
         * DealCardNotify cardPoolLen.
         * @member {number} cardPoolLen
         * @memberof Q2Game.DealCardNotify
         * @instance
         */
        DealCardNotify.prototype.cardPoolLen = 0;

        /**
         * DealCardNotify firstCommonCard.
         * @member {number} firstCommonCard
         * @memberof Q2Game.DealCardNotify
         * @instance
         */
        DealCardNotify.prototype.firstCommonCard = 0;

        /**
         * Creates a new DealCardNotify instance using the specified properties.
         * @function create
         * @memberof Q2Game.DealCardNotify
         * @static
         * @param {Q2Game.IDealCardNotify=} [properties] Properties to set
         * @returns {Q2Game.DealCardNotify} DealCardNotify instance
         */
        DealCardNotify.create = function create(properties) {
            return new DealCardNotify(properties);
        };

        /**
         * Encodes the specified DealCardNotify message. Does not implicitly {@link Q2Game.DealCardNotify.verify|verify} messages.
         * @function encode
         * @memberof Q2Game.DealCardNotify
         * @static
         * @param {Q2Game.IDealCardNotify} message DealCardNotify message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        DealCardNotify.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.seatList != null && message.seatList.length)
                for (var i = 0; i < message.seatList.length; ++i)
                    $root.Q2Game.SeatInfo.encode(message.seatList[i], writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
            if (message.cardPoolLen != null && message.hasOwnProperty("cardPoolLen"))
                writer.uint32(/* id 2, wireType 0 =*/16).int32(message.cardPoolLen);
            if (message.firstCommonCard != null && message.hasOwnProperty("firstCommonCard"))
                writer.uint32(/* id 3, wireType 0 =*/24).int32(message.firstCommonCard);
            return writer;
        };

        /**
         * Encodes the specified DealCardNotify message, length delimited. Does not implicitly {@link Q2Game.DealCardNotify.verify|verify} messages.
         * @function encodeDelimited
         * @memberof Q2Game.DealCardNotify
         * @static
         * @param {Q2Game.IDealCardNotify} message DealCardNotify message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        DealCardNotify.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a DealCardNotify message from the specified reader or buffer.
         * @function decode
         * @memberof Q2Game.DealCardNotify
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {Q2Game.DealCardNotify} DealCardNotify
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        DealCardNotify.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.Q2Game.DealCardNotify();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    if (!(message.seatList && message.seatList.length))
                        message.seatList = [];
                    message.seatList.push($root.Q2Game.SeatInfo.decode(reader, reader.uint32()));
                    break;
                case 2:
                    message.cardPoolLen = reader.int32();
                    break;
                case 3:
                    message.firstCommonCard = reader.int32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a DealCardNotify message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof Q2Game.DealCardNotify
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {Q2Game.DealCardNotify} DealCardNotify
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        DealCardNotify.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a DealCardNotify message.
         * @function verify
         * @memberof Q2Game.DealCardNotify
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        DealCardNotify.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.seatList != null && message.hasOwnProperty("seatList")) {
                if (!Array.isArray(message.seatList))
                    return "seatList: array expected";
                for (var i = 0; i < message.seatList.length; ++i) {
                    var error = $root.Q2Game.SeatInfo.verify(message.seatList[i]);
                    if (error)
                        return "seatList." + error;
                }
            }
            if (message.cardPoolLen != null && message.hasOwnProperty("cardPoolLen"))
                if (!$util.isInteger(message.cardPoolLen))
                    return "cardPoolLen: integer expected";
            if (message.firstCommonCard != null && message.hasOwnProperty("firstCommonCard"))
                if (!$util.isInteger(message.firstCommonCard))
                    return "firstCommonCard: integer expected";
            return null;
        };

        /**
         * Creates a DealCardNotify message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof Q2Game.DealCardNotify
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {Q2Game.DealCardNotify} DealCardNotify
         */
        DealCardNotify.fromObject = function fromObject(object) {
            if (object instanceof $root.Q2Game.DealCardNotify)
                return object;
            var message = new $root.Q2Game.DealCardNotify();
            if (object.seatList) {
                if (!Array.isArray(object.seatList))
                    throw TypeError(".Q2Game.DealCardNotify.seatList: array expected");
                message.seatList = [];
                for (var i = 0; i < object.seatList.length; ++i) {
                    if (typeof object.seatList[i] !== "object")
                        throw TypeError(".Q2Game.DealCardNotify.seatList: object expected");
                    message.seatList[i] = $root.Q2Game.SeatInfo.fromObject(object.seatList[i]);
                }
            }
            if (object.cardPoolLen != null)
                message.cardPoolLen = object.cardPoolLen | 0;
            if (object.firstCommonCard != null)
                message.firstCommonCard = object.firstCommonCard | 0;
            return message;
        };

        /**
         * Creates a plain object from a DealCardNotify message. Also converts values to other types if specified.
         * @function toObject
         * @memberof Q2Game.DealCardNotify
         * @static
         * @param {Q2Game.DealCardNotify} message DealCardNotify
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        DealCardNotify.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.arrays || options.defaults)
                object.seatList = [];
            if (options.defaults) {
                object.cardPoolLen = 0;
                object.firstCommonCard = 0;
            }
            if (message.seatList && message.seatList.length) {
                object.seatList = [];
                for (var j = 0; j < message.seatList.length; ++j)
                    object.seatList[j] = $root.Q2Game.SeatInfo.toObject(message.seatList[j], options);
            }
            if (message.cardPoolLen != null && message.hasOwnProperty("cardPoolLen"))
                object.cardPoolLen = message.cardPoolLen;
            if (message.firstCommonCard != null && message.hasOwnProperty("firstCommonCard"))
                object.firstCommonCard = message.firstCommonCard;
            return object;
        };

        /**
         * Converts this DealCardNotify to JSON.
         * @function toJSON
         * @memberof Q2Game.DealCardNotify
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        DealCardNotify.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return DealCardNotify;
    })();

    Q2Game.MoreCardReq = (function() {

        /**
         * Properties of a MoreCardReq.
         * @memberof Q2Game
         * @interface IMoreCardReq
         */

        /**
         * Constructs a new MoreCardReq.
         * @memberof Q2Game
         * @classdesc Represents a MoreCardReq.
         * @implements IMoreCardReq
         * @constructor
         * @param {Q2Game.IMoreCardReq=} [properties] Properties to set
         */
        function MoreCardReq(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * Creates a new MoreCardReq instance using the specified properties.
         * @function create
         * @memberof Q2Game.MoreCardReq
         * @static
         * @param {Q2Game.IMoreCardReq=} [properties] Properties to set
         * @returns {Q2Game.MoreCardReq} MoreCardReq instance
         */
        MoreCardReq.create = function create(properties) {
            return new MoreCardReq(properties);
        };

        /**
         * Encodes the specified MoreCardReq message. Does not implicitly {@link Q2Game.MoreCardReq.verify|verify} messages.
         * @function encode
         * @memberof Q2Game.MoreCardReq
         * @static
         * @param {Q2Game.IMoreCardReq} message MoreCardReq message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        MoreCardReq.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            return writer;
        };

        /**
         * Encodes the specified MoreCardReq message, length delimited. Does not implicitly {@link Q2Game.MoreCardReq.verify|verify} messages.
         * @function encodeDelimited
         * @memberof Q2Game.MoreCardReq
         * @static
         * @param {Q2Game.IMoreCardReq} message MoreCardReq message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        MoreCardReq.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a MoreCardReq message from the specified reader or buffer.
         * @function decode
         * @memberof Q2Game.MoreCardReq
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {Q2Game.MoreCardReq} MoreCardReq
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        MoreCardReq.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.Q2Game.MoreCardReq();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a MoreCardReq message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof Q2Game.MoreCardReq
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {Q2Game.MoreCardReq} MoreCardReq
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        MoreCardReq.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a MoreCardReq message.
         * @function verify
         * @memberof Q2Game.MoreCardReq
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        MoreCardReq.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            return null;
        };

        /**
         * Creates a MoreCardReq message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof Q2Game.MoreCardReq
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {Q2Game.MoreCardReq} MoreCardReq
         */
        MoreCardReq.fromObject = function fromObject(object) {
            if (object instanceof $root.Q2Game.MoreCardReq)
                return object;
            return new $root.Q2Game.MoreCardReq();
        };

        /**
         * Creates a plain object from a MoreCardReq message. Also converts values to other types if specified.
         * @function toObject
         * @memberof Q2Game.MoreCardReq
         * @static
         * @param {Q2Game.MoreCardReq} message MoreCardReq
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        MoreCardReq.toObject = function toObject() {
            return {};
        };

        /**
         * Converts this MoreCardReq to JSON.
         * @function toJSON
         * @memberof Q2Game.MoreCardReq
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        MoreCardReq.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return MoreCardReq;
    })();

    Q2Game.MoreCardRsp = (function() {

        /**
         * Properties of a MoreCardRsp.
         * @memberof Q2Game
         * @interface IMoreCardRsp
         * @property {number|null} [errNo] MoreCardRsp errNo
         */

        /**
         * Constructs a new MoreCardRsp.
         * @memberof Q2Game
         * @classdesc Represents a MoreCardRsp.
         * @implements IMoreCardRsp
         * @constructor
         * @param {Q2Game.IMoreCardRsp=} [properties] Properties to set
         */
        function MoreCardRsp(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * MoreCardRsp errNo.
         * @member {number} errNo
         * @memberof Q2Game.MoreCardRsp
         * @instance
         */
        MoreCardRsp.prototype.errNo = 0;

        /**
         * Creates a new MoreCardRsp instance using the specified properties.
         * @function create
         * @memberof Q2Game.MoreCardRsp
         * @static
         * @param {Q2Game.IMoreCardRsp=} [properties] Properties to set
         * @returns {Q2Game.MoreCardRsp} MoreCardRsp instance
         */
        MoreCardRsp.create = function create(properties) {
            return new MoreCardRsp(properties);
        };

        /**
         * Encodes the specified MoreCardRsp message. Does not implicitly {@link Q2Game.MoreCardRsp.verify|verify} messages.
         * @function encode
         * @memberof Q2Game.MoreCardRsp
         * @static
         * @param {Q2Game.IMoreCardRsp} message MoreCardRsp message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        MoreCardRsp.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.errNo != null && message.hasOwnProperty("errNo"))
                writer.uint32(/* id 1, wireType 0 =*/8).int32(message.errNo);
            return writer;
        };

        /**
         * Encodes the specified MoreCardRsp message, length delimited. Does not implicitly {@link Q2Game.MoreCardRsp.verify|verify} messages.
         * @function encodeDelimited
         * @memberof Q2Game.MoreCardRsp
         * @static
         * @param {Q2Game.IMoreCardRsp} message MoreCardRsp message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        MoreCardRsp.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a MoreCardRsp message from the specified reader or buffer.
         * @function decode
         * @memberof Q2Game.MoreCardRsp
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {Q2Game.MoreCardRsp} MoreCardRsp
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        MoreCardRsp.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.Q2Game.MoreCardRsp();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.errNo = reader.int32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a MoreCardRsp message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof Q2Game.MoreCardRsp
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {Q2Game.MoreCardRsp} MoreCardRsp
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        MoreCardRsp.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a MoreCardRsp message.
         * @function verify
         * @memberof Q2Game.MoreCardRsp
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        MoreCardRsp.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.errNo != null && message.hasOwnProperty("errNo"))
                if (!$util.isInteger(message.errNo))
                    return "errNo: integer expected";
            return null;
        };

        /**
         * Creates a MoreCardRsp message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof Q2Game.MoreCardRsp
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {Q2Game.MoreCardRsp} MoreCardRsp
         */
        MoreCardRsp.fromObject = function fromObject(object) {
            if (object instanceof $root.Q2Game.MoreCardRsp)
                return object;
            var message = new $root.Q2Game.MoreCardRsp();
            if (object.errNo != null)
                message.errNo = object.errNo | 0;
            return message;
        };

        /**
         * Creates a plain object from a MoreCardRsp message. Also converts values to other types if specified.
         * @function toObject
         * @memberof Q2Game.MoreCardRsp
         * @static
         * @param {Q2Game.MoreCardRsp} message MoreCardRsp
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        MoreCardRsp.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults)
                object.errNo = 0;
            if (message.errNo != null && message.hasOwnProperty("errNo"))
                object.errNo = message.errNo;
            return object;
        };

        /**
         * Converts this MoreCardRsp to JSON.
         * @function toJSON
         * @memberof Q2Game.MoreCardRsp
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        MoreCardRsp.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return MoreCardRsp;
    })();

    Q2Game.MoreCardChangedNotify = (function() {

        /**
         * Properties of a MoreCardChangedNotify.
         * @memberof Q2Game
         * @interface IMoreCardChangedNotify
         * @property {number|null} [card] MoreCardChangedNotify card
         * @property {Q2Game.ISeatInfo|null} [seatInfo] MoreCardChangedNotify seatInfo
         */

        /**
         * Constructs a new MoreCardChangedNotify.
         * @memberof Q2Game
         * @classdesc Represents a MoreCardChangedNotify.
         * @implements IMoreCardChangedNotify
         * @constructor
         * @param {Q2Game.IMoreCardChangedNotify=} [properties] Properties to set
         */
        function MoreCardChangedNotify(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * MoreCardChangedNotify card.
         * @member {number} card
         * @memberof Q2Game.MoreCardChangedNotify
         * @instance
         */
        MoreCardChangedNotify.prototype.card = 0;

        /**
         * MoreCardChangedNotify seatInfo.
         * @member {Q2Game.ISeatInfo|null|undefined} seatInfo
         * @memberof Q2Game.MoreCardChangedNotify
         * @instance
         */
        MoreCardChangedNotify.prototype.seatInfo = null;

        /**
         * Creates a new MoreCardChangedNotify instance using the specified properties.
         * @function create
         * @memberof Q2Game.MoreCardChangedNotify
         * @static
         * @param {Q2Game.IMoreCardChangedNotify=} [properties] Properties to set
         * @returns {Q2Game.MoreCardChangedNotify} MoreCardChangedNotify instance
         */
        MoreCardChangedNotify.create = function create(properties) {
            return new MoreCardChangedNotify(properties);
        };

        /**
         * Encodes the specified MoreCardChangedNotify message. Does not implicitly {@link Q2Game.MoreCardChangedNotify.verify|verify} messages.
         * @function encode
         * @memberof Q2Game.MoreCardChangedNotify
         * @static
         * @param {Q2Game.IMoreCardChangedNotify} message MoreCardChangedNotify message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        MoreCardChangedNotify.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.seatInfo != null && message.hasOwnProperty("seatInfo"))
                $root.Q2Game.SeatInfo.encode(message.seatInfo, writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
            if (message.card != null && message.hasOwnProperty("card"))
                writer.uint32(/* id 3, wireType 0 =*/24).int32(message.card);
            return writer;
        };

        /**
         * Encodes the specified MoreCardChangedNotify message, length delimited. Does not implicitly {@link Q2Game.MoreCardChangedNotify.verify|verify} messages.
         * @function encodeDelimited
         * @memberof Q2Game.MoreCardChangedNotify
         * @static
         * @param {Q2Game.IMoreCardChangedNotify} message MoreCardChangedNotify message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        MoreCardChangedNotify.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a MoreCardChangedNotify message from the specified reader or buffer.
         * @function decode
         * @memberof Q2Game.MoreCardChangedNotify
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {Q2Game.MoreCardChangedNotify} MoreCardChangedNotify
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        MoreCardChangedNotify.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.Q2Game.MoreCardChangedNotify();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 3:
                    message.card = reader.int32();
                    break;
                case 2:
                    message.seatInfo = $root.Q2Game.SeatInfo.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a MoreCardChangedNotify message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof Q2Game.MoreCardChangedNotify
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {Q2Game.MoreCardChangedNotify} MoreCardChangedNotify
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        MoreCardChangedNotify.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a MoreCardChangedNotify message.
         * @function verify
         * @memberof Q2Game.MoreCardChangedNotify
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        MoreCardChangedNotify.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.card != null && message.hasOwnProperty("card"))
                if (!$util.isInteger(message.card))
                    return "card: integer expected";
            if (message.seatInfo != null && message.hasOwnProperty("seatInfo")) {
                var error = $root.Q2Game.SeatInfo.verify(message.seatInfo);
                if (error)
                    return "seatInfo." + error;
            }
            return null;
        };

        /**
         * Creates a MoreCardChangedNotify message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof Q2Game.MoreCardChangedNotify
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {Q2Game.MoreCardChangedNotify} MoreCardChangedNotify
         */
        MoreCardChangedNotify.fromObject = function fromObject(object) {
            if (object instanceof $root.Q2Game.MoreCardChangedNotify)
                return object;
            var message = new $root.Q2Game.MoreCardChangedNotify();
            if (object.card != null)
                message.card = object.card | 0;
            if (object.seatInfo != null) {
                if (typeof object.seatInfo !== "object")
                    throw TypeError(".Q2Game.MoreCardChangedNotify.seatInfo: object expected");
                message.seatInfo = $root.Q2Game.SeatInfo.fromObject(object.seatInfo);
            }
            return message;
        };

        /**
         * Creates a plain object from a MoreCardChangedNotify message. Also converts values to other types if specified.
         * @function toObject
         * @memberof Q2Game.MoreCardChangedNotify
         * @static
         * @param {Q2Game.MoreCardChangedNotify} message MoreCardChangedNotify
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        MoreCardChangedNotify.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                object.seatInfo = null;
                object.card = 0;
            }
            if (message.seatInfo != null && message.hasOwnProperty("seatInfo"))
                object.seatInfo = $root.Q2Game.SeatInfo.toObject(message.seatInfo, options);
            if (message.card != null && message.hasOwnProperty("card"))
                object.card = message.card;
            return object;
        };

        /**
         * Converts this MoreCardChangedNotify to JSON.
         * @function toJSON
         * @memberof Q2Game.MoreCardChangedNotify
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        MoreCardChangedNotify.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return MoreCardChangedNotify;
    })();

    Q2Game.MoreCardNotify = (function() {

        /**
         * Properties of a MoreCardNotify.
         * @memberof Q2Game
         * @interface IMoreCardNotify
         * @property {number|null} [seatId] MoreCardNotify seatId
         * @property {number|null} [cardPoolLen] MoreCardNotify cardPoolLen
         */

        /**
         * Constructs a new MoreCardNotify.
         * @memberof Q2Game
         * @classdesc Represents a MoreCardNotify.
         * @implements IMoreCardNotify
         * @constructor
         * @param {Q2Game.IMoreCardNotify=} [properties] Properties to set
         */
        function MoreCardNotify(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * MoreCardNotify seatId.
         * @member {number} seatId
         * @memberof Q2Game.MoreCardNotify
         * @instance
         */
        MoreCardNotify.prototype.seatId = 0;

        /**
         * MoreCardNotify cardPoolLen.
         * @member {number} cardPoolLen
         * @memberof Q2Game.MoreCardNotify
         * @instance
         */
        MoreCardNotify.prototype.cardPoolLen = 0;

        /**
         * Creates a new MoreCardNotify instance using the specified properties.
         * @function create
         * @memberof Q2Game.MoreCardNotify
         * @static
         * @param {Q2Game.IMoreCardNotify=} [properties] Properties to set
         * @returns {Q2Game.MoreCardNotify} MoreCardNotify instance
         */
        MoreCardNotify.create = function create(properties) {
            return new MoreCardNotify(properties);
        };

        /**
         * Encodes the specified MoreCardNotify message. Does not implicitly {@link Q2Game.MoreCardNotify.verify|verify} messages.
         * @function encode
         * @memberof Q2Game.MoreCardNotify
         * @static
         * @param {Q2Game.IMoreCardNotify} message MoreCardNotify message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        MoreCardNotify.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.seatId != null && message.hasOwnProperty("seatId"))
                writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.seatId);
            if (message.cardPoolLen != null && message.hasOwnProperty("cardPoolLen"))
                writer.uint32(/* id 8, wireType 0 =*/64).int32(message.cardPoolLen);
            return writer;
        };

        /**
         * Encodes the specified MoreCardNotify message, length delimited. Does not implicitly {@link Q2Game.MoreCardNotify.verify|verify} messages.
         * @function encodeDelimited
         * @memberof Q2Game.MoreCardNotify
         * @static
         * @param {Q2Game.IMoreCardNotify} message MoreCardNotify message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        MoreCardNotify.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a MoreCardNotify message from the specified reader or buffer.
         * @function decode
         * @memberof Q2Game.MoreCardNotify
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {Q2Game.MoreCardNotify} MoreCardNotify
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        MoreCardNotify.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.Q2Game.MoreCardNotify();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.seatId = reader.uint32();
                    break;
                case 8:
                    message.cardPoolLen = reader.int32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a MoreCardNotify message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof Q2Game.MoreCardNotify
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {Q2Game.MoreCardNotify} MoreCardNotify
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        MoreCardNotify.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a MoreCardNotify message.
         * @function verify
         * @memberof Q2Game.MoreCardNotify
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        MoreCardNotify.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.seatId != null && message.hasOwnProperty("seatId"))
                if (!$util.isInteger(message.seatId))
                    return "seatId: integer expected";
            if (message.cardPoolLen != null && message.hasOwnProperty("cardPoolLen"))
                if (!$util.isInteger(message.cardPoolLen))
                    return "cardPoolLen: integer expected";
            return null;
        };

        /**
         * Creates a MoreCardNotify message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof Q2Game.MoreCardNotify
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {Q2Game.MoreCardNotify} MoreCardNotify
         */
        MoreCardNotify.fromObject = function fromObject(object) {
            if (object instanceof $root.Q2Game.MoreCardNotify)
                return object;
            var message = new $root.Q2Game.MoreCardNotify();
            if (object.seatId != null)
                message.seatId = object.seatId >>> 0;
            if (object.cardPoolLen != null)
                message.cardPoolLen = object.cardPoolLen | 0;
            return message;
        };

        /**
         * Creates a plain object from a MoreCardNotify message. Also converts values to other types if specified.
         * @function toObject
         * @memberof Q2Game.MoreCardNotify
         * @static
         * @param {Q2Game.MoreCardNotify} message MoreCardNotify
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        MoreCardNotify.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                object.seatId = 0;
                object.cardPoolLen = 0;
            }
            if (message.seatId != null && message.hasOwnProperty("seatId"))
                object.seatId = message.seatId;
            if (message.cardPoolLen != null && message.hasOwnProperty("cardPoolLen"))
                object.cardPoolLen = message.cardPoolLen;
            return object;
        };

        /**
         * Converts this MoreCardNotify to JSON.
         * @function toJSON
         * @memberof Q2Game.MoreCardNotify
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        MoreCardNotify.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return MoreCardNotify;
    })();

    Q2Game.RaiseReq = (function() {

        /**
         * Properties of a RaiseReq.
         * @memberof Q2Game
         * @interface IRaiseReq
         * @property {Array.<number>|null} [cards] RaiseReq cards
         * @property {Array.<number>|null} [targetCards] RaiseReq targetCards
         */

        /**
         * Constructs a new RaiseReq.
         * @memberof Q2Game
         * @classdesc Represents a RaiseReq.
         * @implements IRaiseReq
         * @constructor
         * @param {Q2Game.IRaiseReq=} [properties] Properties to set
         */
        function RaiseReq(properties) {
            this.cards = [];
            this.targetCards = [];
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * RaiseReq cards.
         * @member {Array.<number>} cards
         * @memberof Q2Game.RaiseReq
         * @instance
         */
        RaiseReq.prototype.cards = $util.emptyArray;

        /**
         * RaiseReq targetCards.
         * @member {Array.<number>} targetCards
         * @memberof Q2Game.RaiseReq
         * @instance
         */
        RaiseReq.prototype.targetCards = $util.emptyArray;

        /**
         * Creates a new RaiseReq instance using the specified properties.
         * @function create
         * @memberof Q2Game.RaiseReq
         * @static
         * @param {Q2Game.IRaiseReq=} [properties] Properties to set
         * @returns {Q2Game.RaiseReq} RaiseReq instance
         */
        RaiseReq.create = function create(properties) {
            return new RaiseReq(properties);
        };

        /**
         * Encodes the specified RaiseReq message. Does not implicitly {@link Q2Game.RaiseReq.verify|verify} messages.
         * @function encode
         * @memberof Q2Game.RaiseReq
         * @static
         * @param {Q2Game.IRaiseReq} message RaiseReq message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        RaiseReq.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.cards != null && message.cards.length)
                for (var i = 0; i < message.cards.length; ++i)
                    writer.uint32(/* id 1, wireType 0 =*/8).int32(message.cards[i]);
            if (message.targetCards != null && message.targetCards.length)
                for (var i = 0; i < message.targetCards.length; ++i)
                    writer.uint32(/* id 3, wireType 0 =*/24).int32(message.targetCards[i]);
            return writer;
        };

        /**
         * Encodes the specified RaiseReq message, length delimited. Does not implicitly {@link Q2Game.RaiseReq.verify|verify} messages.
         * @function encodeDelimited
         * @memberof Q2Game.RaiseReq
         * @static
         * @param {Q2Game.IRaiseReq} message RaiseReq message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        RaiseReq.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a RaiseReq message from the specified reader or buffer.
         * @function decode
         * @memberof Q2Game.RaiseReq
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {Q2Game.RaiseReq} RaiseReq
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        RaiseReq.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.Q2Game.RaiseReq();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    if (!(message.cards && message.cards.length))
                        message.cards = [];
                    if ((tag & 7) === 2) {
                        var end2 = reader.uint32() + reader.pos;
                        while (reader.pos < end2)
                            message.cards.push(reader.int32());
                    } else
                        message.cards.push(reader.int32());
                    break;
                case 3:
                    if (!(message.targetCards && message.targetCards.length))
                        message.targetCards = [];
                    if ((tag & 7) === 2) {
                        var end2 = reader.uint32() + reader.pos;
                        while (reader.pos < end2)
                            message.targetCards.push(reader.int32());
                    } else
                        message.targetCards.push(reader.int32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a RaiseReq message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof Q2Game.RaiseReq
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {Q2Game.RaiseReq} RaiseReq
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        RaiseReq.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a RaiseReq message.
         * @function verify
         * @memberof Q2Game.RaiseReq
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        RaiseReq.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.cards != null && message.hasOwnProperty("cards")) {
                if (!Array.isArray(message.cards))
                    return "cards: array expected";
                for (var i = 0; i < message.cards.length; ++i)
                    if (!$util.isInteger(message.cards[i]))
                        return "cards: integer[] expected";
            }
            if (message.targetCards != null && message.hasOwnProperty("targetCards")) {
                if (!Array.isArray(message.targetCards))
                    return "targetCards: array expected";
                for (var i = 0; i < message.targetCards.length; ++i)
                    if (!$util.isInteger(message.targetCards[i]))
                        return "targetCards: integer[] expected";
            }
            return null;
        };

        /**
         * Creates a RaiseReq message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof Q2Game.RaiseReq
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {Q2Game.RaiseReq} RaiseReq
         */
        RaiseReq.fromObject = function fromObject(object) {
            if (object instanceof $root.Q2Game.RaiseReq)
                return object;
            var message = new $root.Q2Game.RaiseReq();
            if (object.cards) {
                if (!Array.isArray(object.cards))
                    throw TypeError(".Q2Game.RaiseReq.cards: array expected");
                message.cards = [];
                for (var i = 0; i < object.cards.length; ++i)
                    message.cards[i] = object.cards[i] | 0;
            }
            if (object.targetCards) {
                if (!Array.isArray(object.targetCards))
                    throw TypeError(".Q2Game.RaiseReq.targetCards: array expected");
                message.targetCards = [];
                for (var i = 0; i < object.targetCards.length; ++i)
                    message.targetCards[i] = object.targetCards[i] | 0;
            }
            return message;
        };

        /**
         * Creates a plain object from a RaiseReq message. Also converts values to other types if specified.
         * @function toObject
         * @memberof Q2Game.RaiseReq
         * @static
         * @param {Q2Game.RaiseReq} message RaiseReq
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        RaiseReq.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.arrays || options.defaults) {
                object.cards = [];
                object.targetCards = [];
            }
            if (message.cards && message.cards.length) {
                object.cards = [];
                for (var j = 0; j < message.cards.length; ++j)
                    object.cards[j] = message.cards[j];
            }
            if (message.targetCards && message.targetCards.length) {
                object.targetCards = [];
                for (var j = 0; j < message.targetCards.length; ++j)
                    object.targetCards[j] = message.targetCards[j];
            }
            return object;
        };

        /**
         * Converts this RaiseReq to JSON.
         * @function toJSON
         * @memberof Q2Game.RaiseReq
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        RaiseReq.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return RaiseReq;
    })();

    Q2Game.RaiseRsp = (function() {

        /**
         * Properties of a RaiseRsp.
         * @memberof Q2Game
         * @interface IRaiseRsp
         * @property {number|null} [errNo] RaiseRsp errNo
         * @property {Q2Game.ISeatInfo|null} [seatInfo] RaiseRsp seatInfo
         */

        /**
         * Constructs a new RaiseRsp.
         * @memberof Q2Game
         * @classdesc Represents a RaiseRsp.
         * @implements IRaiseRsp
         * @constructor
         * @param {Q2Game.IRaiseRsp=} [properties] Properties to set
         */
        function RaiseRsp(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * RaiseRsp errNo.
         * @member {number} errNo
         * @memberof Q2Game.RaiseRsp
         * @instance
         */
        RaiseRsp.prototype.errNo = 0;

        /**
         * RaiseRsp seatInfo.
         * @member {Q2Game.ISeatInfo|null|undefined} seatInfo
         * @memberof Q2Game.RaiseRsp
         * @instance
         */
        RaiseRsp.prototype.seatInfo = null;

        /**
         * Creates a new RaiseRsp instance using the specified properties.
         * @function create
         * @memberof Q2Game.RaiseRsp
         * @static
         * @param {Q2Game.IRaiseRsp=} [properties] Properties to set
         * @returns {Q2Game.RaiseRsp} RaiseRsp instance
         */
        RaiseRsp.create = function create(properties) {
            return new RaiseRsp(properties);
        };

        /**
         * Encodes the specified RaiseRsp message. Does not implicitly {@link Q2Game.RaiseRsp.verify|verify} messages.
         * @function encode
         * @memberof Q2Game.RaiseRsp
         * @static
         * @param {Q2Game.IRaiseRsp} message RaiseRsp message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        RaiseRsp.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.errNo != null && message.hasOwnProperty("errNo"))
                writer.uint32(/* id 1, wireType 0 =*/8).int32(message.errNo);
            if (message.seatInfo != null && message.hasOwnProperty("seatInfo"))
                $root.Q2Game.SeatInfo.encode(message.seatInfo, writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
            return writer;
        };

        /**
         * Encodes the specified RaiseRsp message, length delimited. Does not implicitly {@link Q2Game.RaiseRsp.verify|verify} messages.
         * @function encodeDelimited
         * @memberof Q2Game.RaiseRsp
         * @static
         * @param {Q2Game.IRaiseRsp} message RaiseRsp message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        RaiseRsp.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a RaiseRsp message from the specified reader or buffer.
         * @function decode
         * @memberof Q2Game.RaiseRsp
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {Q2Game.RaiseRsp} RaiseRsp
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        RaiseRsp.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.Q2Game.RaiseRsp();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.errNo = reader.int32();
                    break;
                case 2:
                    message.seatInfo = $root.Q2Game.SeatInfo.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a RaiseRsp message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof Q2Game.RaiseRsp
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {Q2Game.RaiseRsp} RaiseRsp
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        RaiseRsp.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a RaiseRsp message.
         * @function verify
         * @memberof Q2Game.RaiseRsp
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        RaiseRsp.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.errNo != null && message.hasOwnProperty("errNo"))
                if (!$util.isInteger(message.errNo))
                    return "errNo: integer expected";
            if (message.seatInfo != null && message.hasOwnProperty("seatInfo")) {
                var error = $root.Q2Game.SeatInfo.verify(message.seatInfo);
                if (error)
                    return "seatInfo." + error;
            }
            return null;
        };

        /**
         * Creates a RaiseRsp message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof Q2Game.RaiseRsp
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {Q2Game.RaiseRsp} RaiseRsp
         */
        RaiseRsp.fromObject = function fromObject(object) {
            if (object instanceof $root.Q2Game.RaiseRsp)
                return object;
            var message = new $root.Q2Game.RaiseRsp();
            if (object.errNo != null)
                message.errNo = object.errNo | 0;
            if (object.seatInfo != null) {
                if (typeof object.seatInfo !== "object")
                    throw TypeError(".Q2Game.RaiseRsp.seatInfo: object expected");
                message.seatInfo = $root.Q2Game.SeatInfo.fromObject(object.seatInfo);
            }
            return message;
        };

        /**
         * Creates a plain object from a RaiseRsp message. Also converts values to other types if specified.
         * @function toObject
         * @memberof Q2Game.RaiseRsp
         * @static
         * @param {Q2Game.RaiseRsp} message RaiseRsp
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        RaiseRsp.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                object.errNo = 0;
                object.seatInfo = null;
            }
            if (message.errNo != null && message.hasOwnProperty("errNo"))
                object.errNo = message.errNo;
            if (message.seatInfo != null && message.hasOwnProperty("seatInfo"))
                object.seatInfo = $root.Q2Game.SeatInfo.toObject(message.seatInfo, options);
            return object;
        };

        /**
         * Converts this RaiseRsp to JSON.
         * @function toJSON
         * @memberof Q2Game.RaiseRsp
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        RaiseRsp.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return RaiseRsp;
    })();

    Q2Game.RaiseNotify = (function() {

        /**
         * Properties of a RaiseNotify.
         * @memberof Q2Game
         * @interface IRaiseNotify
         * @property {number|null} [seatId] RaiseNotify seatId
         * @property {Array.<number>|null} [commonCards] RaiseNotify commonCards
         * @property {Q2Game.ICardPattern|null} [pattern] RaiseNotify pattern
         * @property {Array.<number>|null} [cards] RaiseNotify cards
         * @property {boolean|null} [fromCompleteProcess] RaiseNotify fromCompleteProcess
         */

        /**
         * Constructs a new RaiseNotify.
         * @memberof Q2Game
         * @classdesc Represents a RaiseNotify.
         * @implements IRaiseNotify
         * @constructor
         * @param {Q2Game.IRaiseNotify=} [properties] Properties to set
         */
        function RaiseNotify(properties) {
            this.commonCards = [];
            this.cards = [];
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * RaiseNotify seatId.
         * @member {number} seatId
         * @memberof Q2Game.RaiseNotify
         * @instance
         */
        RaiseNotify.prototype.seatId = 0;

        /**
         * RaiseNotify commonCards.
         * @member {Array.<number>} commonCards
         * @memberof Q2Game.RaiseNotify
         * @instance
         */
        RaiseNotify.prototype.commonCards = $util.emptyArray;

        /**
         * RaiseNotify pattern.
         * @member {Q2Game.ICardPattern|null|undefined} pattern
         * @memberof Q2Game.RaiseNotify
         * @instance
         */
        RaiseNotify.prototype.pattern = null;

        /**
         * RaiseNotify cards.
         * @member {Array.<number>} cards
         * @memberof Q2Game.RaiseNotify
         * @instance
         */
        RaiseNotify.prototype.cards = $util.emptyArray;

        /**
         * RaiseNotify fromCompleteProcess.
         * @member {boolean} fromCompleteProcess
         * @memberof Q2Game.RaiseNotify
         * @instance
         */
        RaiseNotify.prototype.fromCompleteProcess = false;

        /**
         * Creates a new RaiseNotify instance using the specified properties.
         * @function create
         * @memberof Q2Game.RaiseNotify
         * @static
         * @param {Q2Game.IRaiseNotify=} [properties] Properties to set
         * @returns {Q2Game.RaiseNotify} RaiseNotify instance
         */
        RaiseNotify.create = function create(properties) {
            return new RaiseNotify(properties);
        };

        /**
         * Encodes the specified RaiseNotify message. Does not implicitly {@link Q2Game.RaiseNotify.verify|verify} messages.
         * @function encode
         * @memberof Q2Game.RaiseNotify
         * @static
         * @param {Q2Game.IRaiseNotify} message RaiseNotify message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        RaiseNotify.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.seatId != null && message.hasOwnProperty("seatId"))
                writer.uint32(/* id 1, wireType 0 =*/8).int32(message.seatId);
            if (message.commonCards != null && message.commonCards.length)
                for (var i = 0; i < message.commonCards.length; ++i)
                    writer.uint32(/* id 2, wireType 0 =*/16).int32(message.commonCards[i]);
            if (message.pattern != null && message.hasOwnProperty("pattern"))
                $root.Q2Game.CardPattern.encode(message.pattern, writer.uint32(/* id 3, wireType 2 =*/26).fork()).ldelim();
            if (message.cards != null && message.cards.length)
                for (var i = 0; i < message.cards.length; ++i)
                    writer.uint32(/* id 4, wireType 0 =*/32).int32(message.cards[i]);
            if (message.fromCompleteProcess != null && message.hasOwnProperty("fromCompleteProcess"))
                writer.uint32(/* id 5, wireType 0 =*/40).bool(message.fromCompleteProcess);
            return writer;
        };

        /**
         * Encodes the specified RaiseNotify message, length delimited. Does not implicitly {@link Q2Game.RaiseNotify.verify|verify} messages.
         * @function encodeDelimited
         * @memberof Q2Game.RaiseNotify
         * @static
         * @param {Q2Game.IRaiseNotify} message RaiseNotify message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        RaiseNotify.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a RaiseNotify message from the specified reader or buffer.
         * @function decode
         * @memberof Q2Game.RaiseNotify
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {Q2Game.RaiseNotify} RaiseNotify
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        RaiseNotify.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.Q2Game.RaiseNotify();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.seatId = reader.int32();
                    break;
                case 2:
                    if (!(message.commonCards && message.commonCards.length))
                        message.commonCards = [];
                    if ((tag & 7) === 2) {
                        var end2 = reader.uint32() + reader.pos;
                        while (reader.pos < end2)
                            message.commonCards.push(reader.int32());
                    } else
                        message.commonCards.push(reader.int32());
                    break;
                case 3:
                    message.pattern = $root.Q2Game.CardPattern.decode(reader, reader.uint32());
                    break;
                case 4:
                    if (!(message.cards && message.cards.length))
                        message.cards = [];
                    if ((tag & 7) === 2) {
                        var end2 = reader.uint32() + reader.pos;
                        while (reader.pos < end2)
                            message.cards.push(reader.int32());
                    } else
                        message.cards.push(reader.int32());
                    break;
                case 5:
                    message.fromCompleteProcess = reader.bool();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a RaiseNotify message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof Q2Game.RaiseNotify
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {Q2Game.RaiseNotify} RaiseNotify
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        RaiseNotify.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a RaiseNotify message.
         * @function verify
         * @memberof Q2Game.RaiseNotify
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        RaiseNotify.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.seatId != null && message.hasOwnProperty("seatId"))
                if (!$util.isInteger(message.seatId))
                    return "seatId: integer expected";
            if (message.commonCards != null && message.hasOwnProperty("commonCards")) {
                if (!Array.isArray(message.commonCards))
                    return "commonCards: array expected";
                for (var i = 0; i < message.commonCards.length; ++i)
                    if (!$util.isInteger(message.commonCards[i]))
                        return "commonCards: integer[] expected";
            }
            if (message.pattern != null && message.hasOwnProperty("pattern")) {
                var error = $root.Q2Game.CardPattern.verify(message.pattern);
                if (error)
                    return "pattern." + error;
            }
            if (message.cards != null && message.hasOwnProperty("cards")) {
                if (!Array.isArray(message.cards))
                    return "cards: array expected";
                for (var i = 0; i < message.cards.length; ++i)
                    if (!$util.isInteger(message.cards[i]))
                        return "cards: integer[] expected";
            }
            if (message.fromCompleteProcess != null && message.hasOwnProperty("fromCompleteProcess"))
                if (typeof message.fromCompleteProcess !== "boolean")
                    return "fromCompleteProcess: boolean expected";
            return null;
        };

        /**
         * Creates a RaiseNotify message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof Q2Game.RaiseNotify
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {Q2Game.RaiseNotify} RaiseNotify
         */
        RaiseNotify.fromObject = function fromObject(object) {
            if (object instanceof $root.Q2Game.RaiseNotify)
                return object;
            var message = new $root.Q2Game.RaiseNotify();
            if (object.seatId != null)
                message.seatId = object.seatId | 0;
            if (object.commonCards) {
                if (!Array.isArray(object.commonCards))
                    throw TypeError(".Q2Game.RaiseNotify.commonCards: array expected");
                message.commonCards = [];
                for (var i = 0; i < object.commonCards.length; ++i)
                    message.commonCards[i] = object.commonCards[i] | 0;
            }
            if (object.pattern != null) {
                if (typeof object.pattern !== "object")
                    throw TypeError(".Q2Game.RaiseNotify.pattern: object expected");
                message.pattern = $root.Q2Game.CardPattern.fromObject(object.pattern);
            }
            if (object.cards) {
                if (!Array.isArray(object.cards))
                    throw TypeError(".Q2Game.RaiseNotify.cards: array expected");
                message.cards = [];
                for (var i = 0; i < object.cards.length; ++i)
                    message.cards[i] = object.cards[i] | 0;
            }
            if (object.fromCompleteProcess != null)
                message.fromCompleteProcess = Boolean(object.fromCompleteProcess);
            return message;
        };

        /**
         * Creates a plain object from a RaiseNotify message. Also converts values to other types if specified.
         * @function toObject
         * @memberof Q2Game.RaiseNotify
         * @static
         * @param {Q2Game.RaiseNotify} message RaiseNotify
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        RaiseNotify.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.arrays || options.defaults) {
                object.commonCards = [];
                object.cards = [];
            }
            if (options.defaults) {
                object.seatId = 0;
                object.pattern = null;
                object.fromCompleteProcess = false;
            }
            if (message.seatId != null && message.hasOwnProperty("seatId"))
                object.seatId = message.seatId;
            if (message.commonCards && message.commonCards.length) {
                object.commonCards = [];
                for (var j = 0; j < message.commonCards.length; ++j)
                    object.commonCards[j] = message.commonCards[j];
            }
            if (message.pattern != null && message.hasOwnProperty("pattern"))
                object.pattern = $root.Q2Game.CardPattern.toObject(message.pattern, options);
            if (message.cards && message.cards.length) {
                object.cards = [];
                for (var j = 0; j < message.cards.length; ++j)
                    object.cards[j] = message.cards[j];
            }
            if (message.fromCompleteProcess != null && message.hasOwnProperty("fromCompleteProcess"))
                object.fromCompleteProcess = message.fromCompleteProcess;
            return object;
        };

        /**
         * Converts this RaiseNotify to JSON.
         * @function toJSON
         * @memberof Q2Game.RaiseNotify
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        RaiseNotify.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return RaiseNotify;
    })();

    Q2Game.AttachReq = (function() {

        /**
         * Properties of an AttachReq.
         * @memberof Q2Game
         * @interface IAttachReq
         * @property {number|null} [targetSeat] AttachReq targetSeat
         * @property {number|null} [card] AttachReq card
         * @property {Array.<number>|null} [targetCards] AttachReq targetCards
         */

        /**
         * Constructs a new AttachReq.
         * @memberof Q2Game
         * @classdesc Represents an AttachReq.
         * @implements IAttachReq
         * @constructor
         * @param {Q2Game.IAttachReq=} [properties] Properties to set
         */
        function AttachReq(properties) {
            this.targetCards = [];
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * AttachReq targetSeat.
         * @member {number} targetSeat
         * @memberof Q2Game.AttachReq
         * @instance
         */
        AttachReq.prototype.targetSeat = 0;

        /**
         * AttachReq card.
         * @member {number} card
         * @memberof Q2Game.AttachReq
         * @instance
         */
        AttachReq.prototype.card = 0;

        /**
         * AttachReq targetCards.
         * @member {Array.<number>} targetCards
         * @memberof Q2Game.AttachReq
         * @instance
         */
        AttachReq.prototype.targetCards = $util.emptyArray;

        /**
         * Creates a new AttachReq instance using the specified properties.
         * @function create
         * @memberof Q2Game.AttachReq
         * @static
         * @param {Q2Game.IAttachReq=} [properties] Properties to set
         * @returns {Q2Game.AttachReq} AttachReq instance
         */
        AttachReq.create = function create(properties) {
            return new AttachReq(properties);
        };

        /**
         * Encodes the specified AttachReq message. Does not implicitly {@link Q2Game.AttachReq.verify|verify} messages.
         * @function encode
         * @memberof Q2Game.AttachReq
         * @static
         * @param {Q2Game.IAttachReq} message AttachReq message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        AttachReq.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.targetSeat != null && message.hasOwnProperty("targetSeat"))
                writer.uint32(/* id 1, wireType 0 =*/8).int32(message.targetSeat);
            if (message.card != null && message.hasOwnProperty("card"))
                writer.uint32(/* id 2, wireType 0 =*/16).int32(message.card);
            if (message.targetCards != null && message.targetCards.length)
                for (var i = 0; i < message.targetCards.length; ++i)
                    writer.uint32(/* id 3, wireType 0 =*/24).int32(message.targetCards[i]);
            return writer;
        };

        /**
         * Encodes the specified AttachReq message, length delimited. Does not implicitly {@link Q2Game.AttachReq.verify|verify} messages.
         * @function encodeDelimited
         * @memberof Q2Game.AttachReq
         * @static
         * @param {Q2Game.IAttachReq} message AttachReq message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        AttachReq.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes an AttachReq message from the specified reader or buffer.
         * @function decode
         * @memberof Q2Game.AttachReq
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {Q2Game.AttachReq} AttachReq
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        AttachReq.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.Q2Game.AttachReq();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.targetSeat = reader.int32();
                    break;
                case 2:
                    message.card = reader.int32();
                    break;
                case 3:
                    if (!(message.targetCards && message.targetCards.length))
                        message.targetCards = [];
                    if ((tag & 7) === 2) {
                        var end2 = reader.uint32() + reader.pos;
                        while (reader.pos < end2)
                            message.targetCards.push(reader.int32());
                    } else
                        message.targetCards.push(reader.int32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes an AttachReq message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof Q2Game.AttachReq
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {Q2Game.AttachReq} AttachReq
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        AttachReq.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies an AttachReq message.
         * @function verify
         * @memberof Q2Game.AttachReq
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        AttachReq.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.targetSeat != null && message.hasOwnProperty("targetSeat"))
                if (!$util.isInteger(message.targetSeat))
                    return "targetSeat: integer expected";
            if (message.card != null && message.hasOwnProperty("card"))
                if (!$util.isInteger(message.card))
                    return "card: integer expected";
            if (message.targetCards != null && message.hasOwnProperty("targetCards")) {
                if (!Array.isArray(message.targetCards))
                    return "targetCards: array expected";
                for (var i = 0; i < message.targetCards.length; ++i)
                    if (!$util.isInteger(message.targetCards[i]))
                        return "targetCards: integer[] expected";
            }
            return null;
        };

        /**
         * Creates an AttachReq message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof Q2Game.AttachReq
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {Q2Game.AttachReq} AttachReq
         */
        AttachReq.fromObject = function fromObject(object) {
            if (object instanceof $root.Q2Game.AttachReq)
                return object;
            var message = new $root.Q2Game.AttachReq();
            if (object.targetSeat != null)
                message.targetSeat = object.targetSeat | 0;
            if (object.card != null)
                message.card = object.card | 0;
            if (object.targetCards) {
                if (!Array.isArray(object.targetCards))
                    throw TypeError(".Q2Game.AttachReq.targetCards: array expected");
                message.targetCards = [];
                for (var i = 0; i < object.targetCards.length; ++i)
                    message.targetCards[i] = object.targetCards[i] | 0;
            }
            return message;
        };

        /**
         * Creates a plain object from an AttachReq message. Also converts values to other types if specified.
         * @function toObject
         * @memberof Q2Game.AttachReq
         * @static
         * @param {Q2Game.AttachReq} message AttachReq
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        AttachReq.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.arrays || options.defaults)
                object.targetCards = [];
            if (options.defaults) {
                object.targetSeat = 0;
                object.card = 0;
            }
            if (message.targetSeat != null && message.hasOwnProperty("targetSeat"))
                object.targetSeat = message.targetSeat;
            if (message.card != null && message.hasOwnProperty("card"))
                object.card = message.card;
            if (message.targetCards && message.targetCards.length) {
                object.targetCards = [];
                for (var j = 0; j < message.targetCards.length; ++j)
                    object.targetCards[j] = message.targetCards[j];
            }
            return object;
        };

        /**
         * Converts this AttachReq to JSON.
         * @function toJSON
         * @memberof Q2Game.AttachReq
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        AttachReq.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return AttachReq;
    })();

    Q2Game.AttachRsp = (function() {

        /**
         * Properties of an AttachRsp.
         * @memberof Q2Game
         * @interface IAttachRsp
         * @property {number|null} [errNo] AttachRsp errNo
         * @property {Q2Game.ISeatInfo|null} [seatInfo] AttachRsp seatInfo
         */

        /**
         * Constructs a new AttachRsp.
         * @memberof Q2Game
         * @classdesc Represents an AttachRsp.
         * @implements IAttachRsp
         * @constructor
         * @param {Q2Game.IAttachRsp=} [properties] Properties to set
         */
        function AttachRsp(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * AttachRsp errNo.
         * @member {number} errNo
         * @memberof Q2Game.AttachRsp
         * @instance
         */
        AttachRsp.prototype.errNo = 0;

        /**
         * AttachRsp seatInfo.
         * @member {Q2Game.ISeatInfo|null|undefined} seatInfo
         * @memberof Q2Game.AttachRsp
         * @instance
         */
        AttachRsp.prototype.seatInfo = null;

        /**
         * Creates a new AttachRsp instance using the specified properties.
         * @function create
         * @memberof Q2Game.AttachRsp
         * @static
         * @param {Q2Game.IAttachRsp=} [properties] Properties to set
         * @returns {Q2Game.AttachRsp} AttachRsp instance
         */
        AttachRsp.create = function create(properties) {
            return new AttachRsp(properties);
        };

        /**
         * Encodes the specified AttachRsp message. Does not implicitly {@link Q2Game.AttachRsp.verify|verify} messages.
         * @function encode
         * @memberof Q2Game.AttachRsp
         * @static
         * @param {Q2Game.IAttachRsp} message AttachRsp message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        AttachRsp.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.errNo != null && message.hasOwnProperty("errNo"))
                writer.uint32(/* id 1, wireType 0 =*/8).int32(message.errNo);
            if (message.seatInfo != null && message.hasOwnProperty("seatInfo"))
                $root.Q2Game.SeatInfo.encode(message.seatInfo, writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
            return writer;
        };

        /**
         * Encodes the specified AttachRsp message, length delimited. Does not implicitly {@link Q2Game.AttachRsp.verify|verify} messages.
         * @function encodeDelimited
         * @memberof Q2Game.AttachRsp
         * @static
         * @param {Q2Game.IAttachRsp} message AttachRsp message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        AttachRsp.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes an AttachRsp message from the specified reader or buffer.
         * @function decode
         * @memberof Q2Game.AttachRsp
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {Q2Game.AttachRsp} AttachRsp
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        AttachRsp.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.Q2Game.AttachRsp();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.errNo = reader.int32();
                    break;
                case 2:
                    message.seatInfo = $root.Q2Game.SeatInfo.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes an AttachRsp message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof Q2Game.AttachRsp
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {Q2Game.AttachRsp} AttachRsp
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        AttachRsp.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies an AttachRsp message.
         * @function verify
         * @memberof Q2Game.AttachRsp
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        AttachRsp.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.errNo != null && message.hasOwnProperty("errNo"))
                if (!$util.isInteger(message.errNo))
                    return "errNo: integer expected";
            if (message.seatInfo != null && message.hasOwnProperty("seatInfo")) {
                var error = $root.Q2Game.SeatInfo.verify(message.seatInfo);
                if (error)
                    return "seatInfo." + error;
            }
            return null;
        };

        /**
         * Creates an AttachRsp message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof Q2Game.AttachRsp
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {Q2Game.AttachRsp} AttachRsp
         */
        AttachRsp.fromObject = function fromObject(object) {
            if (object instanceof $root.Q2Game.AttachRsp)
                return object;
            var message = new $root.Q2Game.AttachRsp();
            if (object.errNo != null)
                message.errNo = object.errNo | 0;
            if (object.seatInfo != null) {
                if (typeof object.seatInfo !== "object")
                    throw TypeError(".Q2Game.AttachRsp.seatInfo: object expected");
                message.seatInfo = $root.Q2Game.SeatInfo.fromObject(object.seatInfo);
            }
            return message;
        };

        /**
         * Creates a plain object from an AttachRsp message. Also converts values to other types if specified.
         * @function toObject
         * @memberof Q2Game.AttachRsp
         * @static
         * @param {Q2Game.AttachRsp} message AttachRsp
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        AttachRsp.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                object.errNo = 0;
                object.seatInfo = null;
            }
            if (message.errNo != null && message.hasOwnProperty("errNo"))
                object.errNo = message.errNo;
            if (message.seatInfo != null && message.hasOwnProperty("seatInfo"))
                object.seatInfo = $root.Q2Game.SeatInfo.toObject(message.seatInfo, options);
            return object;
        };

        /**
         * Converts this AttachRsp to JSON.
         * @function toJSON
         * @memberof Q2Game.AttachRsp
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        AttachRsp.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return AttachRsp;
    })();

    Q2Game.AttachNotify = (function() {

        /**
         * Properties of an AttachNotify.
         * @memberof Q2Game
         * @interface IAttachNotify
         * @property {number|null} [seatId] AttachNotify seatId
         * @property {number|null} [targetSeat] AttachNotify targetSeat
         * @property {number|null} [card] AttachNotify card
         * @property {Q2Game.ICardPattern|null} [pattern] AttachNotify pattern
         * @property {boolean|null} [fromCompleteProcess] AttachNotify fromCompleteProcess
         */

        /**
         * Constructs a new AttachNotify.
         * @memberof Q2Game
         * @classdesc Represents an AttachNotify.
         * @implements IAttachNotify
         * @constructor
         * @param {Q2Game.IAttachNotify=} [properties] Properties to set
         */
        function AttachNotify(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * AttachNotify seatId.
         * @member {number} seatId
         * @memberof Q2Game.AttachNotify
         * @instance
         */
        AttachNotify.prototype.seatId = 0;

        /**
         * AttachNotify targetSeat.
         * @member {number} targetSeat
         * @memberof Q2Game.AttachNotify
         * @instance
         */
        AttachNotify.prototype.targetSeat = 0;

        /**
         * AttachNotify card.
         * @member {number} card
         * @memberof Q2Game.AttachNotify
         * @instance
         */
        AttachNotify.prototype.card = 0;

        /**
         * AttachNotify pattern.
         * @member {Q2Game.ICardPattern|null|undefined} pattern
         * @memberof Q2Game.AttachNotify
         * @instance
         */
        AttachNotify.prototype.pattern = null;

        /**
         * AttachNotify fromCompleteProcess.
         * @member {boolean} fromCompleteProcess
         * @memberof Q2Game.AttachNotify
         * @instance
         */
        AttachNotify.prototype.fromCompleteProcess = false;

        /**
         * Creates a new AttachNotify instance using the specified properties.
         * @function create
         * @memberof Q2Game.AttachNotify
         * @static
         * @param {Q2Game.IAttachNotify=} [properties] Properties to set
         * @returns {Q2Game.AttachNotify} AttachNotify instance
         */
        AttachNotify.create = function create(properties) {
            return new AttachNotify(properties);
        };

        /**
         * Encodes the specified AttachNotify message. Does not implicitly {@link Q2Game.AttachNotify.verify|verify} messages.
         * @function encode
         * @memberof Q2Game.AttachNotify
         * @static
         * @param {Q2Game.IAttachNotify} message AttachNotify message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        AttachNotify.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.seatId != null && message.hasOwnProperty("seatId"))
                writer.uint32(/* id 1, wireType 0 =*/8).int32(message.seatId);
            if (message.card != null && message.hasOwnProperty("card"))
                writer.uint32(/* id 2, wireType 0 =*/16).int32(message.card);
            if (message.pattern != null && message.hasOwnProperty("pattern"))
                $root.Q2Game.CardPattern.encode(message.pattern, writer.uint32(/* id 3, wireType 2 =*/26).fork()).ldelim();
            if (message.fromCompleteProcess != null && message.hasOwnProperty("fromCompleteProcess"))
                writer.uint32(/* id 4, wireType 0 =*/32).bool(message.fromCompleteProcess);
            if (message.targetSeat != null && message.hasOwnProperty("targetSeat"))
                writer.uint32(/* id 8, wireType 0 =*/64).int32(message.targetSeat);
            return writer;
        };

        /**
         * Encodes the specified AttachNotify message, length delimited. Does not implicitly {@link Q2Game.AttachNotify.verify|verify} messages.
         * @function encodeDelimited
         * @memberof Q2Game.AttachNotify
         * @static
         * @param {Q2Game.IAttachNotify} message AttachNotify message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        AttachNotify.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes an AttachNotify message from the specified reader or buffer.
         * @function decode
         * @memberof Q2Game.AttachNotify
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {Q2Game.AttachNotify} AttachNotify
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        AttachNotify.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.Q2Game.AttachNotify();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.seatId = reader.int32();
                    break;
                case 8:
                    message.targetSeat = reader.int32();
                    break;
                case 2:
                    message.card = reader.int32();
                    break;
                case 3:
                    message.pattern = $root.Q2Game.CardPattern.decode(reader, reader.uint32());
                    break;
                case 4:
                    message.fromCompleteProcess = reader.bool();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes an AttachNotify message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof Q2Game.AttachNotify
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {Q2Game.AttachNotify} AttachNotify
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        AttachNotify.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies an AttachNotify message.
         * @function verify
         * @memberof Q2Game.AttachNotify
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        AttachNotify.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.seatId != null && message.hasOwnProperty("seatId"))
                if (!$util.isInteger(message.seatId))
                    return "seatId: integer expected";
            if (message.targetSeat != null && message.hasOwnProperty("targetSeat"))
                if (!$util.isInteger(message.targetSeat))
                    return "targetSeat: integer expected";
            if (message.card != null && message.hasOwnProperty("card"))
                if (!$util.isInteger(message.card))
                    return "card: integer expected";
            if (message.pattern != null && message.hasOwnProperty("pattern")) {
                var error = $root.Q2Game.CardPattern.verify(message.pattern);
                if (error)
                    return "pattern." + error;
            }
            if (message.fromCompleteProcess != null && message.hasOwnProperty("fromCompleteProcess"))
                if (typeof message.fromCompleteProcess !== "boolean")
                    return "fromCompleteProcess: boolean expected";
            return null;
        };

        /**
         * Creates an AttachNotify message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof Q2Game.AttachNotify
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {Q2Game.AttachNotify} AttachNotify
         */
        AttachNotify.fromObject = function fromObject(object) {
            if (object instanceof $root.Q2Game.AttachNotify)
                return object;
            var message = new $root.Q2Game.AttachNotify();
            if (object.seatId != null)
                message.seatId = object.seatId | 0;
            if (object.targetSeat != null)
                message.targetSeat = object.targetSeat | 0;
            if (object.card != null)
                message.card = object.card | 0;
            if (object.pattern != null) {
                if (typeof object.pattern !== "object")
                    throw TypeError(".Q2Game.AttachNotify.pattern: object expected");
                message.pattern = $root.Q2Game.CardPattern.fromObject(object.pattern);
            }
            if (object.fromCompleteProcess != null)
                message.fromCompleteProcess = Boolean(object.fromCompleteProcess);
            return message;
        };

        /**
         * Creates a plain object from an AttachNotify message. Also converts values to other types if specified.
         * @function toObject
         * @memberof Q2Game.AttachNotify
         * @static
         * @param {Q2Game.AttachNotify} message AttachNotify
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        AttachNotify.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                object.seatId = 0;
                object.card = 0;
                object.pattern = null;
                object.fromCompleteProcess = false;
                object.targetSeat = 0;
            }
            if (message.seatId != null && message.hasOwnProperty("seatId"))
                object.seatId = message.seatId;
            if (message.card != null && message.hasOwnProperty("card"))
                object.card = message.card;
            if (message.pattern != null && message.hasOwnProperty("pattern"))
                object.pattern = $root.Q2Game.CardPattern.toObject(message.pattern, options);
            if (message.fromCompleteProcess != null && message.hasOwnProperty("fromCompleteProcess"))
                object.fromCompleteProcess = message.fromCompleteProcess;
            if (message.targetSeat != null && message.hasOwnProperty("targetSeat"))
                object.targetSeat = message.targetSeat;
            return object;
        };

        /**
         * Converts this AttachNotify to JSON.
         * @function toJSON
         * @memberof Q2Game.AttachNotify
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        AttachNotify.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return AttachNotify;
    })();

    Q2Game.ShowQ2Req = (function() {

        /**
         * Properties of a ShowQ2Req.
         * @memberof Q2Game
         * @interface IShowQ2Req
         * @property {boolean|null} [isReq] ShowQ2Req isReq
         */

        /**
         * Constructs a new ShowQ2Req.
         * @memberof Q2Game
         * @classdesc Represents a ShowQ2Req.
         * @implements IShowQ2Req
         * @constructor
         * @param {Q2Game.IShowQ2Req=} [properties] Properties to set
         */
        function ShowQ2Req(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * ShowQ2Req isReq.
         * @member {boolean} isReq
         * @memberof Q2Game.ShowQ2Req
         * @instance
         */
        ShowQ2Req.prototype.isReq = false;

        /**
         * Creates a new ShowQ2Req instance using the specified properties.
         * @function create
         * @memberof Q2Game.ShowQ2Req
         * @static
         * @param {Q2Game.IShowQ2Req=} [properties] Properties to set
         * @returns {Q2Game.ShowQ2Req} ShowQ2Req instance
         */
        ShowQ2Req.create = function create(properties) {
            return new ShowQ2Req(properties);
        };

        /**
         * Encodes the specified ShowQ2Req message. Does not implicitly {@link Q2Game.ShowQ2Req.verify|verify} messages.
         * @function encode
         * @memberof Q2Game.ShowQ2Req
         * @static
         * @param {Q2Game.IShowQ2Req} message ShowQ2Req message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        ShowQ2Req.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.isReq != null && message.hasOwnProperty("isReq"))
                writer.uint32(/* id 1, wireType 0 =*/8).bool(message.isReq);
            return writer;
        };

        /**
         * Encodes the specified ShowQ2Req message, length delimited. Does not implicitly {@link Q2Game.ShowQ2Req.verify|verify} messages.
         * @function encodeDelimited
         * @memberof Q2Game.ShowQ2Req
         * @static
         * @param {Q2Game.IShowQ2Req} message ShowQ2Req message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        ShowQ2Req.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a ShowQ2Req message from the specified reader or buffer.
         * @function decode
         * @memberof Q2Game.ShowQ2Req
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {Q2Game.ShowQ2Req} ShowQ2Req
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        ShowQ2Req.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.Q2Game.ShowQ2Req();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.isReq = reader.bool();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a ShowQ2Req message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof Q2Game.ShowQ2Req
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {Q2Game.ShowQ2Req} ShowQ2Req
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        ShowQ2Req.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a ShowQ2Req message.
         * @function verify
         * @memberof Q2Game.ShowQ2Req
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        ShowQ2Req.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.isReq != null && message.hasOwnProperty("isReq"))
                if (typeof message.isReq !== "boolean")
                    return "isReq: boolean expected";
            return null;
        };

        /**
         * Creates a ShowQ2Req message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof Q2Game.ShowQ2Req
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {Q2Game.ShowQ2Req} ShowQ2Req
         */
        ShowQ2Req.fromObject = function fromObject(object) {
            if (object instanceof $root.Q2Game.ShowQ2Req)
                return object;
            var message = new $root.Q2Game.ShowQ2Req();
            if (object.isReq != null)
                message.isReq = Boolean(object.isReq);
            return message;
        };

        /**
         * Creates a plain object from a ShowQ2Req message. Also converts values to other types if specified.
         * @function toObject
         * @memberof Q2Game.ShowQ2Req
         * @static
         * @param {Q2Game.ShowQ2Req} message ShowQ2Req
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        ShowQ2Req.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults)
                object.isReq = false;
            if (message.isReq != null && message.hasOwnProperty("isReq"))
                object.isReq = message.isReq;
            return object;
        };

        /**
         * Converts this ShowQ2Req to JSON.
         * @function toJSON
         * @memberof Q2Game.ShowQ2Req
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        ShowQ2Req.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return ShowQ2Req;
    })();

    Q2Game.ShowQ2Rsp = (function() {

        /**
         * Properties of a ShowQ2Rsp.
         * @memberof Q2Game
         * @interface IShowQ2Rsp
         * @property {number|null} [errNo] ShowQ2Rsp errNo
         */

        /**
         * Constructs a new ShowQ2Rsp.
         * @memberof Q2Game
         * @classdesc Represents a ShowQ2Rsp.
         * @implements IShowQ2Rsp
         * @constructor
         * @param {Q2Game.IShowQ2Rsp=} [properties] Properties to set
         */
        function ShowQ2Rsp(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * ShowQ2Rsp errNo.
         * @member {number} errNo
         * @memberof Q2Game.ShowQ2Rsp
         * @instance
         */
        ShowQ2Rsp.prototype.errNo = 0;

        /**
         * Creates a new ShowQ2Rsp instance using the specified properties.
         * @function create
         * @memberof Q2Game.ShowQ2Rsp
         * @static
         * @param {Q2Game.IShowQ2Rsp=} [properties] Properties to set
         * @returns {Q2Game.ShowQ2Rsp} ShowQ2Rsp instance
         */
        ShowQ2Rsp.create = function create(properties) {
            return new ShowQ2Rsp(properties);
        };

        /**
         * Encodes the specified ShowQ2Rsp message. Does not implicitly {@link Q2Game.ShowQ2Rsp.verify|verify} messages.
         * @function encode
         * @memberof Q2Game.ShowQ2Rsp
         * @static
         * @param {Q2Game.IShowQ2Rsp} message ShowQ2Rsp message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        ShowQ2Rsp.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.errNo != null && message.hasOwnProperty("errNo"))
                writer.uint32(/* id 1, wireType 0 =*/8).int32(message.errNo);
            return writer;
        };

        /**
         * Encodes the specified ShowQ2Rsp message, length delimited. Does not implicitly {@link Q2Game.ShowQ2Rsp.verify|verify} messages.
         * @function encodeDelimited
         * @memberof Q2Game.ShowQ2Rsp
         * @static
         * @param {Q2Game.IShowQ2Rsp} message ShowQ2Rsp message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        ShowQ2Rsp.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a ShowQ2Rsp message from the specified reader or buffer.
         * @function decode
         * @memberof Q2Game.ShowQ2Rsp
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {Q2Game.ShowQ2Rsp} ShowQ2Rsp
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        ShowQ2Rsp.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.Q2Game.ShowQ2Rsp();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.errNo = reader.int32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a ShowQ2Rsp message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof Q2Game.ShowQ2Rsp
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {Q2Game.ShowQ2Rsp} ShowQ2Rsp
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        ShowQ2Rsp.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a ShowQ2Rsp message.
         * @function verify
         * @memberof Q2Game.ShowQ2Rsp
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        ShowQ2Rsp.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.errNo != null && message.hasOwnProperty("errNo"))
                if (!$util.isInteger(message.errNo))
                    return "errNo: integer expected";
            return null;
        };

        /**
         * Creates a ShowQ2Rsp message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof Q2Game.ShowQ2Rsp
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {Q2Game.ShowQ2Rsp} ShowQ2Rsp
         */
        ShowQ2Rsp.fromObject = function fromObject(object) {
            if (object instanceof $root.Q2Game.ShowQ2Rsp)
                return object;
            var message = new $root.Q2Game.ShowQ2Rsp();
            if (object.errNo != null)
                message.errNo = object.errNo | 0;
            return message;
        };

        /**
         * Creates a plain object from a ShowQ2Rsp message. Also converts values to other types if specified.
         * @function toObject
         * @memberof Q2Game.ShowQ2Rsp
         * @static
         * @param {Q2Game.ShowQ2Rsp} message ShowQ2Rsp
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        ShowQ2Rsp.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults)
                object.errNo = 0;
            if (message.errNo != null && message.hasOwnProperty("errNo"))
                object.errNo = message.errNo;
            return object;
        };

        /**
         * Converts this ShowQ2Rsp to JSON.
         * @function toJSON
         * @memberof Q2Game.ShowQ2Rsp
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        ShowQ2Rsp.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return ShowQ2Rsp;
    })();

    Q2Game.ShowQ2Notify = (function() {

        /**
         * Properties of a ShowQ2Notify.
         * @memberof Q2Game
         * @interface IShowQ2Notify
         * @property {number|null} [seatId] ShowQ2Notify seatId
         */

        /**
         * Constructs a new ShowQ2Notify.
         * @memberof Q2Game
         * @classdesc Represents a ShowQ2Notify.
         * @implements IShowQ2Notify
         * @constructor
         * @param {Q2Game.IShowQ2Notify=} [properties] Properties to set
         */
        function ShowQ2Notify(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * ShowQ2Notify seatId.
         * @member {number} seatId
         * @memberof Q2Game.ShowQ2Notify
         * @instance
         */
        ShowQ2Notify.prototype.seatId = 0;

        /**
         * Creates a new ShowQ2Notify instance using the specified properties.
         * @function create
         * @memberof Q2Game.ShowQ2Notify
         * @static
         * @param {Q2Game.IShowQ2Notify=} [properties] Properties to set
         * @returns {Q2Game.ShowQ2Notify} ShowQ2Notify instance
         */
        ShowQ2Notify.create = function create(properties) {
            return new ShowQ2Notify(properties);
        };

        /**
         * Encodes the specified ShowQ2Notify message. Does not implicitly {@link Q2Game.ShowQ2Notify.verify|verify} messages.
         * @function encode
         * @memberof Q2Game.ShowQ2Notify
         * @static
         * @param {Q2Game.IShowQ2Notify} message ShowQ2Notify message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        ShowQ2Notify.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.seatId != null && message.hasOwnProperty("seatId"))
                writer.uint32(/* id 1, wireType 0 =*/8).int32(message.seatId);
            return writer;
        };

        /**
         * Encodes the specified ShowQ2Notify message, length delimited. Does not implicitly {@link Q2Game.ShowQ2Notify.verify|verify} messages.
         * @function encodeDelimited
         * @memberof Q2Game.ShowQ2Notify
         * @static
         * @param {Q2Game.IShowQ2Notify} message ShowQ2Notify message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        ShowQ2Notify.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a ShowQ2Notify message from the specified reader or buffer.
         * @function decode
         * @memberof Q2Game.ShowQ2Notify
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {Q2Game.ShowQ2Notify} ShowQ2Notify
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        ShowQ2Notify.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.Q2Game.ShowQ2Notify();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.seatId = reader.int32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a ShowQ2Notify message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof Q2Game.ShowQ2Notify
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {Q2Game.ShowQ2Notify} ShowQ2Notify
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        ShowQ2Notify.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a ShowQ2Notify message.
         * @function verify
         * @memberof Q2Game.ShowQ2Notify
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        ShowQ2Notify.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.seatId != null && message.hasOwnProperty("seatId"))
                if (!$util.isInteger(message.seatId))
                    return "seatId: integer expected";
            return null;
        };

        /**
         * Creates a ShowQ2Notify message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof Q2Game.ShowQ2Notify
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {Q2Game.ShowQ2Notify} ShowQ2Notify
         */
        ShowQ2Notify.fromObject = function fromObject(object) {
            if (object instanceof $root.Q2Game.ShowQ2Notify)
                return object;
            var message = new $root.Q2Game.ShowQ2Notify();
            if (object.seatId != null)
                message.seatId = object.seatId | 0;
            return message;
        };

        /**
         * Creates a plain object from a ShowQ2Notify message. Also converts values to other types if specified.
         * @function toObject
         * @memberof Q2Game.ShowQ2Notify
         * @static
         * @param {Q2Game.ShowQ2Notify} message ShowQ2Notify
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        ShowQ2Notify.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults)
                object.seatId = 0;
            if (message.seatId != null && message.hasOwnProperty("seatId"))
                object.seatId = message.seatId;
            return object;
        };

        /**
         * Converts this ShowQ2Notify to JSON.
         * @function toJSON
         * @memberof Q2Game.ShowQ2Notify
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        ShowQ2Notify.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return ShowQ2Notify;
    })();

    Q2Game.DiscardReq = (function() {

        /**
         * Properties of a DiscardReq.
         * @memberof Q2Game
         * @interface IDiscardReq
         * @property {number|null} [card] DiscardReq card
         */

        /**
         * Constructs a new DiscardReq.
         * @memberof Q2Game
         * @classdesc Represents a DiscardReq.
         * @implements IDiscardReq
         * @constructor
         * @param {Q2Game.IDiscardReq=} [properties] Properties to set
         */
        function DiscardReq(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * DiscardReq card.
         * @member {number} card
         * @memberof Q2Game.DiscardReq
         * @instance
         */
        DiscardReq.prototype.card = 0;

        /**
         * Creates a new DiscardReq instance using the specified properties.
         * @function create
         * @memberof Q2Game.DiscardReq
         * @static
         * @param {Q2Game.IDiscardReq=} [properties] Properties to set
         * @returns {Q2Game.DiscardReq} DiscardReq instance
         */
        DiscardReq.create = function create(properties) {
            return new DiscardReq(properties);
        };

        /**
         * Encodes the specified DiscardReq message. Does not implicitly {@link Q2Game.DiscardReq.verify|verify} messages.
         * @function encode
         * @memberof Q2Game.DiscardReq
         * @static
         * @param {Q2Game.IDiscardReq} message DiscardReq message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        DiscardReq.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.card != null && message.hasOwnProperty("card"))
                writer.uint32(/* id 1, wireType 0 =*/8).int32(message.card);
            return writer;
        };

        /**
         * Encodes the specified DiscardReq message, length delimited. Does not implicitly {@link Q2Game.DiscardReq.verify|verify} messages.
         * @function encodeDelimited
         * @memberof Q2Game.DiscardReq
         * @static
         * @param {Q2Game.IDiscardReq} message DiscardReq message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        DiscardReq.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a DiscardReq message from the specified reader or buffer.
         * @function decode
         * @memberof Q2Game.DiscardReq
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {Q2Game.DiscardReq} DiscardReq
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        DiscardReq.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.Q2Game.DiscardReq();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.card = reader.int32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a DiscardReq message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof Q2Game.DiscardReq
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {Q2Game.DiscardReq} DiscardReq
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        DiscardReq.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a DiscardReq message.
         * @function verify
         * @memberof Q2Game.DiscardReq
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        DiscardReq.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.card != null && message.hasOwnProperty("card"))
                if (!$util.isInteger(message.card))
                    return "card: integer expected";
            return null;
        };

        /**
         * Creates a DiscardReq message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof Q2Game.DiscardReq
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {Q2Game.DiscardReq} DiscardReq
         */
        DiscardReq.fromObject = function fromObject(object) {
            if (object instanceof $root.Q2Game.DiscardReq)
                return object;
            var message = new $root.Q2Game.DiscardReq();
            if (object.card != null)
                message.card = object.card | 0;
            return message;
        };

        /**
         * Creates a plain object from a DiscardReq message. Also converts values to other types if specified.
         * @function toObject
         * @memberof Q2Game.DiscardReq
         * @static
         * @param {Q2Game.DiscardReq} message DiscardReq
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        DiscardReq.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults)
                object.card = 0;
            if (message.card != null && message.hasOwnProperty("card"))
                object.card = message.card;
            return object;
        };

        /**
         * Converts this DiscardReq to JSON.
         * @function toJSON
         * @memberof Q2Game.DiscardReq
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        DiscardReq.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return DiscardReq;
    })();

    Q2Game.DiscardRsp = (function() {

        /**
         * Properties of a DiscardRsp.
         * @memberof Q2Game
         * @interface IDiscardRsp
         * @property {number|null} [errNo] DiscardRsp errNo
         */

        /**
         * Constructs a new DiscardRsp.
         * @memberof Q2Game
         * @classdesc Represents a DiscardRsp.
         * @implements IDiscardRsp
         * @constructor
         * @param {Q2Game.IDiscardRsp=} [properties] Properties to set
         */
        function DiscardRsp(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * DiscardRsp errNo.
         * @member {number} errNo
         * @memberof Q2Game.DiscardRsp
         * @instance
         */
        DiscardRsp.prototype.errNo = 0;

        /**
         * Creates a new DiscardRsp instance using the specified properties.
         * @function create
         * @memberof Q2Game.DiscardRsp
         * @static
         * @param {Q2Game.IDiscardRsp=} [properties] Properties to set
         * @returns {Q2Game.DiscardRsp} DiscardRsp instance
         */
        DiscardRsp.create = function create(properties) {
            return new DiscardRsp(properties);
        };

        /**
         * Encodes the specified DiscardRsp message. Does not implicitly {@link Q2Game.DiscardRsp.verify|verify} messages.
         * @function encode
         * @memberof Q2Game.DiscardRsp
         * @static
         * @param {Q2Game.IDiscardRsp} message DiscardRsp message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        DiscardRsp.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.errNo != null && message.hasOwnProperty("errNo"))
                writer.uint32(/* id 1, wireType 0 =*/8).int32(message.errNo);
            return writer;
        };

        /**
         * Encodes the specified DiscardRsp message, length delimited. Does not implicitly {@link Q2Game.DiscardRsp.verify|verify} messages.
         * @function encodeDelimited
         * @memberof Q2Game.DiscardRsp
         * @static
         * @param {Q2Game.IDiscardRsp} message DiscardRsp message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        DiscardRsp.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a DiscardRsp message from the specified reader or buffer.
         * @function decode
         * @memberof Q2Game.DiscardRsp
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {Q2Game.DiscardRsp} DiscardRsp
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        DiscardRsp.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.Q2Game.DiscardRsp();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.errNo = reader.int32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a DiscardRsp message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof Q2Game.DiscardRsp
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {Q2Game.DiscardRsp} DiscardRsp
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        DiscardRsp.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a DiscardRsp message.
         * @function verify
         * @memberof Q2Game.DiscardRsp
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        DiscardRsp.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.errNo != null && message.hasOwnProperty("errNo"))
                if (!$util.isInteger(message.errNo))
                    return "errNo: integer expected";
            return null;
        };

        /**
         * Creates a DiscardRsp message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof Q2Game.DiscardRsp
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {Q2Game.DiscardRsp} DiscardRsp
         */
        DiscardRsp.fromObject = function fromObject(object) {
            if (object instanceof $root.Q2Game.DiscardRsp)
                return object;
            var message = new $root.Q2Game.DiscardRsp();
            if (object.errNo != null)
                message.errNo = object.errNo | 0;
            return message;
        };

        /**
         * Creates a plain object from a DiscardRsp message. Also converts values to other types if specified.
         * @function toObject
         * @memberof Q2Game.DiscardRsp
         * @static
         * @param {Q2Game.DiscardRsp} message DiscardRsp
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        DiscardRsp.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults)
                object.errNo = 0;
            if (message.errNo != null && message.hasOwnProperty("errNo"))
                object.errNo = message.errNo;
            return object;
        };

        /**
         * Converts this DiscardRsp to JSON.
         * @function toJSON
         * @memberof Q2Game.DiscardRsp
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        DiscardRsp.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return DiscardRsp;
    })();

    Q2Game.SeatChangedNotify = (function() {

        /**
         * Properties of a SeatChangedNotify.
         * @memberof Q2Game
         * @interface ISeatChangedNotify
         * @property {Q2Game.ISeatInfo|null} [seatInfo] SeatChangedNotify seatInfo
         */

        /**
         * Constructs a new SeatChangedNotify.
         * @memberof Q2Game
         * @classdesc Represents a SeatChangedNotify.
         * @implements ISeatChangedNotify
         * @constructor
         * @param {Q2Game.ISeatChangedNotify=} [properties] Properties to set
         */
        function SeatChangedNotify(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * SeatChangedNotify seatInfo.
         * @member {Q2Game.ISeatInfo|null|undefined} seatInfo
         * @memberof Q2Game.SeatChangedNotify
         * @instance
         */
        SeatChangedNotify.prototype.seatInfo = null;

        /**
         * Creates a new SeatChangedNotify instance using the specified properties.
         * @function create
         * @memberof Q2Game.SeatChangedNotify
         * @static
         * @param {Q2Game.ISeatChangedNotify=} [properties] Properties to set
         * @returns {Q2Game.SeatChangedNotify} SeatChangedNotify instance
         */
        SeatChangedNotify.create = function create(properties) {
            return new SeatChangedNotify(properties);
        };

        /**
         * Encodes the specified SeatChangedNotify message. Does not implicitly {@link Q2Game.SeatChangedNotify.verify|verify} messages.
         * @function encode
         * @memberof Q2Game.SeatChangedNotify
         * @static
         * @param {Q2Game.ISeatChangedNotify} message SeatChangedNotify message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        SeatChangedNotify.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.seatInfo != null && message.hasOwnProperty("seatInfo"))
                $root.Q2Game.SeatInfo.encode(message.seatInfo, writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
            return writer;
        };

        /**
         * Encodes the specified SeatChangedNotify message, length delimited. Does not implicitly {@link Q2Game.SeatChangedNotify.verify|verify} messages.
         * @function encodeDelimited
         * @memberof Q2Game.SeatChangedNotify
         * @static
         * @param {Q2Game.ISeatChangedNotify} message SeatChangedNotify message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        SeatChangedNotify.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a SeatChangedNotify message from the specified reader or buffer.
         * @function decode
         * @memberof Q2Game.SeatChangedNotify
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {Q2Game.SeatChangedNotify} SeatChangedNotify
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        SeatChangedNotify.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.Q2Game.SeatChangedNotify();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 2:
                    message.seatInfo = $root.Q2Game.SeatInfo.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a SeatChangedNotify message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof Q2Game.SeatChangedNotify
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {Q2Game.SeatChangedNotify} SeatChangedNotify
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        SeatChangedNotify.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a SeatChangedNotify message.
         * @function verify
         * @memberof Q2Game.SeatChangedNotify
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        SeatChangedNotify.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.seatInfo != null && message.hasOwnProperty("seatInfo")) {
                var error = $root.Q2Game.SeatInfo.verify(message.seatInfo);
                if (error)
                    return "seatInfo." + error;
            }
            return null;
        };

        /**
         * Creates a SeatChangedNotify message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof Q2Game.SeatChangedNotify
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {Q2Game.SeatChangedNotify} SeatChangedNotify
         */
        SeatChangedNotify.fromObject = function fromObject(object) {
            if (object instanceof $root.Q2Game.SeatChangedNotify)
                return object;
            var message = new $root.Q2Game.SeatChangedNotify();
            if (object.seatInfo != null) {
                if (typeof object.seatInfo !== "object")
                    throw TypeError(".Q2Game.SeatChangedNotify.seatInfo: object expected");
                message.seatInfo = $root.Q2Game.SeatInfo.fromObject(object.seatInfo);
            }
            return message;
        };

        /**
         * Creates a plain object from a SeatChangedNotify message. Also converts values to other types if specified.
         * @function toObject
         * @memberof Q2Game.SeatChangedNotify
         * @static
         * @param {Q2Game.SeatChangedNotify} message SeatChangedNotify
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        SeatChangedNotify.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults)
                object.seatInfo = null;
            if (message.seatInfo != null && message.hasOwnProperty("seatInfo"))
                object.seatInfo = $root.Q2Game.SeatInfo.toObject(message.seatInfo, options);
            return object;
        };

        /**
         * Converts this SeatChangedNotify to JSON.
         * @function toJSON
         * @memberof Q2Game.SeatChangedNotify
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        SeatChangedNotify.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return SeatChangedNotify;
    })();

    Q2Game.DiscardNotify = (function() {

        /**
         * Properties of a DiscardNotify.
         * @memberof Q2Game
         * @interface IDiscardNotify
         * @property {number|null} [seatId] DiscardNotify seatId
         * @property {number|null} [card] DiscardNotify card
         * @property {Array.<number>|null} [commonCards] DiscardNotify commonCards
         * @property {boolean|null} [fromCompleteProcess] DiscardNotify fromCompleteProcess
         */

        /**
         * Constructs a new DiscardNotify.
         * @memberof Q2Game
         * @classdesc Represents a DiscardNotify.
         * @implements IDiscardNotify
         * @constructor
         * @param {Q2Game.IDiscardNotify=} [properties] Properties to set
         */
        function DiscardNotify(properties) {
            this.commonCards = [];
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * DiscardNotify seatId.
         * @member {number} seatId
         * @memberof Q2Game.DiscardNotify
         * @instance
         */
        DiscardNotify.prototype.seatId = 0;

        /**
         * DiscardNotify card.
         * @member {number} card
         * @memberof Q2Game.DiscardNotify
         * @instance
         */
        DiscardNotify.prototype.card = 0;

        /**
         * DiscardNotify commonCards.
         * @member {Array.<number>} commonCards
         * @memberof Q2Game.DiscardNotify
         * @instance
         */
        DiscardNotify.prototype.commonCards = $util.emptyArray;

        /**
         * DiscardNotify fromCompleteProcess.
         * @member {boolean} fromCompleteProcess
         * @memberof Q2Game.DiscardNotify
         * @instance
         */
        DiscardNotify.prototype.fromCompleteProcess = false;

        /**
         * Creates a new DiscardNotify instance using the specified properties.
         * @function create
         * @memberof Q2Game.DiscardNotify
         * @static
         * @param {Q2Game.IDiscardNotify=} [properties] Properties to set
         * @returns {Q2Game.DiscardNotify} DiscardNotify instance
         */
        DiscardNotify.create = function create(properties) {
            return new DiscardNotify(properties);
        };

        /**
         * Encodes the specified DiscardNotify message. Does not implicitly {@link Q2Game.DiscardNotify.verify|verify} messages.
         * @function encode
         * @memberof Q2Game.DiscardNotify
         * @static
         * @param {Q2Game.IDiscardNotify} message DiscardNotify message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        DiscardNotify.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.seatId != null && message.hasOwnProperty("seatId"))
                writer.uint32(/* id 1, wireType 0 =*/8).int32(message.seatId);
            if (message.card != null && message.hasOwnProperty("card"))
                writer.uint32(/* id 2, wireType 0 =*/16).int32(message.card);
            if (message.commonCards != null && message.commonCards.length)
                for (var i = 0; i < message.commonCards.length; ++i)
                    writer.uint32(/* id 3, wireType 0 =*/24).int32(message.commonCards[i]);
            if (message.fromCompleteProcess != null && message.hasOwnProperty("fromCompleteProcess"))
                writer.uint32(/* id 4, wireType 0 =*/32).bool(message.fromCompleteProcess);
            return writer;
        };

        /**
         * Encodes the specified DiscardNotify message, length delimited. Does not implicitly {@link Q2Game.DiscardNotify.verify|verify} messages.
         * @function encodeDelimited
         * @memberof Q2Game.DiscardNotify
         * @static
         * @param {Q2Game.IDiscardNotify} message DiscardNotify message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        DiscardNotify.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a DiscardNotify message from the specified reader or buffer.
         * @function decode
         * @memberof Q2Game.DiscardNotify
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {Q2Game.DiscardNotify} DiscardNotify
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        DiscardNotify.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.Q2Game.DiscardNotify();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.seatId = reader.int32();
                    break;
                case 2:
                    message.card = reader.int32();
                    break;
                case 3:
                    if (!(message.commonCards && message.commonCards.length))
                        message.commonCards = [];
                    if ((tag & 7) === 2) {
                        var end2 = reader.uint32() + reader.pos;
                        while (reader.pos < end2)
                            message.commonCards.push(reader.int32());
                    } else
                        message.commonCards.push(reader.int32());
                    break;
                case 4:
                    message.fromCompleteProcess = reader.bool();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a DiscardNotify message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof Q2Game.DiscardNotify
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {Q2Game.DiscardNotify} DiscardNotify
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        DiscardNotify.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a DiscardNotify message.
         * @function verify
         * @memberof Q2Game.DiscardNotify
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        DiscardNotify.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.seatId != null && message.hasOwnProperty("seatId"))
                if (!$util.isInteger(message.seatId))
                    return "seatId: integer expected";
            if (message.card != null && message.hasOwnProperty("card"))
                if (!$util.isInteger(message.card))
                    return "card: integer expected";
            if (message.commonCards != null && message.hasOwnProperty("commonCards")) {
                if (!Array.isArray(message.commonCards))
                    return "commonCards: array expected";
                for (var i = 0; i < message.commonCards.length; ++i)
                    if (!$util.isInteger(message.commonCards[i]))
                        return "commonCards: integer[] expected";
            }
            if (message.fromCompleteProcess != null && message.hasOwnProperty("fromCompleteProcess"))
                if (typeof message.fromCompleteProcess !== "boolean")
                    return "fromCompleteProcess: boolean expected";
            return null;
        };

        /**
         * Creates a DiscardNotify message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof Q2Game.DiscardNotify
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {Q2Game.DiscardNotify} DiscardNotify
         */
        DiscardNotify.fromObject = function fromObject(object) {
            if (object instanceof $root.Q2Game.DiscardNotify)
                return object;
            var message = new $root.Q2Game.DiscardNotify();
            if (object.seatId != null)
                message.seatId = object.seatId | 0;
            if (object.card != null)
                message.card = object.card | 0;
            if (object.commonCards) {
                if (!Array.isArray(object.commonCards))
                    throw TypeError(".Q2Game.DiscardNotify.commonCards: array expected");
                message.commonCards = [];
                for (var i = 0; i < object.commonCards.length; ++i)
                    message.commonCards[i] = object.commonCards[i] | 0;
            }
            if (object.fromCompleteProcess != null)
                message.fromCompleteProcess = Boolean(object.fromCompleteProcess);
            return message;
        };

        /**
         * Creates a plain object from a DiscardNotify message. Also converts values to other types if specified.
         * @function toObject
         * @memberof Q2Game.DiscardNotify
         * @static
         * @param {Q2Game.DiscardNotify} message DiscardNotify
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        DiscardNotify.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.arrays || options.defaults)
                object.commonCards = [];
            if (options.defaults) {
                object.seatId = 0;
                object.card = 0;
                object.fromCompleteProcess = false;
            }
            if (message.seatId != null && message.hasOwnProperty("seatId"))
                object.seatId = message.seatId;
            if (message.card != null && message.hasOwnProperty("card"))
                object.card = message.card;
            if (message.commonCards && message.commonCards.length) {
                object.commonCards = [];
                for (var j = 0; j < message.commonCards.length; ++j)
                    object.commonCards[j] = message.commonCards[j];
            }
            if (message.fromCompleteProcess != null && message.hasOwnProperty("fromCompleteProcess"))
                object.fromCompleteProcess = message.fromCompleteProcess;
            return object;
        };

        /**
         * Converts this DiscardNotify to JSON.
         * @function toJSON
         * @memberof Q2Game.DiscardNotify
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        DiscardNotify.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return DiscardNotify;
    })();

    Q2Game.StorageReq = (function() {

        /**
         * Properties of a StorageReq.
         * @memberof Q2Game
         * @interface IStorageReq
         * @property {Array.<number>|null} [cards] StorageReq cards
         */

        /**
         * Constructs a new StorageReq.
         * @memberof Q2Game
         * @classdesc Represents a StorageReq.
         * @implements IStorageReq
         * @constructor
         * @param {Q2Game.IStorageReq=} [properties] Properties to set
         */
        function StorageReq(properties) {
            this.cards = [];
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * StorageReq cards.
         * @member {Array.<number>} cards
         * @memberof Q2Game.StorageReq
         * @instance
         */
        StorageReq.prototype.cards = $util.emptyArray;

        /**
         * Creates a new StorageReq instance using the specified properties.
         * @function create
         * @memberof Q2Game.StorageReq
         * @static
         * @param {Q2Game.IStorageReq=} [properties] Properties to set
         * @returns {Q2Game.StorageReq} StorageReq instance
         */
        StorageReq.create = function create(properties) {
            return new StorageReq(properties);
        };

        /**
         * Encodes the specified StorageReq message. Does not implicitly {@link Q2Game.StorageReq.verify|verify} messages.
         * @function encode
         * @memberof Q2Game.StorageReq
         * @static
         * @param {Q2Game.IStorageReq} message StorageReq message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        StorageReq.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.cards != null && message.cards.length)
                for (var i = 0; i < message.cards.length; ++i)
                    writer.uint32(/* id 1, wireType 0 =*/8).int32(message.cards[i]);
            return writer;
        };

        /**
         * Encodes the specified StorageReq message, length delimited. Does not implicitly {@link Q2Game.StorageReq.verify|verify} messages.
         * @function encodeDelimited
         * @memberof Q2Game.StorageReq
         * @static
         * @param {Q2Game.IStorageReq} message StorageReq message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        StorageReq.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a StorageReq message from the specified reader or buffer.
         * @function decode
         * @memberof Q2Game.StorageReq
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {Q2Game.StorageReq} StorageReq
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        StorageReq.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.Q2Game.StorageReq();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    if (!(message.cards && message.cards.length))
                        message.cards = [];
                    if ((tag & 7) === 2) {
                        var end2 = reader.uint32() + reader.pos;
                        while (reader.pos < end2)
                            message.cards.push(reader.int32());
                    } else
                        message.cards.push(reader.int32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a StorageReq message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof Q2Game.StorageReq
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {Q2Game.StorageReq} StorageReq
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        StorageReq.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a StorageReq message.
         * @function verify
         * @memberof Q2Game.StorageReq
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        StorageReq.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.cards != null && message.hasOwnProperty("cards")) {
                if (!Array.isArray(message.cards))
                    return "cards: array expected";
                for (var i = 0; i < message.cards.length; ++i)
                    if (!$util.isInteger(message.cards[i]))
                        return "cards: integer[] expected";
            }
            return null;
        };

        /**
         * Creates a StorageReq message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof Q2Game.StorageReq
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {Q2Game.StorageReq} StorageReq
         */
        StorageReq.fromObject = function fromObject(object) {
            if (object instanceof $root.Q2Game.StorageReq)
                return object;
            var message = new $root.Q2Game.StorageReq();
            if (object.cards) {
                if (!Array.isArray(object.cards))
                    throw TypeError(".Q2Game.StorageReq.cards: array expected");
                message.cards = [];
                for (var i = 0; i < object.cards.length; ++i)
                    message.cards[i] = object.cards[i] | 0;
            }
            return message;
        };

        /**
         * Creates a plain object from a StorageReq message. Also converts values to other types if specified.
         * @function toObject
         * @memberof Q2Game.StorageReq
         * @static
         * @param {Q2Game.StorageReq} message StorageReq
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        StorageReq.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.arrays || options.defaults)
                object.cards = [];
            if (message.cards && message.cards.length) {
                object.cards = [];
                for (var j = 0; j < message.cards.length; ++j)
                    object.cards[j] = message.cards[j];
            }
            return object;
        };

        /**
         * Converts this StorageReq to JSON.
         * @function toJSON
         * @memberof Q2Game.StorageReq
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        StorageReq.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return StorageReq;
    })();

    Q2Game.StorageRsp = (function() {

        /**
         * Properties of a StorageRsp.
         * @memberof Q2Game
         * @interface IStorageRsp
         * @property {number|null} [errNo] StorageRsp errNo
         * @property {Q2Game.ISeatInfo|null} [seatInfo] StorageRsp seatInfo
         */

        /**
         * Constructs a new StorageRsp.
         * @memberof Q2Game
         * @classdesc Represents a StorageRsp.
         * @implements IStorageRsp
         * @constructor
         * @param {Q2Game.IStorageRsp=} [properties] Properties to set
         */
        function StorageRsp(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * StorageRsp errNo.
         * @member {number} errNo
         * @memberof Q2Game.StorageRsp
         * @instance
         */
        StorageRsp.prototype.errNo = 0;

        /**
         * StorageRsp seatInfo.
         * @member {Q2Game.ISeatInfo|null|undefined} seatInfo
         * @memberof Q2Game.StorageRsp
         * @instance
         */
        StorageRsp.prototype.seatInfo = null;

        /**
         * Creates a new StorageRsp instance using the specified properties.
         * @function create
         * @memberof Q2Game.StorageRsp
         * @static
         * @param {Q2Game.IStorageRsp=} [properties] Properties to set
         * @returns {Q2Game.StorageRsp} StorageRsp instance
         */
        StorageRsp.create = function create(properties) {
            return new StorageRsp(properties);
        };

        /**
         * Encodes the specified StorageRsp message. Does not implicitly {@link Q2Game.StorageRsp.verify|verify} messages.
         * @function encode
         * @memberof Q2Game.StorageRsp
         * @static
         * @param {Q2Game.IStorageRsp} message StorageRsp message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        StorageRsp.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.errNo != null && message.hasOwnProperty("errNo"))
                writer.uint32(/* id 1, wireType 0 =*/8).int32(message.errNo);
            if (message.seatInfo != null && message.hasOwnProperty("seatInfo"))
                $root.Q2Game.SeatInfo.encode(message.seatInfo, writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
            return writer;
        };

        /**
         * Encodes the specified StorageRsp message, length delimited. Does not implicitly {@link Q2Game.StorageRsp.verify|verify} messages.
         * @function encodeDelimited
         * @memberof Q2Game.StorageRsp
         * @static
         * @param {Q2Game.IStorageRsp} message StorageRsp message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        StorageRsp.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a StorageRsp message from the specified reader or buffer.
         * @function decode
         * @memberof Q2Game.StorageRsp
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {Q2Game.StorageRsp} StorageRsp
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        StorageRsp.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.Q2Game.StorageRsp();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.errNo = reader.int32();
                    break;
                case 2:
                    message.seatInfo = $root.Q2Game.SeatInfo.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a StorageRsp message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof Q2Game.StorageRsp
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {Q2Game.StorageRsp} StorageRsp
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        StorageRsp.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a StorageRsp message.
         * @function verify
         * @memberof Q2Game.StorageRsp
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        StorageRsp.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.errNo != null && message.hasOwnProperty("errNo"))
                if (!$util.isInteger(message.errNo))
                    return "errNo: integer expected";
            if (message.seatInfo != null && message.hasOwnProperty("seatInfo")) {
                var error = $root.Q2Game.SeatInfo.verify(message.seatInfo);
                if (error)
                    return "seatInfo." + error;
            }
            return null;
        };

        /**
         * Creates a StorageRsp message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof Q2Game.StorageRsp
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {Q2Game.StorageRsp} StorageRsp
         */
        StorageRsp.fromObject = function fromObject(object) {
            if (object instanceof $root.Q2Game.StorageRsp)
                return object;
            var message = new $root.Q2Game.StorageRsp();
            if (object.errNo != null)
                message.errNo = object.errNo | 0;
            if (object.seatInfo != null) {
                if (typeof object.seatInfo !== "object")
                    throw TypeError(".Q2Game.StorageRsp.seatInfo: object expected");
                message.seatInfo = $root.Q2Game.SeatInfo.fromObject(object.seatInfo);
            }
            return message;
        };

        /**
         * Creates a plain object from a StorageRsp message. Also converts values to other types if specified.
         * @function toObject
         * @memberof Q2Game.StorageRsp
         * @static
         * @param {Q2Game.StorageRsp} message StorageRsp
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        StorageRsp.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                object.errNo = 0;
                object.seatInfo = null;
            }
            if (message.errNo != null && message.hasOwnProperty("errNo"))
                object.errNo = message.errNo;
            if (message.seatInfo != null && message.hasOwnProperty("seatInfo"))
                object.seatInfo = $root.Q2Game.SeatInfo.toObject(message.seatInfo, options);
            return object;
        };

        /**
         * Converts this StorageRsp to JSON.
         * @function toJSON
         * @memberof Q2Game.StorageRsp
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        StorageRsp.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return StorageRsp;
    })();

    Q2Game.StorageNotify = (function() {

        /**
         * Properties of a StorageNotify.
         * @memberof Q2Game
         * @interface IStorageNotify
         * @property {number|null} [seatId] StorageNotify seatId
         * @property {Q2Game.ICardPattern|null} [pattern] StorageNotify pattern
         * @property {boolean|null} [fromCompleteProcess] StorageNotify fromCompleteProcess
         */

        /**
         * Constructs a new StorageNotify.
         * @memberof Q2Game
         * @classdesc Represents a StorageNotify.
         * @implements IStorageNotify
         * @constructor
         * @param {Q2Game.IStorageNotify=} [properties] Properties to set
         */
        function StorageNotify(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * StorageNotify seatId.
         * @member {number} seatId
         * @memberof Q2Game.StorageNotify
         * @instance
         */
        StorageNotify.prototype.seatId = 0;

        /**
         * StorageNotify pattern.
         * @member {Q2Game.ICardPattern|null|undefined} pattern
         * @memberof Q2Game.StorageNotify
         * @instance
         */
        StorageNotify.prototype.pattern = null;

        /**
         * StorageNotify fromCompleteProcess.
         * @member {boolean} fromCompleteProcess
         * @memberof Q2Game.StorageNotify
         * @instance
         */
        StorageNotify.prototype.fromCompleteProcess = false;

        /**
         * Creates a new StorageNotify instance using the specified properties.
         * @function create
         * @memberof Q2Game.StorageNotify
         * @static
         * @param {Q2Game.IStorageNotify=} [properties] Properties to set
         * @returns {Q2Game.StorageNotify} StorageNotify instance
         */
        StorageNotify.create = function create(properties) {
            return new StorageNotify(properties);
        };

        /**
         * Encodes the specified StorageNotify message. Does not implicitly {@link Q2Game.StorageNotify.verify|verify} messages.
         * @function encode
         * @memberof Q2Game.StorageNotify
         * @static
         * @param {Q2Game.IStorageNotify} message StorageNotify message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        StorageNotify.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.seatId != null && message.hasOwnProperty("seatId"))
                writer.uint32(/* id 1, wireType 0 =*/8).int32(message.seatId);
            if (message.pattern != null && message.hasOwnProperty("pattern"))
                $root.Q2Game.CardPattern.encode(message.pattern, writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
            if (message.fromCompleteProcess != null && message.hasOwnProperty("fromCompleteProcess"))
                writer.uint32(/* id 4, wireType 0 =*/32).bool(message.fromCompleteProcess);
            return writer;
        };

        /**
         * Encodes the specified StorageNotify message, length delimited. Does not implicitly {@link Q2Game.StorageNotify.verify|verify} messages.
         * @function encodeDelimited
         * @memberof Q2Game.StorageNotify
         * @static
         * @param {Q2Game.IStorageNotify} message StorageNotify message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        StorageNotify.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a StorageNotify message from the specified reader or buffer.
         * @function decode
         * @memberof Q2Game.StorageNotify
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {Q2Game.StorageNotify} StorageNotify
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        StorageNotify.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.Q2Game.StorageNotify();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.seatId = reader.int32();
                    break;
                case 2:
                    message.pattern = $root.Q2Game.CardPattern.decode(reader, reader.uint32());
                    break;
                case 4:
                    message.fromCompleteProcess = reader.bool();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a StorageNotify message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof Q2Game.StorageNotify
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {Q2Game.StorageNotify} StorageNotify
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        StorageNotify.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a StorageNotify message.
         * @function verify
         * @memberof Q2Game.StorageNotify
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        StorageNotify.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.seatId != null && message.hasOwnProperty("seatId"))
                if (!$util.isInteger(message.seatId))
                    return "seatId: integer expected";
            if (message.pattern != null && message.hasOwnProperty("pattern")) {
                var error = $root.Q2Game.CardPattern.verify(message.pattern);
                if (error)
                    return "pattern." + error;
            }
            if (message.fromCompleteProcess != null && message.hasOwnProperty("fromCompleteProcess"))
                if (typeof message.fromCompleteProcess !== "boolean")
                    return "fromCompleteProcess: boolean expected";
            return null;
        };

        /**
         * Creates a StorageNotify message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof Q2Game.StorageNotify
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {Q2Game.StorageNotify} StorageNotify
         */
        StorageNotify.fromObject = function fromObject(object) {
            if (object instanceof $root.Q2Game.StorageNotify)
                return object;
            var message = new $root.Q2Game.StorageNotify();
            if (object.seatId != null)
                message.seatId = object.seatId | 0;
            if (object.pattern != null) {
                if (typeof object.pattern !== "object")
                    throw TypeError(".Q2Game.StorageNotify.pattern: object expected");
                message.pattern = $root.Q2Game.CardPattern.fromObject(object.pattern);
            }
            if (object.fromCompleteProcess != null)
                message.fromCompleteProcess = Boolean(object.fromCompleteProcess);
            return message;
        };

        /**
         * Creates a plain object from a StorageNotify message. Also converts values to other types if specified.
         * @function toObject
         * @memberof Q2Game.StorageNotify
         * @static
         * @param {Q2Game.StorageNotify} message StorageNotify
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        StorageNotify.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                object.seatId = 0;
                object.pattern = null;
                object.fromCompleteProcess = false;
            }
            if (message.seatId != null && message.hasOwnProperty("seatId"))
                object.seatId = message.seatId;
            if (message.pattern != null && message.hasOwnProperty("pattern"))
                object.pattern = $root.Q2Game.CardPattern.toObject(message.pattern, options);
            if (message.fromCompleteProcess != null && message.hasOwnProperty("fromCompleteProcess"))
                object.fromCompleteProcess = message.fromCompleteProcess;
            return object;
        };

        /**
         * Converts this StorageNotify to JSON.
         * @function toJSON
         * @memberof Q2Game.StorageNotify
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        StorageNotify.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return StorageNotify;
    })();

    Q2Game.CompleteReq = (function() {

        /**
         * Properties of a CompleteReq.
         * @memberof Q2Game
         * @interface ICompleteReq
         * @property {boolean|null} [isReq] CompleteReq isReq
         */

        /**
         * Constructs a new CompleteReq.
         * @memberof Q2Game
         * @classdesc Represents a CompleteReq.
         * @implements ICompleteReq
         * @constructor
         * @param {Q2Game.ICompleteReq=} [properties] Properties to set
         */
        function CompleteReq(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * CompleteReq isReq.
         * @member {boolean} isReq
         * @memberof Q2Game.CompleteReq
         * @instance
         */
        CompleteReq.prototype.isReq = false;

        /**
         * Creates a new CompleteReq instance using the specified properties.
         * @function create
         * @memberof Q2Game.CompleteReq
         * @static
         * @param {Q2Game.ICompleteReq=} [properties] Properties to set
         * @returns {Q2Game.CompleteReq} CompleteReq instance
         */
        CompleteReq.create = function create(properties) {
            return new CompleteReq(properties);
        };

        /**
         * Encodes the specified CompleteReq message. Does not implicitly {@link Q2Game.CompleteReq.verify|verify} messages.
         * @function encode
         * @memberof Q2Game.CompleteReq
         * @static
         * @param {Q2Game.ICompleteReq} message CompleteReq message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        CompleteReq.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.isReq != null && message.hasOwnProperty("isReq"))
                writer.uint32(/* id 1, wireType 0 =*/8).bool(message.isReq);
            return writer;
        };

        /**
         * Encodes the specified CompleteReq message, length delimited. Does not implicitly {@link Q2Game.CompleteReq.verify|verify} messages.
         * @function encodeDelimited
         * @memberof Q2Game.CompleteReq
         * @static
         * @param {Q2Game.ICompleteReq} message CompleteReq message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        CompleteReq.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a CompleteReq message from the specified reader or buffer.
         * @function decode
         * @memberof Q2Game.CompleteReq
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {Q2Game.CompleteReq} CompleteReq
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        CompleteReq.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.Q2Game.CompleteReq();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.isReq = reader.bool();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a CompleteReq message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof Q2Game.CompleteReq
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {Q2Game.CompleteReq} CompleteReq
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        CompleteReq.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a CompleteReq message.
         * @function verify
         * @memberof Q2Game.CompleteReq
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        CompleteReq.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.isReq != null && message.hasOwnProperty("isReq"))
                if (typeof message.isReq !== "boolean")
                    return "isReq: boolean expected";
            return null;
        };

        /**
         * Creates a CompleteReq message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof Q2Game.CompleteReq
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {Q2Game.CompleteReq} CompleteReq
         */
        CompleteReq.fromObject = function fromObject(object) {
            if (object instanceof $root.Q2Game.CompleteReq)
                return object;
            var message = new $root.Q2Game.CompleteReq();
            if (object.isReq != null)
                message.isReq = Boolean(object.isReq);
            return message;
        };

        /**
         * Creates a plain object from a CompleteReq message. Also converts values to other types if specified.
         * @function toObject
         * @memberof Q2Game.CompleteReq
         * @static
         * @param {Q2Game.CompleteReq} message CompleteReq
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        CompleteReq.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults)
                object.isReq = false;
            if (message.isReq != null && message.hasOwnProperty("isReq"))
                object.isReq = message.isReq;
            return object;
        };

        /**
         * Converts this CompleteReq to JSON.
         * @function toJSON
         * @memberof Q2Game.CompleteReq
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        CompleteReq.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return CompleteReq;
    })();

    Q2Game.CompleteRsp = (function() {

        /**
         * Properties of a CompleteRsp.
         * @memberof Q2Game
         * @interface ICompleteRsp
         * @property {number|null} [errNo] CompleteRsp errNo
         */

        /**
         * Constructs a new CompleteRsp.
         * @memberof Q2Game
         * @classdesc Represents a CompleteRsp.
         * @implements ICompleteRsp
         * @constructor
         * @param {Q2Game.ICompleteRsp=} [properties] Properties to set
         */
        function CompleteRsp(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * CompleteRsp errNo.
         * @member {number} errNo
         * @memberof Q2Game.CompleteRsp
         * @instance
         */
        CompleteRsp.prototype.errNo = 0;

        /**
         * Creates a new CompleteRsp instance using the specified properties.
         * @function create
         * @memberof Q2Game.CompleteRsp
         * @static
         * @param {Q2Game.ICompleteRsp=} [properties] Properties to set
         * @returns {Q2Game.CompleteRsp} CompleteRsp instance
         */
        CompleteRsp.create = function create(properties) {
            return new CompleteRsp(properties);
        };

        /**
         * Encodes the specified CompleteRsp message. Does not implicitly {@link Q2Game.CompleteRsp.verify|verify} messages.
         * @function encode
         * @memberof Q2Game.CompleteRsp
         * @static
         * @param {Q2Game.ICompleteRsp} message CompleteRsp message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        CompleteRsp.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.errNo != null && message.hasOwnProperty("errNo"))
                writer.uint32(/* id 1, wireType 0 =*/8).int32(message.errNo);
            return writer;
        };

        /**
         * Encodes the specified CompleteRsp message, length delimited. Does not implicitly {@link Q2Game.CompleteRsp.verify|verify} messages.
         * @function encodeDelimited
         * @memberof Q2Game.CompleteRsp
         * @static
         * @param {Q2Game.ICompleteRsp} message CompleteRsp message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        CompleteRsp.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a CompleteRsp message from the specified reader or buffer.
         * @function decode
         * @memberof Q2Game.CompleteRsp
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {Q2Game.CompleteRsp} CompleteRsp
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        CompleteRsp.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.Q2Game.CompleteRsp();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.errNo = reader.int32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a CompleteRsp message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof Q2Game.CompleteRsp
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {Q2Game.CompleteRsp} CompleteRsp
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        CompleteRsp.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a CompleteRsp message.
         * @function verify
         * @memberof Q2Game.CompleteRsp
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        CompleteRsp.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.errNo != null && message.hasOwnProperty("errNo"))
                if (!$util.isInteger(message.errNo))
                    return "errNo: integer expected";
            return null;
        };

        /**
         * Creates a CompleteRsp message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof Q2Game.CompleteRsp
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {Q2Game.CompleteRsp} CompleteRsp
         */
        CompleteRsp.fromObject = function fromObject(object) {
            if (object instanceof $root.Q2Game.CompleteRsp)
                return object;
            var message = new $root.Q2Game.CompleteRsp();
            if (object.errNo != null)
                message.errNo = object.errNo | 0;
            return message;
        };

        /**
         * Creates a plain object from a CompleteRsp message. Also converts values to other types if specified.
         * @function toObject
         * @memberof Q2Game.CompleteRsp
         * @static
         * @param {Q2Game.CompleteRsp} message CompleteRsp
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        CompleteRsp.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults)
                object.errNo = 0;
            if (message.errNo != null && message.hasOwnProperty("errNo"))
                object.errNo = message.errNo;
            return object;
        };

        /**
         * Converts this CompleteRsp to JSON.
         * @function toJSON
         * @memberof Q2Game.CompleteRsp
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        CompleteRsp.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return CompleteRsp;
    })();

    Q2Game.GameSettle = (function() {

        /**
         * Properties of a GameSettle.
         * @memberof Q2Game
         * @interface IGameSettle
         * @property {Array.<Q2Game.GameSettle.ISeatInfo>|null} [seatList] GameSettle seatList
         * @property {number|null} [completeSeatId] GameSettle completeSeatId
         * @property {number|null} [baseCoin] GameSettle baseCoin
         */

        /**
         * Constructs a new GameSettle.
         * @memberof Q2Game
         * @classdesc Represents a GameSettle.
         * @implements IGameSettle
         * @constructor
         * @param {Q2Game.IGameSettle=} [properties] Properties to set
         */
        function GameSettle(properties) {
            this.seatList = [];
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * GameSettle seatList.
         * @member {Array.<Q2Game.GameSettle.ISeatInfo>} seatList
         * @memberof Q2Game.GameSettle
         * @instance
         */
        GameSettle.prototype.seatList = $util.emptyArray;

        /**
         * GameSettle completeSeatId.
         * @member {number} completeSeatId
         * @memberof Q2Game.GameSettle
         * @instance
         */
        GameSettle.prototype.completeSeatId = 0;

        /**
         * GameSettle baseCoin.
         * @member {number} baseCoin
         * @memberof Q2Game.GameSettle
         * @instance
         */
        GameSettle.prototype.baseCoin = 0;

        /**
         * Creates a new GameSettle instance using the specified properties.
         * @function create
         * @memberof Q2Game.GameSettle
         * @static
         * @param {Q2Game.IGameSettle=} [properties] Properties to set
         * @returns {Q2Game.GameSettle} GameSettle instance
         */
        GameSettle.create = function create(properties) {
            return new GameSettle(properties);
        };

        /**
         * Encodes the specified GameSettle message. Does not implicitly {@link Q2Game.GameSettle.verify|verify} messages.
         * @function encode
         * @memberof Q2Game.GameSettle
         * @static
         * @param {Q2Game.IGameSettle} message GameSettle message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        GameSettle.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.seatList != null && message.seatList.length)
                for (var i = 0; i < message.seatList.length; ++i)
                    $root.Q2Game.GameSettle.SeatInfo.encode(message.seatList[i], writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
            if (message.baseCoin != null && message.hasOwnProperty("baseCoin"))
                writer.uint32(/* id 3, wireType 0 =*/24).int32(message.baseCoin);
            if (message.completeSeatId != null && message.hasOwnProperty("completeSeatId"))
                writer.uint32(/* id 4, wireType 0 =*/32).int32(message.completeSeatId);
            return writer;
        };

        /**
         * Encodes the specified GameSettle message, length delimited. Does not implicitly {@link Q2Game.GameSettle.verify|verify} messages.
         * @function encodeDelimited
         * @memberof Q2Game.GameSettle
         * @static
         * @param {Q2Game.IGameSettle} message GameSettle message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        GameSettle.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a GameSettle message from the specified reader or buffer.
         * @function decode
         * @memberof Q2Game.GameSettle
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {Q2Game.GameSettle} GameSettle
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        GameSettle.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.Q2Game.GameSettle();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 2:
                    if (!(message.seatList && message.seatList.length))
                        message.seatList = [];
                    message.seatList.push($root.Q2Game.GameSettle.SeatInfo.decode(reader, reader.uint32()));
                    break;
                case 4:
                    message.completeSeatId = reader.int32();
                    break;
                case 3:
                    message.baseCoin = reader.int32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a GameSettle message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof Q2Game.GameSettle
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {Q2Game.GameSettle} GameSettle
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        GameSettle.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a GameSettle message.
         * @function verify
         * @memberof Q2Game.GameSettle
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        GameSettle.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.seatList != null && message.hasOwnProperty("seatList")) {
                if (!Array.isArray(message.seatList))
                    return "seatList: array expected";
                for (var i = 0; i < message.seatList.length; ++i) {
                    var error = $root.Q2Game.GameSettle.SeatInfo.verify(message.seatList[i]);
                    if (error)
                        return "seatList." + error;
                }
            }
            if (message.completeSeatId != null && message.hasOwnProperty("completeSeatId"))
                if (!$util.isInteger(message.completeSeatId))
                    return "completeSeatId: integer expected";
            if (message.baseCoin != null && message.hasOwnProperty("baseCoin"))
                if (!$util.isInteger(message.baseCoin))
                    return "baseCoin: integer expected";
            return null;
        };

        /**
         * Creates a GameSettle message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof Q2Game.GameSettle
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {Q2Game.GameSettle} GameSettle
         */
        GameSettle.fromObject = function fromObject(object) {
            if (object instanceof $root.Q2Game.GameSettle)
                return object;
            var message = new $root.Q2Game.GameSettle();
            if (object.seatList) {
                if (!Array.isArray(object.seatList))
                    throw TypeError(".Q2Game.GameSettle.seatList: array expected");
                message.seatList = [];
                for (var i = 0; i < object.seatList.length; ++i) {
                    if (typeof object.seatList[i] !== "object")
                        throw TypeError(".Q2Game.GameSettle.seatList: object expected");
                    message.seatList[i] = $root.Q2Game.GameSettle.SeatInfo.fromObject(object.seatList[i]);
                }
            }
            if (object.completeSeatId != null)
                message.completeSeatId = object.completeSeatId | 0;
            if (object.baseCoin != null)
                message.baseCoin = object.baseCoin | 0;
            return message;
        };

        /**
         * Creates a plain object from a GameSettle message. Also converts values to other types if specified.
         * @function toObject
         * @memberof Q2Game.GameSettle
         * @static
         * @param {Q2Game.GameSettle} message GameSettle
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        GameSettle.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.arrays || options.defaults)
                object.seatList = [];
            if (options.defaults) {
                object.baseCoin = 0;
                object.completeSeatId = 0;
            }
            if (message.seatList && message.seatList.length) {
                object.seatList = [];
                for (var j = 0; j < message.seatList.length; ++j)
                    object.seatList[j] = $root.Q2Game.GameSettle.SeatInfo.toObject(message.seatList[j], options);
            }
            if (message.baseCoin != null && message.hasOwnProperty("baseCoin"))
                object.baseCoin = message.baseCoin;
            if (message.completeSeatId != null && message.hasOwnProperty("completeSeatId"))
                object.completeSeatId = message.completeSeatId;
            return object;
        };

        /**
         * Converts this GameSettle to JSON.
         * @function toJSON
         * @memberof Q2Game.GameSettle
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        GameSettle.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        GameSettle.SeatInfo = (function() {

            /**
             * Properties of a SeatInfo.
             * @memberof Q2Game.GameSettle
             * @interface ISeatInfo
             * @property {number|null} [seatId] SeatInfo seatId
             * @property {number|null} [playerId] SeatInfo playerId
             * @property {number|null} [balance] SeatInfo balance
             * @property {number|null} [coinBalance] SeatInfo coinBalance
             * @property {number|null} [scoreBalance] SeatInfo scoreBalance
             * @property {number|null} [positiveCardsScore] SeatInfo positiveCardsScore
             * @property {number|null} [negativeCardsScore] SeatInfo negativeCardsScore
             * @property {number|null} [specialItemsScore] SeatInfo specialItemsScore
             * @property {Array.<number>|null} [positiveCards] SeatInfo positiveCards
             * @property {Array.<number>|null} [negativeCards] SeatInfo negativeCards
             * @property {Array.<Q2Game.IScore>|null} [specialItems] SeatInfo specialItems
             */

            /**
             * Constructs a new SeatInfo.
             * @memberof Q2Game.GameSettle
             * @classdesc Represents a SeatInfo.
             * @implements ISeatInfo
             * @constructor
             * @param {Q2Game.GameSettle.ISeatInfo=} [properties] Properties to set
             */
            function SeatInfo(properties) {
                this.positiveCards = [];
                this.negativeCards = [];
                this.specialItems = [];
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * SeatInfo seatId.
             * @member {number} seatId
             * @memberof Q2Game.GameSettle.SeatInfo
             * @instance
             */
            SeatInfo.prototype.seatId = 0;

            /**
             * SeatInfo playerId.
             * @member {number} playerId
             * @memberof Q2Game.GameSettle.SeatInfo
             * @instance
             */
            SeatInfo.prototype.playerId = 0;

            /**
             * SeatInfo balance.
             * @member {number} balance
             * @memberof Q2Game.GameSettle.SeatInfo
             * @instance
             */
            SeatInfo.prototype.balance = 0;

            /**
             * SeatInfo coinBalance.
             * @member {number} coinBalance
             * @memberof Q2Game.GameSettle.SeatInfo
             * @instance
             */
            SeatInfo.prototype.coinBalance = 0;

            /**
             * SeatInfo scoreBalance.
             * @member {number} scoreBalance
             * @memberof Q2Game.GameSettle.SeatInfo
             * @instance
             */
            SeatInfo.prototype.scoreBalance = 0;

            /**
             * SeatInfo positiveCardsScore.
             * @member {number} positiveCardsScore
             * @memberof Q2Game.GameSettle.SeatInfo
             * @instance
             */
            SeatInfo.prototype.positiveCardsScore = 0;

            /**
             * SeatInfo negativeCardsScore.
             * @member {number} negativeCardsScore
             * @memberof Q2Game.GameSettle.SeatInfo
             * @instance
             */
            SeatInfo.prototype.negativeCardsScore = 0;

            /**
             * SeatInfo specialItemsScore.
             * @member {number} specialItemsScore
             * @memberof Q2Game.GameSettle.SeatInfo
             * @instance
             */
            SeatInfo.prototype.specialItemsScore = 0;

            /**
             * SeatInfo positiveCards.
             * @member {Array.<number>} positiveCards
             * @memberof Q2Game.GameSettle.SeatInfo
             * @instance
             */
            SeatInfo.prototype.positiveCards = $util.emptyArray;

            /**
             * SeatInfo negativeCards.
             * @member {Array.<number>} negativeCards
             * @memberof Q2Game.GameSettle.SeatInfo
             * @instance
             */
            SeatInfo.prototype.negativeCards = $util.emptyArray;

            /**
             * SeatInfo specialItems.
             * @member {Array.<Q2Game.IScore>} specialItems
             * @memberof Q2Game.GameSettle.SeatInfo
             * @instance
             */
            SeatInfo.prototype.specialItems = $util.emptyArray;

            /**
             * Creates a new SeatInfo instance using the specified properties.
             * @function create
             * @memberof Q2Game.GameSettle.SeatInfo
             * @static
             * @param {Q2Game.GameSettle.ISeatInfo=} [properties] Properties to set
             * @returns {Q2Game.GameSettle.SeatInfo} SeatInfo instance
             */
            SeatInfo.create = function create(properties) {
                return new SeatInfo(properties);
            };

            /**
             * Encodes the specified SeatInfo message. Does not implicitly {@link Q2Game.GameSettle.SeatInfo.verify|verify} messages.
             * @function encode
             * @memberof Q2Game.GameSettle.SeatInfo
             * @static
             * @param {Q2Game.GameSettle.ISeatInfo} message SeatInfo message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            SeatInfo.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.seatId != null && message.hasOwnProperty("seatId"))
                    writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.seatId);
                if (message.playerId != null && message.hasOwnProperty("playerId"))
                    writer.uint32(/* id 3, wireType 0 =*/24).int32(message.playerId);
                if (message.balance != null && message.hasOwnProperty("balance"))
                    writer.uint32(/* id 4, wireType 1 =*/33).double(message.balance);
                if (message.negativeCards != null && message.negativeCards.length)
                    for (var i = 0; i < message.negativeCards.length; ++i)
                        writer.uint32(/* id 5, wireType 0 =*/40).int32(message.negativeCards[i]);
                if (message.specialItems != null && message.specialItems.length)
                    for (var i = 0; i < message.specialItems.length; ++i)
                        $root.Q2Game.Score.encode(message.specialItems[i], writer.uint32(/* id 6, wireType 2 =*/50).fork()).ldelim();
                if (message.coinBalance != null && message.hasOwnProperty("coinBalance"))
                    writer.uint32(/* id 7, wireType 1 =*/57).double(message.coinBalance);
                if (message.scoreBalance != null && message.hasOwnProperty("scoreBalance"))
                    writer.uint32(/* id 8, wireType 0 =*/64).int32(message.scoreBalance);
                if (message.positiveCards != null && message.positiveCards.length)
                    for (var i = 0; i < message.positiveCards.length; ++i)
                        writer.uint32(/* id 9, wireType 0 =*/72).int32(message.positiveCards[i]);
                if (message.positiveCardsScore != null && message.hasOwnProperty("positiveCardsScore"))
                    writer.uint32(/* id 11, wireType 0 =*/88).int32(message.positiveCardsScore);
                if (message.negativeCardsScore != null && message.hasOwnProperty("negativeCardsScore"))
                    writer.uint32(/* id 12, wireType 0 =*/96).int32(message.negativeCardsScore);
                if (message.specialItemsScore != null && message.hasOwnProperty("specialItemsScore"))
                    writer.uint32(/* id 13, wireType 0 =*/104).int32(message.specialItemsScore);
                return writer;
            };

            /**
             * Encodes the specified SeatInfo message, length delimited. Does not implicitly {@link Q2Game.GameSettle.SeatInfo.verify|verify} messages.
             * @function encodeDelimited
             * @memberof Q2Game.GameSettle.SeatInfo
             * @static
             * @param {Q2Game.GameSettle.ISeatInfo} message SeatInfo message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            SeatInfo.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a SeatInfo message from the specified reader or buffer.
             * @function decode
             * @memberof Q2Game.GameSettle.SeatInfo
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {Q2Game.GameSettle.SeatInfo} SeatInfo
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            SeatInfo.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.Q2Game.GameSettle.SeatInfo();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1:
                        message.seatId = reader.uint32();
                        break;
                    case 3:
                        message.playerId = reader.int32();
                        break;
                    case 4:
                        message.balance = reader.double();
                        break;
                    case 7:
                        message.coinBalance = reader.double();
                        break;
                    case 8:
                        message.scoreBalance = reader.int32();
                        break;
                    case 11:
                        message.positiveCardsScore = reader.int32();
                        break;
                    case 12:
                        message.negativeCardsScore = reader.int32();
                        break;
                    case 13:
                        message.specialItemsScore = reader.int32();
                        break;
                    case 9:
                        if (!(message.positiveCards && message.positiveCards.length))
                            message.positiveCards = [];
                        if ((tag & 7) === 2) {
                            var end2 = reader.uint32() + reader.pos;
                            while (reader.pos < end2)
                                message.positiveCards.push(reader.int32());
                        } else
                            message.positiveCards.push(reader.int32());
                        break;
                    case 5:
                        if (!(message.negativeCards && message.negativeCards.length))
                            message.negativeCards = [];
                        if ((tag & 7) === 2) {
                            var end2 = reader.uint32() + reader.pos;
                            while (reader.pos < end2)
                                message.negativeCards.push(reader.int32());
                        } else
                            message.negativeCards.push(reader.int32());
                        break;
                    case 6:
                        if (!(message.specialItems && message.specialItems.length))
                            message.specialItems = [];
                        message.specialItems.push($root.Q2Game.Score.decode(reader, reader.uint32()));
                        break;
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a SeatInfo message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof Q2Game.GameSettle.SeatInfo
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {Q2Game.GameSettle.SeatInfo} SeatInfo
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            SeatInfo.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a SeatInfo message.
             * @function verify
             * @memberof Q2Game.GameSettle.SeatInfo
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            SeatInfo.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.seatId != null && message.hasOwnProperty("seatId"))
                    if (!$util.isInteger(message.seatId))
                        return "seatId: integer expected";
                if (message.playerId != null && message.hasOwnProperty("playerId"))
                    if (!$util.isInteger(message.playerId))
                        return "playerId: integer expected";
                if (message.balance != null && message.hasOwnProperty("balance"))
                    if (typeof message.balance !== "number")
                        return "balance: number expected";
                if (message.coinBalance != null && message.hasOwnProperty("coinBalance"))
                    if (typeof message.coinBalance !== "number")
                        return "coinBalance: number expected";
                if (message.scoreBalance != null && message.hasOwnProperty("scoreBalance"))
                    if (!$util.isInteger(message.scoreBalance))
                        return "scoreBalance: integer expected";
                if (message.positiveCardsScore != null && message.hasOwnProperty("positiveCardsScore"))
                    if (!$util.isInteger(message.positiveCardsScore))
                        return "positiveCardsScore: integer expected";
                if (message.negativeCardsScore != null && message.hasOwnProperty("negativeCardsScore"))
                    if (!$util.isInteger(message.negativeCardsScore))
                        return "negativeCardsScore: integer expected";
                if (message.specialItemsScore != null && message.hasOwnProperty("specialItemsScore"))
                    if (!$util.isInteger(message.specialItemsScore))
                        return "specialItemsScore: integer expected";
                if (message.positiveCards != null && message.hasOwnProperty("positiveCards")) {
                    if (!Array.isArray(message.positiveCards))
                        return "positiveCards: array expected";
                    for (var i = 0; i < message.positiveCards.length; ++i)
                        if (!$util.isInteger(message.positiveCards[i]))
                            return "positiveCards: integer[] expected";
                }
                if (message.negativeCards != null && message.hasOwnProperty("negativeCards")) {
                    if (!Array.isArray(message.negativeCards))
                        return "negativeCards: array expected";
                    for (var i = 0; i < message.negativeCards.length; ++i)
                        if (!$util.isInteger(message.negativeCards[i]))
                            return "negativeCards: integer[] expected";
                }
                if (message.specialItems != null && message.hasOwnProperty("specialItems")) {
                    if (!Array.isArray(message.specialItems))
                        return "specialItems: array expected";
                    for (var i = 0; i < message.specialItems.length; ++i) {
                        var error = $root.Q2Game.Score.verify(message.specialItems[i]);
                        if (error)
                            return "specialItems." + error;
                    }
                }
                return null;
            };

            /**
             * Creates a SeatInfo message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof Q2Game.GameSettle.SeatInfo
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {Q2Game.GameSettle.SeatInfo} SeatInfo
             */
            SeatInfo.fromObject = function fromObject(object) {
                if (object instanceof $root.Q2Game.GameSettle.SeatInfo)
                    return object;
                var message = new $root.Q2Game.GameSettle.SeatInfo();
                if (object.seatId != null)
                    message.seatId = object.seatId >>> 0;
                if (object.playerId != null)
                    message.playerId = object.playerId | 0;
                if (object.balance != null)
                    message.balance = Number(object.balance);
                if (object.coinBalance != null)
                    message.coinBalance = Number(object.coinBalance);
                if (object.scoreBalance != null)
                    message.scoreBalance = object.scoreBalance | 0;
                if (object.positiveCardsScore != null)
                    message.positiveCardsScore = object.positiveCardsScore | 0;
                if (object.negativeCardsScore != null)
                    message.negativeCardsScore = object.negativeCardsScore | 0;
                if (object.specialItemsScore != null)
                    message.specialItemsScore = object.specialItemsScore | 0;
                if (object.positiveCards) {
                    if (!Array.isArray(object.positiveCards))
                        throw TypeError(".Q2Game.GameSettle.SeatInfo.positiveCards: array expected");
                    message.positiveCards = [];
                    for (var i = 0; i < object.positiveCards.length; ++i)
                        message.positiveCards[i] = object.positiveCards[i] | 0;
                }
                if (object.negativeCards) {
                    if (!Array.isArray(object.negativeCards))
                        throw TypeError(".Q2Game.GameSettle.SeatInfo.negativeCards: array expected");
                    message.negativeCards = [];
                    for (var i = 0; i < object.negativeCards.length; ++i)
                        message.negativeCards[i] = object.negativeCards[i] | 0;
                }
                if (object.specialItems) {
                    if (!Array.isArray(object.specialItems))
                        throw TypeError(".Q2Game.GameSettle.SeatInfo.specialItems: array expected");
                    message.specialItems = [];
                    for (var i = 0; i < object.specialItems.length; ++i) {
                        if (typeof object.specialItems[i] !== "object")
                            throw TypeError(".Q2Game.GameSettle.SeatInfo.specialItems: object expected");
                        message.specialItems[i] = $root.Q2Game.Score.fromObject(object.specialItems[i]);
                    }
                }
                return message;
            };

            /**
             * Creates a plain object from a SeatInfo message. Also converts values to other types if specified.
             * @function toObject
             * @memberof Q2Game.GameSettle.SeatInfo
             * @static
             * @param {Q2Game.GameSettle.SeatInfo} message SeatInfo
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            SeatInfo.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                var object = {};
                if (options.arrays || options.defaults) {
                    object.negativeCards = [];
                    object.specialItems = [];
                    object.positiveCards = [];
                }
                if (options.defaults) {
                    object.seatId = 0;
                    object.playerId = 0;
                    object.balance = 0;
                    object.coinBalance = 0;
                    object.scoreBalance = 0;
                    object.positiveCardsScore = 0;
                    object.negativeCardsScore = 0;
                    object.specialItemsScore = 0;
                }
                if (message.seatId != null && message.hasOwnProperty("seatId"))
                    object.seatId = message.seatId;
                if (message.playerId != null && message.hasOwnProperty("playerId"))
                    object.playerId = message.playerId;
                if (message.balance != null && message.hasOwnProperty("balance"))
                    object.balance = options.json && !isFinite(message.balance) ? String(message.balance) : message.balance;
                if (message.negativeCards && message.negativeCards.length) {
                    object.negativeCards = [];
                    for (var j = 0; j < message.negativeCards.length; ++j)
                        object.negativeCards[j] = message.negativeCards[j];
                }
                if (message.specialItems && message.specialItems.length) {
                    object.specialItems = [];
                    for (var j = 0; j < message.specialItems.length; ++j)
                        object.specialItems[j] = $root.Q2Game.Score.toObject(message.specialItems[j], options);
                }
                if (message.coinBalance != null && message.hasOwnProperty("coinBalance"))
                    object.coinBalance = options.json && !isFinite(message.coinBalance) ? String(message.coinBalance) : message.coinBalance;
                if (message.scoreBalance != null && message.hasOwnProperty("scoreBalance"))
                    object.scoreBalance = message.scoreBalance;
                if (message.positiveCards && message.positiveCards.length) {
                    object.positiveCards = [];
                    for (var j = 0; j < message.positiveCards.length; ++j)
                        object.positiveCards[j] = message.positiveCards[j];
                }
                if (message.positiveCardsScore != null && message.hasOwnProperty("positiveCardsScore"))
                    object.positiveCardsScore = message.positiveCardsScore;
                if (message.negativeCardsScore != null && message.hasOwnProperty("negativeCardsScore"))
                    object.negativeCardsScore = message.negativeCardsScore;
                if (message.specialItemsScore != null && message.hasOwnProperty("specialItemsScore"))
                    object.specialItemsScore = message.specialItemsScore;
                return object;
            };

            /**
             * Converts this SeatInfo to JSON.
             * @function toJSON
             * @memberof Q2Game.GameSettle.SeatInfo
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            SeatInfo.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            return SeatInfo;
        })();

        return GameSettle;
    })();

    Q2Game.CardsSequenceChangedReq = (function() {

        /**
         * Properties of a CardsSequenceChangedReq.
         * @memberof Q2Game
         * @interface ICardsSequenceChangedReq
         * @property {Array.<number>|null} [cards] CardsSequenceChangedReq cards
         */

        /**
         * Constructs a new CardsSequenceChangedReq.
         * @memberof Q2Game
         * @classdesc Represents a CardsSequenceChangedReq.
         * @implements ICardsSequenceChangedReq
         * @constructor
         * @param {Q2Game.ICardsSequenceChangedReq=} [properties] Properties to set
         */
        function CardsSequenceChangedReq(properties) {
            this.cards = [];
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * CardsSequenceChangedReq cards.
         * @member {Array.<number>} cards
         * @memberof Q2Game.CardsSequenceChangedReq
         * @instance
         */
        CardsSequenceChangedReq.prototype.cards = $util.emptyArray;

        /**
         * Creates a new CardsSequenceChangedReq instance using the specified properties.
         * @function create
         * @memberof Q2Game.CardsSequenceChangedReq
         * @static
         * @param {Q2Game.ICardsSequenceChangedReq=} [properties] Properties to set
         * @returns {Q2Game.CardsSequenceChangedReq} CardsSequenceChangedReq instance
         */
        CardsSequenceChangedReq.create = function create(properties) {
            return new CardsSequenceChangedReq(properties);
        };

        /**
         * Encodes the specified CardsSequenceChangedReq message. Does not implicitly {@link Q2Game.CardsSequenceChangedReq.verify|verify} messages.
         * @function encode
         * @memberof Q2Game.CardsSequenceChangedReq
         * @static
         * @param {Q2Game.ICardsSequenceChangedReq} message CardsSequenceChangedReq message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        CardsSequenceChangedReq.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.cards != null && message.cards.length)
                for (var i = 0; i < message.cards.length; ++i)
                    writer.uint32(/* id 1, wireType 0 =*/8).int32(message.cards[i]);
            return writer;
        };

        /**
         * Encodes the specified CardsSequenceChangedReq message, length delimited. Does not implicitly {@link Q2Game.CardsSequenceChangedReq.verify|verify} messages.
         * @function encodeDelimited
         * @memberof Q2Game.CardsSequenceChangedReq
         * @static
         * @param {Q2Game.ICardsSequenceChangedReq} message CardsSequenceChangedReq message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        CardsSequenceChangedReq.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a CardsSequenceChangedReq message from the specified reader or buffer.
         * @function decode
         * @memberof Q2Game.CardsSequenceChangedReq
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {Q2Game.CardsSequenceChangedReq} CardsSequenceChangedReq
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        CardsSequenceChangedReq.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.Q2Game.CardsSequenceChangedReq();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    if (!(message.cards && message.cards.length))
                        message.cards = [];
                    if ((tag & 7) === 2) {
                        var end2 = reader.uint32() + reader.pos;
                        while (reader.pos < end2)
                            message.cards.push(reader.int32());
                    } else
                        message.cards.push(reader.int32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a CardsSequenceChangedReq message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof Q2Game.CardsSequenceChangedReq
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {Q2Game.CardsSequenceChangedReq} CardsSequenceChangedReq
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        CardsSequenceChangedReq.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a CardsSequenceChangedReq message.
         * @function verify
         * @memberof Q2Game.CardsSequenceChangedReq
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        CardsSequenceChangedReq.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.cards != null && message.hasOwnProperty("cards")) {
                if (!Array.isArray(message.cards))
                    return "cards: array expected";
                for (var i = 0; i < message.cards.length; ++i)
                    if (!$util.isInteger(message.cards[i]))
                        return "cards: integer[] expected";
            }
            return null;
        };

        /**
         * Creates a CardsSequenceChangedReq message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof Q2Game.CardsSequenceChangedReq
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {Q2Game.CardsSequenceChangedReq} CardsSequenceChangedReq
         */
        CardsSequenceChangedReq.fromObject = function fromObject(object) {
            if (object instanceof $root.Q2Game.CardsSequenceChangedReq)
                return object;
            var message = new $root.Q2Game.CardsSequenceChangedReq();
            if (object.cards) {
                if (!Array.isArray(object.cards))
                    throw TypeError(".Q2Game.CardsSequenceChangedReq.cards: array expected");
                message.cards = [];
                for (var i = 0; i < object.cards.length; ++i)
                    message.cards[i] = object.cards[i] | 0;
            }
            return message;
        };

        /**
         * Creates a plain object from a CardsSequenceChangedReq message. Also converts values to other types if specified.
         * @function toObject
         * @memberof Q2Game.CardsSequenceChangedReq
         * @static
         * @param {Q2Game.CardsSequenceChangedReq} message CardsSequenceChangedReq
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        CardsSequenceChangedReq.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.arrays || options.defaults)
                object.cards = [];
            if (message.cards && message.cards.length) {
                object.cards = [];
                for (var j = 0; j < message.cards.length; ++j)
                    object.cards[j] = message.cards[j];
            }
            return object;
        };

        /**
         * Converts this CardsSequenceChangedReq to JSON.
         * @function toJSON
         * @memberof Q2Game.CardsSequenceChangedReq
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        CardsSequenceChangedReq.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return CardsSequenceChangedReq;
    })();

    Q2Game.TimeoutNotify = (function() {

        /**
         * Properties of a TimeoutNotify.
         * @memberof Q2Game
         * @interface ITimeoutNotify
         * @property {number|null} [timeout] TimeoutNotify timeout
         * @property {number|null} [event] TimeoutNotify event
         * @property {number|null} [ackId] TimeoutNotify ackId
         * @property {number|null} [seatId] TimeoutNotify seatId
         * @property {number|null} [totalTimeout] TimeoutNotify totalTimeout
         */

        /**
         * Constructs a new TimeoutNotify.
         * @memberof Q2Game
         * @classdesc Represents a TimeoutNotify.
         * @implements ITimeoutNotify
         * @constructor
         * @param {Q2Game.ITimeoutNotify=} [properties] Properties to set
         */
        function TimeoutNotify(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * TimeoutNotify timeout.
         * @member {number} timeout
         * @memberof Q2Game.TimeoutNotify
         * @instance
         */
        TimeoutNotify.prototype.timeout = 0;

        /**
         * TimeoutNotify event.
         * @member {number} event
         * @memberof Q2Game.TimeoutNotify
         * @instance
         */
        TimeoutNotify.prototype.event = 0;

        /**
         * TimeoutNotify ackId.
         * @member {number} ackId
         * @memberof Q2Game.TimeoutNotify
         * @instance
         */
        TimeoutNotify.prototype.ackId = 0;

        /**
         * TimeoutNotify seatId.
         * @member {number} seatId
         * @memberof Q2Game.TimeoutNotify
         * @instance
         */
        TimeoutNotify.prototype.seatId = 0;

        /**
         * TimeoutNotify totalTimeout.
         * @member {number} totalTimeout
         * @memberof Q2Game.TimeoutNotify
         * @instance
         */
        TimeoutNotify.prototype.totalTimeout = 0;

        /**
         * Creates a new TimeoutNotify instance using the specified properties.
         * @function create
         * @memberof Q2Game.TimeoutNotify
         * @static
         * @param {Q2Game.ITimeoutNotify=} [properties] Properties to set
         * @returns {Q2Game.TimeoutNotify} TimeoutNotify instance
         */
        TimeoutNotify.create = function create(properties) {
            return new TimeoutNotify(properties);
        };

        /**
         * Encodes the specified TimeoutNotify message. Does not implicitly {@link Q2Game.TimeoutNotify.verify|verify} messages.
         * @function encode
         * @memberof Q2Game.TimeoutNotify
         * @static
         * @param {Q2Game.ITimeoutNotify} message TimeoutNotify message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        TimeoutNotify.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.timeout != null && message.hasOwnProperty("timeout"))
                writer.uint32(/* id 1, wireType 0 =*/8).int32(message.timeout);
            if (message.event != null && message.hasOwnProperty("event"))
                writer.uint32(/* id 2, wireType 0 =*/16).int32(message.event);
            if (message.seatId != null && message.hasOwnProperty("seatId"))
                writer.uint32(/* id 3, wireType 0 =*/24).uint32(message.seatId);
            if (message.totalTimeout != null && message.hasOwnProperty("totalTimeout"))
                writer.uint32(/* id 5, wireType 0 =*/40).int32(message.totalTimeout);
            if (message.ackId != null && message.hasOwnProperty("ackId"))
                writer.uint32(/* id 6, wireType 0 =*/48).int32(message.ackId);
            return writer;
        };

        /**
         * Encodes the specified TimeoutNotify message, length delimited. Does not implicitly {@link Q2Game.TimeoutNotify.verify|verify} messages.
         * @function encodeDelimited
         * @memberof Q2Game.TimeoutNotify
         * @static
         * @param {Q2Game.ITimeoutNotify} message TimeoutNotify message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        TimeoutNotify.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a TimeoutNotify message from the specified reader or buffer.
         * @function decode
         * @memberof Q2Game.TimeoutNotify
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {Q2Game.TimeoutNotify} TimeoutNotify
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        TimeoutNotify.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.Q2Game.TimeoutNotify();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.timeout = reader.int32();
                    break;
                case 2:
                    message.event = reader.int32();
                    break;
                case 6:
                    message.ackId = reader.int32();
                    break;
                case 3:
                    message.seatId = reader.uint32();
                    break;
                case 5:
                    message.totalTimeout = reader.int32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a TimeoutNotify message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof Q2Game.TimeoutNotify
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {Q2Game.TimeoutNotify} TimeoutNotify
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        TimeoutNotify.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a TimeoutNotify message.
         * @function verify
         * @memberof Q2Game.TimeoutNotify
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        TimeoutNotify.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.timeout != null && message.hasOwnProperty("timeout"))
                if (!$util.isInteger(message.timeout))
                    return "timeout: integer expected";
            if (message.event != null && message.hasOwnProperty("event"))
                if (!$util.isInteger(message.event))
                    return "event: integer expected";
            if (message.ackId != null && message.hasOwnProperty("ackId"))
                if (!$util.isInteger(message.ackId))
                    return "ackId: integer expected";
            if (message.seatId != null && message.hasOwnProperty("seatId"))
                if (!$util.isInteger(message.seatId))
                    return "seatId: integer expected";
            if (message.totalTimeout != null && message.hasOwnProperty("totalTimeout"))
                if (!$util.isInteger(message.totalTimeout))
                    return "totalTimeout: integer expected";
            return null;
        };

        /**
         * Creates a TimeoutNotify message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof Q2Game.TimeoutNotify
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {Q2Game.TimeoutNotify} TimeoutNotify
         */
        TimeoutNotify.fromObject = function fromObject(object) {
            if (object instanceof $root.Q2Game.TimeoutNotify)
                return object;
            var message = new $root.Q2Game.TimeoutNotify();
            if (object.timeout != null)
                message.timeout = object.timeout | 0;
            if (object.event != null)
                message.event = object.event | 0;
            if (object.ackId != null)
                message.ackId = object.ackId | 0;
            if (object.seatId != null)
                message.seatId = object.seatId >>> 0;
            if (object.totalTimeout != null)
                message.totalTimeout = object.totalTimeout | 0;
            return message;
        };

        /**
         * Creates a plain object from a TimeoutNotify message. Also converts values to other types if specified.
         * @function toObject
         * @memberof Q2Game.TimeoutNotify
         * @static
         * @param {Q2Game.TimeoutNotify} message TimeoutNotify
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        TimeoutNotify.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                object.timeout = 0;
                object.event = 0;
                object.seatId = 0;
                object.totalTimeout = 0;
                object.ackId = 0;
            }
            if (message.timeout != null && message.hasOwnProperty("timeout"))
                object.timeout = message.timeout;
            if (message.event != null && message.hasOwnProperty("event"))
                object.event = message.event;
            if (message.seatId != null && message.hasOwnProperty("seatId"))
                object.seatId = message.seatId;
            if (message.totalTimeout != null && message.hasOwnProperty("totalTimeout"))
                object.totalTimeout = message.totalTimeout;
            if (message.ackId != null && message.hasOwnProperty("ackId"))
                object.ackId = message.ackId;
            return object;
        };

        /**
         * Converts this TimeoutNotify to JSON.
         * @function toJSON
         * @memberof Q2Game.TimeoutNotify
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        TimeoutNotify.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return TimeoutNotify;
    })();

    Q2Game.AckReq = (function() {

        /**
         * Properties of an AckReq.
         * @memberof Q2Game
         * @interface IAckReq
         * @property {number|null} [ackId] AckReq ackId
         */

        /**
         * Constructs a new AckReq.
         * @memberof Q2Game
         * @classdesc Represents an AckReq.
         * @implements IAckReq
         * @constructor
         * @param {Q2Game.IAckReq=} [properties] Properties to set
         */
        function AckReq(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * AckReq ackId.
         * @member {number} ackId
         * @memberof Q2Game.AckReq
         * @instance
         */
        AckReq.prototype.ackId = 0;

        /**
         * Creates a new AckReq instance using the specified properties.
         * @function create
         * @memberof Q2Game.AckReq
         * @static
         * @param {Q2Game.IAckReq=} [properties] Properties to set
         * @returns {Q2Game.AckReq} AckReq instance
         */
        AckReq.create = function create(properties) {
            return new AckReq(properties);
        };

        /**
         * Encodes the specified AckReq message. Does not implicitly {@link Q2Game.AckReq.verify|verify} messages.
         * @function encode
         * @memberof Q2Game.AckReq
         * @static
         * @param {Q2Game.IAckReq} message AckReq message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        AckReq.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.ackId != null && message.hasOwnProperty("ackId"))
                writer.uint32(/* id 1, wireType 0 =*/8).int32(message.ackId);
            return writer;
        };

        /**
         * Encodes the specified AckReq message, length delimited. Does not implicitly {@link Q2Game.AckReq.verify|verify} messages.
         * @function encodeDelimited
         * @memberof Q2Game.AckReq
         * @static
         * @param {Q2Game.IAckReq} message AckReq message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        AckReq.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes an AckReq message from the specified reader or buffer.
         * @function decode
         * @memberof Q2Game.AckReq
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {Q2Game.AckReq} AckReq
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        AckReq.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.Q2Game.AckReq();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.ackId = reader.int32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes an AckReq message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof Q2Game.AckReq
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {Q2Game.AckReq} AckReq
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        AckReq.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies an AckReq message.
         * @function verify
         * @memberof Q2Game.AckReq
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        AckReq.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.ackId != null && message.hasOwnProperty("ackId"))
                if (!$util.isInteger(message.ackId))
                    return "ackId: integer expected";
            return null;
        };

        /**
         * Creates an AckReq message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof Q2Game.AckReq
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {Q2Game.AckReq} AckReq
         */
        AckReq.fromObject = function fromObject(object) {
            if (object instanceof $root.Q2Game.AckReq)
                return object;
            var message = new $root.Q2Game.AckReq();
            if (object.ackId != null)
                message.ackId = object.ackId | 0;
            return message;
        };

        /**
         * Creates a plain object from an AckReq message. Also converts values to other types if specified.
         * @function toObject
         * @memberof Q2Game.AckReq
         * @static
         * @param {Q2Game.AckReq} message AckReq
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        AckReq.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults)
                object.ackId = 0;
            if (message.ackId != null && message.hasOwnProperty("ackId"))
                object.ackId = message.ackId;
            return object;
        };

        /**
         * Converts this AckReq to JSON.
         * @function toJSON
         * @memberof Q2Game.AckReq
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        AckReq.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return AckReq;
    })();

    Q2Game.CardReocrderNotify = (function() {

        /**
         * Properties of a CardReocrderNotify.
         * @memberof Q2Game
         * @interface ICardReocrderNotify
         * @property {Array.<number>|null} [cards] CardReocrderNotify cards
         */

        /**
         * Constructs a new CardReocrderNotify.
         * @memberof Q2Game
         * @classdesc Represents a CardReocrderNotify.
         * @implements ICardReocrderNotify
         * @constructor
         * @param {Q2Game.ICardReocrderNotify=} [properties] Properties to set
         */
        function CardReocrderNotify(properties) {
            this.cards = [];
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * CardReocrderNotify cards.
         * @member {Array.<number>} cards
         * @memberof Q2Game.CardReocrderNotify
         * @instance
         */
        CardReocrderNotify.prototype.cards = $util.emptyArray;

        /**
         * Creates a new CardReocrderNotify instance using the specified properties.
         * @function create
         * @memberof Q2Game.CardReocrderNotify
         * @static
         * @param {Q2Game.ICardReocrderNotify=} [properties] Properties to set
         * @returns {Q2Game.CardReocrderNotify} CardReocrderNotify instance
         */
        CardReocrderNotify.create = function create(properties) {
            return new CardReocrderNotify(properties);
        };

        /**
         * Encodes the specified CardReocrderNotify message. Does not implicitly {@link Q2Game.CardReocrderNotify.verify|verify} messages.
         * @function encode
         * @memberof Q2Game.CardReocrderNotify
         * @static
         * @param {Q2Game.ICardReocrderNotify} message CardReocrderNotify message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        CardReocrderNotify.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.cards != null && message.cards.length)
                for (var i = 0; i < message.cards.length; ++i)
                    writer.uint32(/* id 1, wireType 0 =*/8).int32(message.cards[i]);
            return writer;
        };

        /**
         * Encodes the specified CardReocrderNotify message, length delimited. Does not implicitly {@link Q2Game.CardReocrderNotify.verify|verify} messages.
         * @function encodeDelimited
         * @memberof Q2Game.CardReocrderNotify
         * @static
         * @param {Q2Game.ICardReocrderNotify} message CardReocrderNotify message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        CardReocrderNotify.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a CardReocrderNotify message from the specified reader or buffer.
         * @function decode
         * @memberof Q2Game.CardReocrderNotify
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {Q2Game.CardReocrderNotify} CardReocrderNotify
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        CardReocrderNotify.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.Q2Game.CardReocrderNotify();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    if (!(message.cards && message.cards.length))
                        message.cards = [];
                    if ((tag & 7) === 2) {
                        var end2 = reader.uint32() + reader.pos;
                        while (reader.pos < end2)
                            message.cards.push(reader.int32());
                    } else
                        message.cards.push(reader.int32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a CardReocrderNotify message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof Q2Game.CardReocrderNotify
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {Q2Game.CardReocrderNotify} CardReocrderNotify
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        CardReocrderNotify.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a CardReocrderNotify message.
         * @function verify
         * @memberof Q2Game.CardReocrderNotify
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        CardReocrderNotify.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.cards != null && message.hasOwnProperty("cards")) {
                if (!Array.isArray(message.cards))
                    return "cards: array expected";
                for (var i = 0; i < message.cards.length; ++i)
                    if (!$util.isInteger(message.cards[i]))
                        return "cards: integer[] expected";
            }
            return null;
        };

        /**
         * Creates a CardReocrderNotify message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof Q2Game.CardReocrderNotify
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {Q2Game.CardReocrderNotify} CardReocrderNotify
         */
        CardReocrderNotify.fromObject = function fromObject(object) {
            if (object instanceof $root.Q2Game.CardReocrderNotify)
                return object;
            var message = new $root.Q2Game.CardReocrderNotify();
            if (object.cards) {
                if (!Array.isArray(object.cards))
                    throw TypeError(".Q2Game.CardReocrderNotify.cards: array expected");
                message.cards = [];
                for (var i = 0; i < object.cards.length; ++i)
                    message.cards[i] = object.cards[i] | 0;
            }
            return message;
        };

        /**
         * Creates a plain object from a CardReocrderNotify message. Also converts values to other types if specified.
         * @function toObject
         * @memberof Q2Game.CardReocrderNotify
         * @static
         * @param {Q2Game.CardReocrderNotify} message CardReocrderNotify
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        CardReocrderNotify.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.arrays || options.defaults)
                object.cards = [];
            if (message.cards && message.cards.length) {
                object.cards = [];
                for (var j = 0; j < message.cards.length; ++j)
                    object.cards[j] = message.cards[j];
            }
            return object;
        };

        /**
         * Converts this CardReocrderNotify to JSON.
         * @function toJSON
         * @memberof Q2Game.CardReocrderNotify
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        CardReocrderNotify.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return CardReocrderNotify;
    })();

    return Q2Game;
})();

module.exports = $root;
